var Oo = Object.defineProperty;
var Do = (e, t, n) => t in e ? Oo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var It = (e, t, n) => Do(e, typeof t != "symbol" ? t + "" : t, n);
function $() {
}
function Kt(e, t) {
  for (const n in t) e[n] = t[n];
  return (
    /** @type {T & S} */
    e
  );
}
function no(e) {
  return e();
}
function ln() {
  return /* @__PURE__ */ Object.create(null);
}
function Me(e) {
  e.forEach(no);
}
function se(e) {
  return typeof e == "function";
}
function ae(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
function No(e) {
  return Object.keys(e).length === 0;
}
function oo(e, ...t) {
  if (e == null) {
    for (const o of t)
      o(void 0);
    return $;
  }
  const n = e.subscribe(...t);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
function Ot(e, t, n) {
  e.$$.on_destroy.push(oo(t, n));
}
function Ro(e, t, n, o) {
  if (e) {
    const s = so(e, t, n, o);
    return e[0](s);
  }
}
function so(e, t, n, o) {
  return e[1] && o ? Kt(n.ctx.slice(), e[1](o(t))) : n.ctx;
}
function Bo(e, t, n, o) {
  if (e[2] && o) {
    const s = e[2](o(n));
    if (t.dirty === void 0)
      return s;
    if (typeof s == "object") {
      const i = [], l = Math.max(t.dirty.length, s.length);
      for (let r = 0; r < l; r += 1)
        i[r] = t.dirty[r] | s[r];
      return i;
    }
    return t.dirty | s;
  }
  return t.dirty;
}
function Yo(e, t, n, o, s, i) {
  if (s) {
    const l = so(t, n, o, i);
    e.p(l, s);
  }
}
function Uo(e) {
  if (e.ctx.length > 32) {
    const t = [], n = e.ctx.length / 32;
    for (let o = 0; o < n; o++)
      t[o] = -1;
    return t;
  }
  return -1;
}
function an(e) {
  const t = {};
  for (const n in e) n[0] !== "$" && (t[n] = e[n]);
  return t;
}
function Ze(e) {
  return e ?? "";
}
function z(e, t) {
  e.appendChild(t);
}
function Y(e, t, n) {
  e.insertBefore(t, n || null);
}
function B(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function Ge(e, t) {
  for (let n = 0; n < e.length; n += 1)
    e[n] && e[n].d(t);
}
function C(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function io(e) {
  return document.createTextNode(e);
}
function we() {
  return io(" ");
}
function Se() {
  return io("");
}
function Q(e, t, n, o) {
  return e.addEventListener(t, n, o), () => e.removeEventListener(t, n, o);
}
function c(e, t, n) {
  n == null ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
function Vo(e) {
  return Array.from(e.childNodes);
}
function Pe(e, t, n) {
  e.classList.toggle(t, !!n);
}
function Xo(e, t, { bubbles: n = !1, cancelable: o = !1 } = {}) {
  return new CustomEvent(e, { detail: t, bubbles: n, cancelable: o });
}
let nt;
function tt(e) {
  nt = e;
}
function ro() {
  if (!nt) throw new Error("Function called outside component initialization");
  return nt;
}
function Ye(e) {
  ro().$$.on_mount.push(e);
}
function Ue() {
  const e = ro();
  return (t, n, { cancelable: o = !1 } = {}) => {
    const s = e.$$.callbacks[t];
    if (s) {
      const i = Xo(
        /** @type {string} */
        t,
        n,
        { cancelable: o }
      );
      return s.slice().forEach((l) => {
        l.call(e, i);
      }), !i.defaultPrevented;
    }
    return !0;
  };
}
function de(e, t) {
  const n = e.$$.callbacks[t.type];
  n && n.slice().forEach((o) => o.call(this, t));
}
const Ke = [], Et = [];
let Je = [];
const cn = [], lo = /* @__PURE__ */ Promise.resolve();
let Wt = !1;
function ao() {
  Wt || (Wt = !0, lo.then(fo));
}
function co() {
  return ao(), lo;
}
function Zt(e) {
  Je.push(e);
}
const Dt = /* @__PURE__ */ new Set();
let Fe = 0;
function fo() {
  if (Fe !== 0)
    return;
  const e = nt;
  do {
    try {
      for (; Fe < Ke.length; ) {
        const t = Ke[Fe];
        Fe++, tt(t), Ho(t.$$);
      }
    } catch (t) {
      throw Ke.length = 0, Fe = 0, t;
    }
    for (tt(null), Ke.length = 0, Fe = 0; Et.length; ) Et.pop()();
    for (let t = 0; t < Je.length; t += 1) {
      const n = Je[t];
      Dt.has(n) || (Dt.add(n), n());
    }
    Je.length = 0;
  } while (Ke.length);
  for (; cn.length; )
    cn.pop()();
  Wt = !1, Dt.clear(), tt(e);
}
function Ho(e) {
  if (e.fragment !== null) {
    e.update(), Me(e.before_update);
    const t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(Zt);
  }
}
function Go(e) {
  const t = [], n = [];
  Je.forEach((o) => e.indexOf(o) === -1 ? t.push(o) : n.push(o)), n.forEach((o) => o()), Je = t;
}
const pt = /* @__PURE__ */ new Set();
let He;
function be() {
  He = {
    r: 0,
    c: [],
    p: He
    // parent group
  };
}
function Ee() {
  He.r || Me(He.c), He = He.p;
}
function V(e, t) {
  e && e.i && (pt.delete(e), e.i(t));
}
function j(e, t, n, o) {
  if (e && e.o) {
    if (pt.has(e)) return;
    pt.add(e), He.c.push(() => {
      pt.delete(e), o && (n && e.d(1), o());
    }), e.o(t);
  } else o && o();
}
function ve(e) {
  return (e == null ? void 0 : e.length) !== void 0 ? e : Array.from(e);
}
function ce(e) {
  e && e.c();
}
function re(e, t, n) {
  const { fragment: o, after_update: s } = e.$$;
  o && o.m(t, n), Zt(() => {
    const i = e.$$.on_mount.map(no).filter(se);
    e.$$.on_destroy ? e.$$.on_destroy.push(...i) : Me(i), e.$$.on_mount = [];
  }), s.forEach(Zt);
}
function le(e, t) {
  const n = e.$$;
  n.fragment !== null && (Go(n.after_update), Me(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function jo(e, t) {
  e.$$.dirty[0] === -1 && (Ke.push(e), ao(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function _e(e, t, n, o, s, i, l = null, r = [-1]) {
  const a = nt;
  tt(e);
  const f = e.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: i,
    update: $,
    not_equal: s,
    bound: ln(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (a ? a.$$.context : [])),
    // everything else
    callbacks: ln(),
    dirty: r,
    skip_bound: !1,
    root: t.target || a.$$.root
  };
  l && l(f.root);
  let d = !1;
  if (f.ctx = n ? n(e, t.props || {}, (u, h, ...g) => {
    const m = g.length ? g[0] : h;
    return f.ctx && s(f.ctx[u], f.ctx[u] = m) && (!f.skip_bound && f.bound[u] && f.bound[u](m), d && jo(e, u)), h;
  }) : [], f.update(), d = !0, Me(f.before_update), f.fragment = o ? o(f.ctx) : !1, t.target) {
    if (t.hydrate) {
      const u = Vo(t.target);
      f.fragment && f.fragment.l(u), u.forEach(B);
    } else
      f.fragment && f.fragment.c();
    t.intro && V(e.$$.fragment), re(e, t.target, t.anchor), fo();
  }
  tt(a);
}
class ye {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    It(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    It(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    le(this, 1), this.$destroy = $;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(t, n) {
    if (!se(n))
      return $;
    const o = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return o.push(n), () => {
      const s = o.indexOf(n);
      s !== -1 && o.splice(s, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(t) {
    this.$$set && !No(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const Fo = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Fo);
var x = /* @__PURE__ */ ((e) => (e.ELLIPSE = "ELLIPSE", e.MULTIPOLYGON = "MULTIPOLYGON", e.POLYGON = "POLYGON", e.POLYLINE = "POLYLINE", e.RECTANGLE = "RECTANGLE", e.LINE = "LINE", e))(x || {});
function zo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var uo = { exports: {} };
(function(e) {
  (function() {
    function t(r, a) {
      var f = r.x - a.x, d = r.y - a.y;
      return f * f + d * d;
    }
    function n(r, a, f) {
      var d = a.x, u = a.y, h = f.x - d, g = f.y - u;
      if (h !== 0 || g !== 0) {
        var m = ((r.x - d) * h + (r.y - u) * g) / (h * h + g * g);
        m > 1 ? (d = f.x, u = f.y) : m > 0 && (d += h * m, u += g * m);
      }
      return h = r.x - d, g = r.y - u, h * h + g * g;
    }
    function o(r, a) {
      for (var f = r[0], d = [f], u, h = 1, g = r.length; h < g; h++)
        u = r[h], t(u, f) > a && (d.push(u), f = u);
      return f !== u && d.push(u), d;
    }
    function s(r, a, f, d, u) {
      for (var h = d, g, m = a + 1; m < f; m++) {
        var w = n(r[m], r[a], r[f]);
        w > h && (g = m, h = w);
      }
      h > d && (g - a > 1 && s(r, a, g, d, u), u.push(r[g]), f - g > 1 && s(r, g, f, d, u));
    }
    function i(r, a) {
      var f = r.length - 1, d = [r[0]];
      return s(r, 0, f, a, d), d.push(r[f]), d;
    }
    function l(r, a, f) {
      if (r.length <= 2) return r;
      var d = a !== void 0 ? a * a : 1;
      return r = f ? r : o(r, d), r = i(r, d), r;
    }
    e.exports = l, e.exports.default = l;
  })();
})(uo);
var qo = uo.exports;
const Ko = /* @__PURE__ */ zo(qo), en = {}, Qe = (e, t) => en[e] = t, Jt = (e) => en[e.type].area(e), Wo = (e, t, n, o) => en[e.type].intersects(e, t, n, o), ue = (e) => {
  let t = 1 / 0, n = 1 / 0, o = -1 / 0, s = -1 / 0;
  return e.forEach(([i, l]) => {
    t = Math.min(t, i), n = Math.min(n, l), o = Math.max(o, i), s = Math.max(s, l);
  }), { minX: t, minY: n, maxX: o, maxY: s };
}, vt = (e) => {
  let t = 0, n = e.length - 1;
  for (let o = 0; o < e.length; o++)
    t += (e[n][0] + e[o][0]) * (e[n][1] - e[o][1]), n = o;
  return Math.abs(0.5 * t);
}, At = (e, t, n) => {
  let o = !1;
  for (let s = 0, i = e.length - 1; s < e.length; i = s++) {
    const l = e[s][0], r = e[s][1], a = e[i][0], f = e[i][1];
    r > n != f > n && t < (a - l) * (n - r) / (f - r) + l && (o = !o);
  }
  return o;
}, ho = (e, t = !0) => {
  let n = "M ";
  return e.forEach(([o, s], i) => {
    i === 0 ? n += `${o},${s}` : n += ` L ${o},${s}`;
  }), t && (n += " Z"), n;
}, go = (e, t = 1) => {
  const n = e.map(([o, s]) => ({ x: o, y: s }));
  return Ko(n, t, !0).map((o) => [o.x, o.y]);
}, _t = (e, t) => {
  const n = Math.abs(t[0] - e[0]), o = Math.abs(t[1] - e[1]);
  return Math.sqrt(Math.pow(n, 2) + Math.pow(o, 2));
}, Zo = {
  area: (e) => Math.PI * e.geometry.rx * e.geometry.ry,
  intersects: (e, t, n) => {
    const { cx: o, cy: s, rx: i, ry: l } = e.geometry, r = 0, a = Math.cos(r), f = Math.sin(r), d = t - o, u = n - s, h = a * d + f * u, g = f * d - a * u;
    return h * h / (i * i) + g * g / (l * l) <= 1;
  }
};
Qe(x.ELLIPSE, Zo);
const Jo = {
  area: (e) => 0,
  intersects: (e, t, n, o = 2) => {
    const [[s, i], [l, r]] = e.geometry.points, a = Math.abs((r - i) * t - (l - s) * n + l * i - r * s), f = _t([s, i], [l, r]);
    return a / f <= o;
  }
};
Qe(x.LINE, Jo);
const Qo = {
  area: (e) => {
    const { polygons: t } = e.geometry;
    return t.reduce((n, o) => {
      const [s, ...i] = o.rings, l = vt(s.points), r = i.reduce((a, f) => a + vt(f.points), 0);
      return n + l - r;
    }, 0);
  },
  intersects: (e, t, n) => {
    const { polygons: o } = e.geometry;
    for (const s of o) {
      const [i, ...l] = s.rings;
      if (At(i.points, t, n)) {
        let r = !1;
        for (const a of l)
          if (At(a.points, t, n)) {
            r = !0;
            break;
          }
        if (!r) return !0;
      }
    }
    return !1;
  }
}, yt = (e) => {
  const t = e.reduce((n, o) => [...n, ...o.rings[0].points], []);
  return ue(t);
}, Te = (e) => e.rings.map((n) => ho(n.points)).join(" "), xo = (e) => e.polygons.reduce((t, n) => [
  ...t,
  ...n.rings.reduce((o, s) => [...o, ...s.points], [])
], []), sl = (e, t = 1) => {
  const n = e.geometry.polygons.map((s) => {
    const i = s.rings.map((r) => {
      const a = go(r.points, t);
      return {
        ...r,
        points: a
      };
    }), l = ue(i[0].points);
    return {
      ...s,
      rings: i,
      bounds: l
    };
  }), o = yt(n);
  return {
    ...e,
    geometry: {
      ...e.geometry,
      polygons: n,
      bounds: o
    }
  };
};
Qe(x.MULTIPOLYGON, Qo);
const $o = {
  area: (e) => {
    const t = e.geometry.points;
    return vt(t);
  },
  intersects: (e, t, n) => {
    const o = e.geometry.points;
    return At(o, t, n);
  }
}, il = (e, t = 1) => {
  const n = go(e.geometry.points, t), o = ue(n);
  return {
    ...e,
    geometry: {
      ...e.geometry,
      bounds: o,
      points: n
    }
  };
};
Qe(x.POLYGON, $o);
const es = {
  area: (e) => {
    const t = e.geometry;
    if (!t.closed || t.points.length < 3)
      return 0;
    const n = Qt(t.points, t.closed);
    return vt(n);
  },
  intersects: (e, t, n, o = 2) => {
    const s = e.geometry;
    if (s.closed) {
      const i = Qt(s.points, s.closed);
      return At(i, t, n);
    } else
      return ts(s, [t, n], o);
  }
}, Qt = (e, t = !1) => {
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const s = e[o], i = e[(o + 1) % e.length];
    if (n.push(s.point), (o < e.length - 1 || t) && (s.type === "CURVE" || i.type == "CURVE")) {
      const r = mo(
        s.point,
        s.type === "CURVE" && s.outHandle || s.point,
        i.type === "CURVE" && i.inHandle || i.point,
        i.point,
        10
        // number of approximation segments
      );
      n.push(...r.slice(1));
    }
  }
  return n;
}, mo = (e, t, n, o, s = 10) => {
  const i = [];
  for (let l = 0; l <= s; l++) {
    const r = l / s, a = Math.pow(1 - r, 3) * e[0] + 3 * Math.pow(1 - r, 2) * r * t[0] + 3 * (1 - r) * Math.pow(r, 2) * n[0] + Math.pow(r, 3) * o[0], f = Math.pow(1 - r, 3) * e[1] + 3 * Math.pow(1 - r, 2) * r * t[1] + 3 * (1 - r) * Math.pow(r, 2) * n[1] + Math.pow(r, 3) * o[1];
    i.push([a, f]);
  }
  return i;
}, ts = (e, t, n) => {
  for (let o = 0; o < e.points.length - 1; o++) {
    const s = e.points[o], i = e.points[o + 1];
    if (s.type === "CURVE" || i.type === "CURVE") {
      const r = mo(
        s.point,
        s.type === "CURVE" && s.outHandle || s.point,
        i.type === "CURVE" && i.inHandle || i.point,
        i.point,
        20
        // TODO make configurable? Based on scale factor? Length?
      );
      for (let a = 0; a < r.length - 1; a++)
        if (fn(t, r[a], r[a + 1]) <= n) return !0;
    } else if (fn(t, s.point, i.point) <= n) return !0;
  }
  return !1;
}, fn = (e, t, n) => {
  const [o, s] = e, [i, l] = t, [r, a] = n, f = r - i, d = a - l, u = Math.sqrt(f * f + d * d);
  if (u === 0)
    return Math.sqrt((o - i) * (o - i) + (s - l) * (s - l));
  const h = ((o - i) * f + (s - l) * d) / (u * u);
  return h <= 0 ? Math.sqrt((o - i) * (o - i) + (s - l) * (s - l)) : h >= 1 ? Math.sqrt((o - r) * (o - r) + (s - a) * (s - a)) : Math.abs((a - l) * o - (r - i) * s + r * l - a * i) / u;
}, po = (e) => {
  if (!e.points || e.points.length === 0)
    return "";
  const t = [], n = e.points[0];
  t.push(`M ${n.point[0]} ${n.point[1]}`);
  for (let o = 1; o < e.points.length; o++) {
    const s = e.points[o], i = e.points[o - 1];
    if (s.type === "CURVE" || i.type === "CURVE") {
      const l = i.type === "CURVE" && i.outHandle || i.point, r = s.type === "CURVE" && s.inHandle || s.point, a = s.point;
      t.push(`C ${l[0]} ${l[1]} ${r[0]} ${r[1]} ${a[0]} ${a[1]}`);
    } else
      t.push(`L ${s.point[0]} ${s.point[1]}`);
  }
  if (e.closed) {
    const o = e.points[e.points.length - 1], s = e.points[0];
    if (o.type === "CURVE" || s.type === "CURVE") {
      const l = o.outHandle || o.point, r = s.inHandle || s.point, a = s.point;
      t.push(`C ${l[0]} ${l[1]} ${r[0]} ${r[1]} ${a[0]} ${a[1]}`);
    }
    t.push("Z");
  }
  return t.join(" ");
};
Qe(x.POLYLINE, es);
const ns = {
  area: (e) => e.geometry.w * e.geometry.h,
  intersects: (e, t, n) => {
    const o = e.geometry;
    if (o.rot) {
      const s = o.x + o.w / 2, i = o.y + o.h / 2, l = t - s, r = n - i, a = Math.cos(o.rot), f = Math.sin(o.rot), d = l * a + r * f, u = -l * f + r * a;
      return d >= -o.w / 2 && d <= o.w / 2 && u >= -o.h / 2 && u <= o.h / 2;
    } else
      return t >= o.x && t <= o.x + o.w && n >= o.y && n <= o.y + o.h;
  }
};
Qe(x.RECTANGLE, ns);
const Mt = (e) => wt(e.target), wt = (e) => {
  var t, n;
  return (e == null ? void 0 : e.annotation) !== void 0 && ((n = (t = e == null ? void 0 : e.selector) == null ? void 0 : t.geometry) == null ? void 0 : n.bounds) !== void 0;
}, Re = "-?\\d+(?:\\.\\d+)?(?:[eE][+-]?\\d+)?", _o = 512, tn = (e) => (e == null ? void 0 : e.type) === "FragmentSelector" ? !0 : typeof e == "string" ? e.length > _o || e.indexOf("#") < 0 ? !1 : new RegExp(
  `#xywh=((?:pixel|percent):)?(${Re}),(${Re}),(${Re}),(${Re})$`,
  "i"
).test(e) : !1, os = (e, t = !1) => {
  const n = typeof e == "string" ? e : e.value;
  if (n.length > _o) throw new Error("Fragment too long: " + n);
  const s = new RegExp(
    `(xywh)=((?:pixel|percent))?:?(${Re}),(${Re}),(${Re}),(${Re})$`
  ).exec(n);
  if (!s) throw new Error("Not a MediaFragment: " + n);
  const [i, l, r, a, f, d, u] = s;
  if (l !== "xywh") throw new Error("Unsupported MediaFragment: " + n);
  if (r && r !== "pixel") throw new Error(`Unsupported MediaFragment unit: ${r}`);
  const [h, g, m, w] = [a, f, d, u].map(parseFloat);
  return {
    type: x.RECTANGLE,
    geometry: {
      x: h,
      y: g,
      w: m,
      h: w,
      rot: 0,
      bounds: {
        minX: h,
        minY: t ? g - w : g,
        maxX: h + m,
        maxY: t ? g : g + w
      }
    }
  };
}, ss = (e) => {
  const { x: t, y: n, w: o, h: s } = e;
  return {
    type: "FragmentSelector",
    conformsTo: "http://www.w3.org/TR/media-frags/",
    value: `xywh=pixel:${t},${n},${o},${s}`
  };
}, xt = "http://www.w3.org/2000/svg", un = (e) => {
  const t = (o) => {
    Array.from(o.attributes).forEach((s) => {
      s.name.startsWith("on") && o.removeAttribute(s.name);
    });
  }, n = e.getElementsByTagName("script");
  return Array.from(n).reverse().forEach((o) => o.parentNode.removeChild(o)), Array.from(e.querySelectorAll("*")).forEach(t), e;
}, is = (e) => {
  const o = new XMLSerializer().serializeToString(e.documentElement).replace("<svg>", `<svg xmlns="${xt}">`);
  return new DOMParser().parseFromString(o, "image/svg+xml").documentElement;
}, it = (e) => {
  const t = new DOMParser(), n = e.trimStart().startsWith("<svg") ? e : `<svg xmlns="${xt}">${e}</svg>`, o = t.parseFromString(n, "image/svg+xml"), s = o.lookupPrefix(xt), i = o.lookupNamespaceURI(null);
  return s || i ? un(o).firstChild : un(is(o)).firstChild;
}, rs = (e) => {
  const t = yo(e), n = [];
  let o = [], s = [0, 0];
  for (const i of t)
    switch (i.type.toUpperCase()) {
      case "M":
        o.length > 0 && (n.push({ points: o }), o = []), s = [i.args[0], i.args[1]], o.push([...s]);
        break;
      case "L":
        s = [i.args[0], i.args[1]], o.push([...s]);
        break;
      case "H":
        s = [i.args[0], s[1]], o.push([...s]);
        break;
      case "V":
        s = [s[0], i.args[0]], o.push([...s]);
        break;
      case "C":
        s = [i.args[4], i.args[5]], o.push([...s]);
        break;
      case "A": {
        const [l, r, a, f, d, u, h] = i.args, g = fs(s, [u, h], l, r, a, f, d);
        o.push(...g), s = [u, h];
        break;
      }
      case "Z":
        break;
      default:
        console.warn(`Unsupported SVG path command: ${i.type}`);
        break;
    }
  if (o.length > 2 && n.push({ points: o }), n.length > 0) {
    const i = ue(n[0].points);
    return { rings: n, bounds: i };
  }
}, dn = (e, t, n, o) => {
  if (e.length > 0) {
    const i = e[e.length - 1];
    (t[0] !== i.point[0] || t[1] !== i.point[1]) && (i.type = "CURVE", i.outHandle = t);
  }
  const s = {
    type: n[0] !== o[0] || n[1] !== o[1] ? "CURVE" : "CORNER",
    point: o
  };
  s.type === "CURVE" && (s.inHandle = n), e.push(s);
}, ls = (e) => {
  const { point: t, inHandle: n, outHandle: o } = e;
  if (!n || !o) return !1;
  const s = n[0] - t[0], i = n[1] - t[1], l = o[0] - t[0], r = o[1] - t[1], a = s * r - i * l;
  return Math.abs(a) < 0.01;
}, as = (e) => {
  const t = yo(e);
  let n = [], o = [0, 0], s = !1;
  for (let l = 0; l < t.length; l++) {
    const r = t[l];
    switch (r.type.toUpperCase()) {
      case "M":
        o = [r.args[0], r.args[1]], n.push({
          type: "CORNER",
          point: [...o]
        });
        break;
      case "L":
        o = [r.args[0], r.args[1]], n.push({
          type: "CORNER",
          point: [...o]
        });
        break;
      case "C": {
        const a = [r.args[0], r.args[1]], f = [r.args[2], r.args[3]], d = [r.args[4], r.args[5]];
        dn(n, a, f, d), o = d;
        break;
      }
      case "A": {
        const [a, f, d, u, h, g, m] = r.args;
        us(o, [g, m], a, f, d, u, h).forEach(({ cp1: A, cp2: y, end: v }) => dn(n, A, y, v)), o = [g, m];
        break;
      }
      case "Z":
        s = !0;
        break;
      default:
        console.warn(`Unsupported SVG path command: ${r.type}`);
        break;
    }
  }
  n = n.map((l) => ls(l) ? { ...l, locked: !0 } : l);
  const i = ue(Qt(n, s));
  return {
    points: n,
    closed: s,
    bounds: i
  };
}, yo = (e) => {
  const t = [], n = e.replace(/,/g, " ").trim(), o = /([MmLlHhVvCcAaZz])\s*([^MmLlHhVvCcAaZz]*)/g;
  let s;
  for (; (s = o.exec(n)) !== null; ) {
    const [, i, l] = s, r = l.trim() === "" ? [] : l.trim().split(/\s+/).map(Number).filter((f) => !isNaN(f)), a = cs(i);
    if (a === 0 || r.length <= a)
      t.push({ type: i, args: r });
    else
      for (let f = 0; f < r.length; f += a) {
        const d = f === 0 ? i : i === "M" ? "L" : i === "m" ? "l" : i;
        t.push({ type: d, args: r.slice(f, f + a) });
      }
  }
  return t;
}, cs = (e) => {
  switch (e.toUpperCase()) {
    case "M":
    case "L":
      return 2;
    case "H":
    case "V":
      return 1;
    case "C":
      return 6;
    case "A":
      return 7;
    case "Z":
      return 0;
    default:
      return 2;
  }
}, wo = (e, t, n, o, s, i, l) => {
  const [r, a] = e, [f, d] = t;
  n = Math.abs(n), o = Math.abs(o);
  const u = s % 360 * Math.PI / 180, h = Math.cos(u), g = Math.sin(u), m = (r - f) / 2, w = (a - d) / 2, A = h * m + g * w, y = -g * m + h * w, v = A * A / (n * n) + y * y / (o * o);
  if (v > 1) {
    const E = Math.sqrt(v);
    n *= E, o *= E;
  }
  const p = n * n, k = o * o, T = A * A, P = y * y, L = Math.max(p * k - p * P - k * T, 0), N = p * P + k * T, I = (i !== l ? 1 : -1) * (N === 0 ? 0 : Math.sqrt(L / N)), q = I * (n * y) / o, H = -I * (o * A) / n, G = h * q - g * H + (r + f) / 2, O = g * q + h * H + (a + d) / 2, M = (E, S, U, D) => {
    const K = E * D - S * U < 0 ? -1 : 1, F = Math.max(-1, Math.min(1, (E * U + S * D) / (Math.hypot(E, S) * Math.hypot(U, D))));
    return K * Math.acos(F);
  }, _ = M(1, 0, (A - q) / n, (y - H) / o);
  let b = M((A - q) / n, (y - H) / o, (-A - q) / n, (-y - H) / o);
  return !l && b > 0 && (b -= 2 * Math.PI), l && b < 0 && (b += 2 * Math.PI), { cx: G, cy: O, rx: n, ry: o, cosPhi: h, sinPhi: g, theta1: _, dtheta: b };
}, fs = (e, t, n, o, s, i, l, r = 64) => {
  const [a, f] = e, [d, u] = t;
  if (n === 0 || o === 0 || a === d && f === u)
    return [[d, u]];
  const { cx: h, cy: g, rx: m, ry: w, cosPhi: A, sinPhi: y, theta1: v, dtheta: p } = wo(e, t, n, o, s, i, l), k = Math.max(4, Math.round(r * Math.abs(p) / (2 * Math.PI))), T = [];
  for (let P = 1; P <= k; P++) {
    const L = v + p * P / k, N = h + m * Math.cos(L) * A - w * Math.sin(L) * y, I = g + m * Math.cos(L) * y + w * Math.sin(L) * A;
    T.push([N, I]);
  }
  return T[T.length - 1] = [d, u], T;
}, us = (e, t, n, o, s, i, l) => {
  const [r, a] = e, [f, d] = t;
  if (n === 0 || o === 0 || r === f && a === d)
    return [{ cp1: t, cp2: t, end: t }];
  const { cx: u, cy: h, rx: g, ry: m, cosPhi: w, sinPhi: A, theta1: y, dtheta: v } = wo(e, t, n, o, s, i, l), p = Math.max(1, Math.ceil(Math.abs(v) / (Math.PI / 2))), k = v / p, T = 4 / 3 * Math.tan(k / 4), P = (N, I) => [
    u + g * N * w - m * I * A,
    h + g * N * A + m * I * w
  ], L = [];
  for (let N = 0; N < p; N++) {
    const I = y + N * k, q = I + k, H = Math.cos(I), G = Math.sin(I), O = Math.cos(q), M = Math.sin(q), _ = P(H - T * G, G + T * H), b = P(O + T * M, M - T * O), E = N === p - 1 ? t : P(O, M);
    L.push({ cp1: _, cp2: b, end: E });
  }
  return L;
}, ds = (e) => {
  const [t, n, o] = e.match(/(<polygon points=["|'])([^("|')]*)/) || [], s = o.split(" ").map((i) => i.split(",").map(parseFloat));
  return {
    type: x.POLYGON,
    geometry: {
      points: s,
      bounds: ue(s)
    }
  };
}, hs = (e) => {
  const t = it(e), n = parseFloat(t.getAttribute("cx")), o = parseFloat(t.getAttribute("cy")), s = parseFloat(t.getAttribute("rx")), i = parseFloat(t.getAttribute("ry")), l = {
    minX: n - s,
    minY: o - i,
    maxX: n + s,
    maxY: o + i
  };
  return {
    type: x.ELLIPSE,
    geometry: {
      cx: n,
      cy: o,
      rx: s,
      ry: i,
      bounds: l
    }
  };
}, gs = (e) => {
  const t = it(e), n = parseFloat(t.getAttribute("x1")), o = parseFloat(t.getAttribute("x2")), s = parseFloat(t.getAttribute("y1")), i = parseFloat(t.getAttribute("y2")), l = {
    minX: Math.min(n, o),
    minY: Math.min(s, i),
    maxX: Math.max(n, o),
    maxY: Math.max(s, i)
  };
  return {
    type: x.LINE,
    geometry: {
      points: [[n, s], [o, i]],
      bounds: l
    }
  };
}, ms = (e) => {
  const t = it(e), n = t.nodeName === "path" ? t : Array.from(t.querySelectorAll("path"))[0], o = n == null ? void 0 : n.getAttribute("d");
  if (!o)
    throw new Error("Could not parse SVG path");
  const s = as(o);
  if (!s)
    throw new Error("Could not parse SVG path");
  return {
    type: x.POLYLINE,
    geometry: s
  };
}, ps = (e) => {
  const t = it(e), n = t.nodeName === "rect" ? t : Array.from(t.querySelectorAll("rect"))[0];
  if (!n) throw new Error("Could not parse SVG rect");
  const o = parseFloat(n.getAttribute("x")), s = parseFloat(n.getAttribute("y")), i = parseFloat(n.getAttribute("width")), l = parseFloat(n.getAttribute("height")), r = n.getAttribute("transform");
  let a = 0;
  if (r && r.startsWith("rotate(")) {
    const m = r.match(/rotate\(([^)]+)\)/);
    m && (a = m[1].split(/\s+/).map(parseFloat)[0] * Math.PI / 180);
  }
  const f = o + i / 2, d = s + l / 2, h = [
    [o, s],
    [o + i, s],
    [o + i, s + l],
    [o, s + l]
  ].map(([m, w]) => {
    const A = m - f, y = w - d, v = Math.cos(a), p = Math.sin(a);
    return [
      f + A * v - y * p,
      d + A * p + y * v
    ];
  }), g = ue(h);
  return {
    type: x.RECTANGLE,
    geometry: {
      x: o,
      y: s,
      w: i,
      h: l,
      rot: a,
      bounds: g
    }
  };
}, _s = (e) => {
  const t = it(e), s = (t.nodeName === "path" ? [t] : Array.from(t.querySelectorAll("path"))).map((a) => a.getAttribute("d") || "").map((a) => rs(a)).filter(Boolean), i = s.reduce((a, f) => [...a, ...f.rings[0].points], []), l = ue(i);
  return s.length === 1 && s[0].rings.length === 1 ? {
    type: x.POLYGON,
    geometry: {
      points: i,
      bounds: l
    }
  } : {
    type: x.MULTIPOLYGON,
    geometry: {
      polygons: s,
      bounds: l
    }
  };
}, ys = (e) => {
  const t = typeof e == "string" ? e : e.value;
  if (t.includes("<polygon points="))
    return ds(t);
  if (t.includes("<path ") && (t.includes(" C ") || t.includes(" A ") || !t.includes("Z")))
    return ms(t);
  if (t.includes("<path "))
    return _s(t);
  if (t.includes("<ellipse "))
    return hs(t);
  if (t.includes("<line "))
    return gs(t);
  if (t.includes("<rect "))
    return ps(t);
  throw "Unsupported SVG shape: " + t;
}, ws = (e, t, n, o) => `M ${e + n},${t} A ${n},${o} 0 1,1 ${e - n},${t} A ${n},${o} 0 1,1 ${e + n},${t} Z`, bs = (e) => `<g>${e.polygons.map((n) => `<path fill-rule="evenodd" d="${Te(n)}" />`).join("")}</g>`, Es = (e, t = !1) => {
  let n;
  switch (e.type) {
    case x.RECTANGLE: {
      const o = e.geometry, { x: s, y: i, w: l, h: r, rot: a } = o;
      if (!a)
        n = `<svg><rect x="${s}" y="${i}" width="${l}" height="${r}" /></svg>`;
      else {
        const f = s + l / 2, d = i + r / 2, u = (a ?? 0) * 180 / Math.PI;
        n = `<svg><rect x="${s}" y="${i}" width="${l}" height="${r}" transform="rotate(${u} ${f} ${d})" /></svg>`;
      }
      break;
    }
    case x.POLYGON: {
      const o = e.geometry, { points: s } = o;
      n = t ? `<svg><path d="${ho(s)}" /></svg>` : `<svg><polygon points="${s.map((i) => i.join(",")).join(" ")}" /></svg>`;
      break;
    }
    case x.ELLIPSE: {
      const o = e.geometry, { cx: s, cy: i, rx: l, ry: r } = o;
      n = t ? `<svg><path d="${ws(s, i, l, r)}" /></svg>` : `<svg><ellipse cx="${s}" cy="${i}" rx="${l}" ry="${r}" /></svg>`;
      break;
    }
    case x.MULTIPOLYGON: {
      const o = e.geometry;
      n = `<svg>${bs(o)}</svg>`;
      break;
    }
    case x.LINE: {
      const o = e.geometry, [[s, i], [l, r]] = o.points;
      n = t ? `<svg><path d="M ${s},${i} L ${l},${r}" /></svg>` : `<svg><line x1="${s}" y1="${i}" x2="${l}" y2="${r}" /></svg>`;
      break;
    }
    case x.POLYLINE:
      n = `<svg><path d="${po(e.geometry)}" /></svg>`;
  }
  if (n)
    return { type: "SvgSelector", value: n };
  throw `Unsupported shape type: ${e.type}`;
}, me = [];
for (let e = 0; e < 256; ++e)
  me.push((e + 256).toString(16).slice(1));
function vs(e, t = 0) {
  return (me[e[t + 0]] + me[e[t + 1]] + me[e[t + 2]] + me[e[t + 3]] + "-" + me[e[t + 4]] + me[e[t + 5]] + "-" + me[e[t + 6]] + me[e[t + 7]] + "-" + me[e[t + 8]] + me[e[t + 9]] + "-" + me[e[t + 10]] + me[e[t + 11]] + me[e[t + 12]] + me[e[t + 13]] + me[e[t + 14]] + me[e[t + 15]]).toLowerCase();
}
const As = new Uint8Array(16);
function Ms() {
  return crypto.getRandomValues(As);
}
function bo(e, t, n) {
  return crypto.randomUUID ? crypto.randomUUID() : Ss(e);
}
function Ss(e, t, n) {
  var s;
  e = e || {};
  const o = e.random ?? ((s = e.rng) == null ? void 0 : s.call(e)) ?? Ms();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, vs(o);
}
var hn = Object.prototype.hasOwnProperty;
function Be(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && Be(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (hn.call(e, n) && ++o && !hn.call(t, n) || !(n in t) || !Be(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
const ks = Symbol("clean");
let ke = [], Ne = 0;
const bt = 4, Ps = globalThis.nanostoresGlobal || (globalThis.nanostoresGlobal = { epoch: 0 });
let Ts = () => {
  for (Ne = 0; Ne < ke.length; Ne += bt)
    ke[Ne](
      ke[Ne + 1].value,
      ke[Ne + 2],
      ke[Ne + 3]
    );
  ke.length = 0;
};
const nn = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  let t = [], n = {
    get() {
      return n.lc || n.listen(() => {
      })(), n.value;
    },
    init: e,
    lc: 0,
    listen(o) {
      return n.lc = t.push(o), () => {
        for (let i = Ne + bt; i < ke.length; )
          ke[i] === o ? ke.splice(i, bt) : i += bt;
        let s = t.indexOf(o);
        ~s && (t.splice(s, 1), --n.lc || n.off());
      };
    },
    notify(o, s) {
      Ps.epoch++;
      let i = !ke.length && !0;
      for (let l of t)
        ke.push(
          l,
          n,
          o,
          s
        );
      i && Ts();
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(o) {
      let s = n.value;
      s !== o && (n.value = o, n.notify(s));
    },
    subscribe(o) {
      let s = n.listen(o);
      return o(n.value), s;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (n[ks] = () => {
    t = [], n.lc = 0, n.off();
  }), n;
}, Ls = (e) => {
  const t = /* @__PURE__ */ nn(null);
  return e.observe(({ changes: n }) => {
    const o = t.get();
    if (o) {
      (n.deleted || []).some((i) => i.id === o) && t.set(null);
      const s = (n.updated || []).find(({ oldValue: i }) => i.id === o);
      s && t.set(s.newValue.id);
    }
  }), {
    get current() {
      return t.get();
    },
    subscribe: t.subscribe.bind(t),
    set: t.set.bind(t)
  };
};
var Eo = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SELECT = "SELECT", e.NONE = "NONE", e))(Eo || {});
const Nt = { selected: [] }, Cs = (e, t, n) => {
  const o = /* @__PURE__ */ nn(Nt);
  let s = t;
  const i = () => {
    Be(o.get(), Nt) || o.set(Nt);
  }, l = () => {
    var g;
    return ((g = o.get().selected) == null ? void 0 : g.length) === 0;
  }, r = (g) => {
    if (l())
      return !1;
    const m = typeof g == "string" ? g : g.id;
    return o.get().selected.some((w) => w.id === m);
  }, a = (g, m) => {
    let w;
    if (Array.isArray(g)) {
      if (w = g.map((y) => e.getAnnotation(y)).filter(Boolean), w.length < g.length) {
        console.warn("Invalid selection: " + g.filter((y) => !w.some((v) => v.id === y)));
        return;
      }
    } else {
      const y = e.getAnnotation(g);
      if (!y) {
        console.warn("Invalid selection: " + g);
        return;
      }
      w = [y];
    }
    const A = w.reduce((y, v) => {
      const p = h(v);
      return p === "EDIT" ? [...y, { id: v.id, editable: !0 }] : p === "SELECT" ? [...y, { id: v.id }] : y;
    }, []);
    o.set({ selected: A, event: m });
  }, f = (g, m) => {
    const w = Array.isArray(g) ? g : [g], A = w.map((y) => e.getAnnotation(y)).filter((y) => !!y);
    o.set({
      selected: A.map((y) => {
        const v = m === void 0 ? h(y) === "EDIT" : m;
        return { id: y.id, editable: v };
      })
    }), A.length !== w.length && console.warn("Invalid selection", g);
  }, d = (g) => {
    if (l())
      return !1;
    const { selected: m } = o.get();
    m.some(({ id: w }) => g.includes(w)) && o.set({ selected: m.filter(({ id: w }) => !g.includes(w)) });
  }, u = (g) => {
    s = g, f(o.get().selected.map(({ id: m }) => m));
  }, h = (g) => Is(g, s, n);
  return e.observe(
    ({ changes: g }) => d((g.deleted || []).map((m) => m.id))
  ), {
    get event() {
      const g = o.get();
      return g ? g.event : null;
    },
    get selected() {
      const g = o.get();
      return g ? [...g.selected] : null;
    },
    get userSelectAction() {
      return s;
    },
    clear: i,
    evalSelectAction: h,
    isEmpty: l,
    isSelected: r,
    setSelected: f,
    setUserSelectAction: u,
    subscribe: o.subscribe.bind(o),
    userSelect: a
  };
}, Is = (e, t, n) => {
  const o = n ? n.serialize(e) : e;
  return typeof t == "function" ? t(o) : t || "EDIT";
}, pe = [];
for (let e = 0; e < 256; ++e)
  pe.push((e + 256).toString(16).slice(1));
function Os(e, t = 0) {
  return (pe[e[t + 0]] + pe[e[t + 1]] + pe[e[t + 2]] + pe[e[t + 3]] + "-" + pe[e[t + 4]] + pe[e[t + 5]] + "-" + pe[e[t + 6]] + pe[e[t + 7]] + "-" + pe[e[t + 8]] + pe[e[t + 9]] + "-" + pe[e[t + 10]] + pe[e[t + 11]] + pe[e[t + 12]] + pe[e[t + 13]] + pe[e[t + 14]] + pe[e[t + 15]]).toLowerCase();
}
const Ds = new Uint8Array(16);
function Ns() {
  return crypto.getRandomValues(Ds);
}
function vo(e, t, n) {
  return crypto.randomUUID ? crypto.randomUUID() : Rs(e);
}
function Rs(e, t, n) {
  var o;
  e = e || {};
  const s = e.random ?? ((o = e.rng) == null ? void 0 : o.call(e)) ?? Ns();
  if (s.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, Os(s);
}
const Rt = (e) => {
  const t = (n) => {
    const o = { ...n };
    return n.created && typeof n.created == "string" && (o.created = new Date(n.created)), n.updated && typeof n.updated == "string" && (o.updated = new Date(n.updated)), o;
  };
  return {
    ...e,
    bodies: (e.bodies || []).map(t),
    target: t(e.target)
  };
}, rl = (e, t, n, o) => ({
  id: vo(),
  annotation: typeof e == "string" ? e : e.id,
  created: n || /* @__PURE__ */ new Date(),
  creator: o,
  ...t
}), Bs = (e, t) => {
  const n = new Set(e.bodies.map((o) => o.id));
  return t.bodies.filter((o) => !n.has(o.id));
}, Ys = (e, t) => {
  const n = new Set(t.bodies.map((o) => o.id));
  return e.bodies.filter((o) => !n.has(o.id));
}, Us = (e, t) => t.bodies.map((n) => {
  const o = e.bodies.find((s) => s.id === n.id);
  return { newBody: n, oldBody: o && !Be(o, n) ? o : void 0 };
}).filter(({ oldBody: n }) => n).map(({ oldBody: n, newBody: o }) => ({ oldBody: n, newBody: o })), Vs = (e, t) => !Be(e.target, t.target), Ao = (e, t) => {
  const n = Bs(e, t), o = Ys(e, t), s = Us(e, t);
  return {
    oldValue: e,
    newValue: t,
    bodiesCreated: n.length > 0 ? n : void 0,
    bodiesDeleted: o.length > 0 ? o : void 0,
    bodiesUpdated: s.length > 0 ? s : void 0,
    targetUpdated: Vs(e, t) ? { oldTarget: e.target, newTarget: t.target } : void 0
  };
};
var ne = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.REMOTE = "REMOTE", e.SILENT = "SILENT", e))(ne || {});
const Xs = (e, t) => {
  var n, o;
  const { changes: s, origin: i } = t;
  if (!(e.options.origin ? e.options.origin === i : i !== "SILENT"))
    return !1;
  if (e.options.ignore) {
    const { ignore: l } = e.options, r = (a) => a && a.length > 0;
    if (!(r(s.created) || r(s.deleted))) {
      const a = (n = s.updated) == null ? void 0 : n.some((d) => r(d.bodiesCreated) || r(d.bodiesDeleted) || r(d.bodiesUpdated)), f = (o = s.updated) == null ? void 0 : o.some((d) => d.targetUpdated);
      if (l === "BODY_ONLY" && a && !f || l === "TARGET_ONLY" && f && !a)
        return !1;
    }
  }
  if (e.options.annotations) {
    const l = /* @__PURE__ */ new Set([
      ...(s.created || []).map((r) => r.id),
      ...(s.deleted || []).map((r) => r.id),
      ...(s.updated || []).map(({ oldValue: r }) => r.id)
    ]);
    return !!(Array.isArray(e.options.annotations) ? e.options.annotations : [e.options.annotations]).find((r) => l.has(r));
  } else
    return !0;
}, Hs = (e, t) => {
  const n = new Set((e.created || []).map((u) => u.id)), o = new Set((e.updated || []).map(({ newValue: u }) => u.id)), s = new Set((t.created || []).map((u) => u.id)), i = new Set((t.deleted || []).map((u) => u.id)), l = new Set((t.updated || []).map(({ oldValue: u }) => u.id)), r = new Set((t.updated || []).filter(({ oldValue: u }) => n.has(u.id) || o.has(u.id)).map(({ oldValue: u }) => u.id)), a = [
    ...(e.created || []).filter((u) => !i.has(u.id)).map((u) => l.has(u.id) ? t.updated.find(({ oldValue: h }) => h.id === u.id).newValue : u),
    ...t.created || []
  ], f = [
    ...(e.deleted || []).filter((u) => !s.has(u.id)),
    ...(t.deleted || []).filter((u) => !n.has(u.id))
  ], d = [
    ...(e.updated || []).filter(({ newValue: u }) => !i.has(u.id)).map((u) => {
      const { oldValue: h, newValue: g } = u;
      if (l.has(g.id)) {
        const m = t.updated.find((w) => w.oldValue.id === g.id).newValue;
        return Ao(h, m);
      } else
        return u;
    }),
    ...(t.updated || []).filter(({ oldValue: u }) => !r.has(u.id))
  ];
  return { created: a, deleted: f, updated: d };
}, Bt = (e) => {
  const t = e.id === void 0 ? vo() : e.id;
  return {
    ...e,
    id: t,
    bodies: e.bodies === void 0 ? [] : e.bodies.map((n) => ({
      ...n,
      annotation: t
    })),
    target: {
      ...e.target,
      annotation: t
    }
  };
}, Gs = (e) => e.id !== void 0, js = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = [], o = (_, b = {}) => {
    n.push({ onChange: _, options: b });
  }, s = (_) => {
    const b = n.findIndex((E) => E.onChange == _);
    b > -1 && n.splice(b, 1);
  }, i = (_, b) => {
    const E = {
      origin: _,
      changes: {
        created: b.created || [],
        updated: b.updated || [],
        deleted: b.deleted || []
      },
      state: [...e.values()]
    };
    n.forEach((S) => {
      Xs(S, E) && S.onChange(E);
    });
  }, l = (_) => {
    e.set(_.id, _), _.bodies.forEach((b) => t.set(b.id, _.id));
  }, r = (_, b = ne.LOCAL) => {
    if (_.id && e.get(_.id))
      throw Error(`Cannot add annotation ${_.id} - exists already`);
    {
      const E = Bt(_);
      l(E), i(b, { created: [E] });
    }
  }, a = (_, b) => {
    const E = Bt(typeof _ == "string" ? b : _), S = typeof _ == "string" ? _ : _.id, U = S && e.get(S);
    if (U) {
      const D = Ao(U, E);
      return S === E.id ? e.set(S, E) : (e.delete(S), e.set(E.id, E)), U.bodies.forEach((K) => t.delete(K.id)), E.bodies.forEach((K) => t.set(K.id, E.id)), D;
    } else
      console.warn(`Cannot update annotation ${S} - does not exist`);
  }, f = (_, b = ne.LOCAL, E = ne.LOCAL) => {
    const S = Gs(b) ? E : b, U = a(_, b);
    U && i(S, { updated: [U] });
  }, d = (_, b = ne.LOCAL) => {
    e.get(_.id) ? f(_, b) : r(_, b);
  }, u = (_, b = ne.LOCAL) => {
    const E = _.reduce((S, U) => {
      const D = a(U);
      return D ? [...S, D] : S;
    }, []);
    E.length > 0 && i(b, { updated: E });
  }, h = (_) => _.map(Bt).reduce((b, E) => e.get(E.id) ? { ...b, toUpdate: [...b.toUpdate, E] } : { ...b, toAdd: [...b.toAdd, E] }, { toAdd: [], toUpdate: [] }), g = (_, b = ne.LOCAL) => {
    const { toAdd: E, toUpdate: S } = h(_), U = S.map((D) => a(D, b)).filter(Boolean);
    E.forEach(l), i(b, { created: E, updated: U });
  }, m = (_, b = ne.LOCAL) => {
    const E = e.get(_.annotation);
    if (E) {
      const S = {
        ...E,
        bodies: [...E.bodies, _]
      };
      e.set(E.id, S), t.set(_.id, S.id), i(b, { updated: [{
        oldValue: E,
        newValue: S,
        bodiesCreated: [_]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${_.annotation}`);
  }, w = () => [...e.values()], A = (_ = ne.LOCAL) => {
    const b = [...e.values()];
    e.clear(), t.clear(), i(_, { deleted: b });
  }, y = (_, b = ne.LOCAL) => {
    const { toAdd: E, toUpdate: S } = h(_), U = new Set([...E, ...S].map((F) => F.id)), D = [...e.keys()].filter((F) => !U.has(F)).map((F) => p(F)).filter(Boolean), K = S.map((F) => a(F)).filter(Boolean);
    E.forEach(l), i(b, { created: E, updated: K, deleted: D });
  }, v = (_, b = !0, E = ne.LOCAL) => {
    b ? y(_, E) : g(_, E);
  }, p = (_) => {
    const b = typeof _ == "string" ? _ : _.id, E = e.get(b);
    if (E)
      return e.delete(b), E.bodies.forEach((S) => t.delete(S.id)), E;
    console.warn(`Attempt to delete missing annotation: ${b}`);
  }, k = (_, b = ne.LOCAL) => {
    const E = p(_);
    E && i(b, { deleted: [E] });
  }, T = (_, b = ne.LOCAL) => {
    const E = _.reduce((S, U) => {
      const D = p(U);
      return D ? [...S, D] : S;
    }, []);
    E.length > 0 && i(b, { deleted: E });
  }, P = (_) => {
    const b = e.get(_.annotation);
    if (b) {
      const E = b.bodies.find((S) => S.id === _.id);
      if (E) {
        t.delete(E.id);
        const S = {
          ...b,
          bodies: b.bodies.filter((U) => U.id !== _.id)
        };
        return e.set(b.id, S), {
          oldValue: b,
          newValue: S,
          bodiesDeleted: [E]
        };
      } else
        console.warn(`Attempt to delete missing body ${_.id} from annotation ${_.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${_.annotation}`);
  }, L = (_, b = ne.LOCAL) => {
    const E = P(_);
    E && i(b, { updated: [E] });
  }, N = (_, b = ne.LOCAL) => {
    const E = _.map((S) => P(S)).filter(Boolean);
    E.length > 0 && i(b, { updated: E });
  }, I = (_) => {
    const b = e.get(_);
    return b ? { ...b } : void 0;
  }, q = (_) => {
    const b = t.get(_);
    if (b) {
      const E = I(b).bodies.find((S) => S.id === _);
      if (E)
        return E;
      console.error(`Store integrity error: body ${_} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${_}`);
  }, H = (_, b) => {
    if (_.annotation !== b.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const E = e.get(_.annotation);
    if (E) {
      const S = E.bodies.find((D) => D.id === _.id), U = {
        ...E,
        bodies: E.bodies.map((D) => D.id === S.id ? b : D)
      };
      return e.set(E.id, U), S.id !== b.id && (t.delete(S.id), t.set(b.id, U.id)), {
        oldValue: E,
        newValue: U,
        bodiesUpdated: [{ oldBody: S, newBody: b }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${_.annotation}`);
  }, G = (_, b, E = ne.LOCAL) => {
    const S = H(_, b);
    S && i(E, { updated: [S] });
  }, O = (_, b = ne.LOCAL) => {
    const E = _.map((S) => H({ id: S.id, annotation: S.annotation }, S)).filter(Boolean);
    i(b, { updated: E });
  }, M = (_) => {
    const b = e.get(_.annotation);
    if (b) {
      const E = {
        ...b,
        target: {
          ...b.target,
          ..._
        }
      };
      return e.set(b.id, E), {
        oldValue: b,
        newValue: E,
        targetUpdated: {
          oldTarget: b.target,
          newTarget: _
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${_.annotation}`);
  };
  return {
    addAnnotation: r,
    addBody: m,
    all: w,
    bulkAddAnnotations: v,
    bulkDeleteAnnotations: T,
    bulkDeleteBodies: N,
    bulkUpdateAnnotations: u,
    bulkUpdateBodies: O,
    bulkUpdateTargets: (_, b = ne.LOCAL) => {
      const E = _.map((S) => M(S)).filter(Boolean);
      E.length > 0 && i(b, { updated: E });
    },
    bulkUpsertAnnotations: g,
    clear: A,
    deleteAnnotation: k,
    deleteBody: L,
    getAnnotation: I,
    getBody: q,
    observe: o,
    syncAnnotations: y,
    unobserve: s,
    updateAnnotation: f,
    updateBody: G,
    updateTarget: (_, b = ne.LOCAL) => {
      const E = M(_);
      E && i(b, { updated: [E] });
    },
    upsertAnnotation: d
  };
};
let Fs = () => ({
  emit(e, ...t) {
    for (let n = this.events[e] || [], o = 0, s = n.length; o < s; o++)
      n[o](...t);
  },
  events: {},
  on(e, t) {
    var n;
    return ((n = this.events)[e] || (n[e] = [])).push(t), () => {
      var o;
      this.events[e] = (o = this.events[e]) == null ? void 0 : o.filter((s) => t !== s);
    };
  }
});
const zs = 250, qs = (e, t) => {
  const n = Fs(), o = (t == null ? void 0 : t.changes) || [];
  let s = t ? t.pointer : -1, i = !1, l = 0;
  const r = (m) => {
    if (!i) {
      const { changes: w } = m, A = performance.now();
      if (A - l > zs)
        o.splice(s + 1), o.push(w), s = o.length - 1;
      else {
        const y = o.length - 1;
        o[y] = Hs(o[y], w);
      }
      l = A;
    }
    i = !1;
  };
  e.observe(r, { origin: ne.LOCAL });
  const a = (m) => m && m.length > 0 && e.bulkDeleteAnnotations(m), f = (m) => m && m.length > 0 && e.bulkUpsertAnnotations(m), d = (m) => m && m.length > 0 && e.bulkUpdateAnnotations(m.map(({ oldValue: w }) => w)), u = (m) => m && m.length > 0 && e.bulkUpdateAnnotations(m.map(({ newValue: w }) => w)), h = (m) => m && m.length > 0 && e.bulkUpsertAnnotations(m), g = (m) => m && m.length > 0 && e.bulkDeleteAnnotations(m);
  return {
    canRedo: () => o.length - 1 > s,
    canUndo: () => s > -1,
    destroy: () => e.unobserve(r),
    getHistory: () => ({ changes: [...o], pointer: s }),
    on: (m, w) => n.on(m, w),
    redo: () => {
      if (o.length - 1 > s) {
        i = !0;
        const { created: m, updated: w, deleted: A } = o[s + 1];
        f(m), u(w), g(A), n.emit("redo", o[s + 1]), s += 1;
      }
    },
    undo: () => {
      if (s > -1) {
        i = !0;
        const { created: m, updated: w, deleted: A } = o[s];
        a(m), d(w), h(A), n.emit("undo", o[s]), s -= 1;
      }
    }
  };
}, Ks = () => {
  const e = /* @__PURE__ */ nn([]);
  return {
    subscribe: e.subscribe.bind(e),
    set: e.set.bind(e)
  };
}, Ws = (e, t, n, o) => {
  const { hover: s, selection: i, store: l, viewport: r } = e, a = /* @__PURE__ */ new Map();
  let f = [], d, u;
  const h = (y, v) => {
    a.has(y) ? a.get(y).push(v) : a.set(y, [v]);
  }, g = (y, v) => {
    const p = a.get(y);
    if (p) {
      const k = p.indexOf(v);
      k !== -1 && p.splice(k, 1);
    }
  }, m = (y, v, p) => {
    a.has(y) && setTimeout(() => {
      a.get(y).forEach((k) => {
        if (n) {
          const T = Array.isArray(v) ? v.map((L) => n.serialize(L)) : n.serialize(v), P = p ? p instanceof PointerEvent ? p : n.serialize(p) : void 0;
          k(T, P);
        } else
          k(v, p);
      });
    }, 1);
  }, w = () => {
    const { selected: y } = i, v = (y || []).map(({ id: p }) => l.getAnnotation(p));
    v.forEach((p) => {
      const k = f.find((T) => T.id === p.id);
      (!k || !Be(k, p)) && m("updateAnnotation", p, k);
    }), f = f.map((p) => v.find(({ id: T }) => T === p.id) || p);
  };
  i.subscribe(({ selected: y }) => {
    if (!(f.length === 0 && y.length === 0)) {
      if (f.length === 0 && y.length > 0)
        f = y.map(({ id: v }) => l.getAnnotation(v));
      else if (f.length > 0 && y.length === 0)
        f.forEach((v) => {
          const p = l.getAnnotation(v.id);
          p && !Be(p, v) && m("updateAnnotation", p, v);
        }), f = [];
      else {
        const v = new Set(f.map((k) => k.id)), p = new Set(y.map(({ id: k }) => k));
        f.filter((k) => !p.has(k.id)).forEach((k) => {
          const T = l.getAnnotation(k.id);
          T && !Be(T, k) && m("updateAnnotation", T, k);
        }), f = [
          // Remove annotations that were deselected
          ...f.filter((k) => p.has(k.id)),
          // Add editable annotations that were selected
          ...y.filter(({ id: k }) => !v.has(k)).map(({ id: k }) => l.getAnnotation(k))
        ];
      }
      m("selectionChanged", f);
    }
  }), s.subscribe((y) => {
    !d && y ? m("mouseEnterAnnotation", l.getAnnotation(y)) : d && !y ? m("mouseLeaveAnnotation", l.getAnnotation(d)) : d && y && (m("mouseLeaveAnnotation", l.getAnnotation(d)), m("mouseEnterAnnotation", l.getAnnotation(y))), d = y;
  }), r == null || r.subscribe((y) => m("viewportIntersect", y.map((v) => l.getAnnotation(v)))), l.observe((y) => {
    o && (u && clearTimeout(u), u = setTimeout(w, 1e3));
    const { created: v, deleted: p } = y.changes;
    (v || []).forEach((k) => m("createAnnotation", k)), (p || []).forEach((k) => m("deleteAnnotation", k)), (y.changes.updated || []).filter((k) => [
      ...k.bodiesCreated || [],
      ...k.bodiesDeleted || [],
      ...k.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: k, newValue: T }) => {
      const P = f.find((L) => L.id === k.id) || k;
      f = f.map((L) => L.id === k.id ? T : L), m("updateAnnotation", T, P);
    });
  }, { origin: ne.LOCAL }), l.observe((y) => {
    if (f) {
      const v = new Set(f.map((k) => k.id)), p = (y.changes.updated || []).filter(({ newValue: k }) => v.has(k.id)).map(({ newValue: k }) => k);
      p.length > 0 && (f = f.map((k) => p.find((P) => P.id === k.id) || k));
    }
  }, { origin: ne.REMOTE });
  const A = (y) => (v) => {
    const { updated: p } = v;
    y ? (p || []).forEach((k) => m("updateAnnotation", k.oldValue, k.newValue)) : (p || []).forEach((k) => m("updateAnnotation", k.newValue, k.oldValue));
  };
  return t.on("undo", A(!0)), t.on("redo", A(!1)), { on: h, off: g, emit: m };
}, Zs = (e) => (t) => t.reduce((n, o) => {
  const { parsed: s, error: i } = e.parse(o);
  return i ? {
    parsed: n.parsed,
    failed: [...n.failed, o]
  } : s ? {
    parsed: [...n.parsed, s],
    failed: n.failed
  } : {
    ...n
  };
}, { parsed: [], failed: [] }), Js = (e, t, n) => {
  const { store: o, selection: s } = e, i = (y) => {
    if (n) {
      const { parsed: v, error: p } = n.parse(y);
      v ? o.addAnnotation(v, ne.REMOTE) : console.error(p);
    } else
      o.addAnnotation(Rt(y), ne.REMOTE);
  }, l = () => s.clear(), r = () => o.clear(), a = (y) => {
    const v = o.getAnnotation(y);
    return n && v ? n.serialize(v) : v;
  }, f = () => n ? o.all().map(n.serialize) : o.all(), d = () => {
    var y;
    const v = (((y = s.selected) == null ? void 0 : y.map((p) => p.id)) || []).map((p) => o.getAnnotation(p)).filter(Boolean);
    return n ? v.map(n.serialize) : v;
  }, u = (y, v = !0) => fetch(y).then((p) => p.json()).then((p) => (g(p, v), p)), h = (y) => {
    if (typeof y == "string") {
      const v = o.getAnnotation(y);
      if (o.deleteAnnotation(y), v)
        return n ? n.serialize(v) : v;
    } else {
      const v = n ? n.parse(y).parsed : y;
      if (v)
        return o.deleteAnnotation(v), y;
    }
  }, g = (y, v = !0) => {
    const p = v ? o.syncAnnotations : o.bulkUpsertAnnotations;
    if (n) {
      const k = n.parseAll || Zs(n), { parsed: T, failed: P } = k(y);
      P.length > 0 && console.warn(`Discarded ${P.length} invalid annotations`, P), p(T, ne.REMOTE);
    } else
      p(y.map(Rt), ne.REMOTE);
  }, m = (y, v) => {
    y ? s.setSelected(y, v) : s.clear();
  }, w = (y) => {
    s.setUserSelectAction(y);
  }, A = (y) => {
    if (n) {
      const v = n.parse(y).parsed, p = n.serialize(o.getAnnotation(v.id));
      return o.updateAnnotation(v), p;
    } else {
      const v = o.getAnnotation(y.id);
      return o.updateAnnotation(Rt(y)), v;
    }
  };
  return {
    addAnnotation: i,
    cancelSelected: l,
    canRedo: t.canRedo,
    canUndo: t.canUndo,
    clearAnnotations: r,
    getAnnotationById: a,
    getAnnotations: f,
    getHistory: t.getHistory,
    getSelected: d,
    loadAnnotations: u,
    redo: t.redo,
    removeAnnotation: h,
    setAnnotations: g,
    setSelected: m,
    setUserSelectAction: w,
    undo: t.undo,
    updateAnnotation: A
  };
}, ll = (e, t, n) => typeof t == "function" ? t(e, n) : t, al = (e, t) => typeof e != "function" && typeof t != "function" ? {
  ...e || {},
  ...t || {}
} : (n, o) => {
  const s = typeof e == "function" ? e(n, o) : e, i = typeof t == "function" ? t(n, o) : t;
  return {
    ...s || {},
    ...i || {}
  };
};
let Qs = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", xs = (e) => crypto.getRandomValues(new Uint8Array(e)), $s = (e, t, n) => {
  let o = 256 - 256 % e.length;
  if (o === 256) {
    let i = e.length - 1;
    return (l = t) => {
      if (!l) return "";
      let r = "";
      for (; ; ) {
        let a = n(l), f = l;
        for (; f--; )
          if (r += e[a[f] & i], r.length >= l) return r;
      }
    };
  }
  let s = Math.ceil(1.6 * 256 * t / o);
  return (i = t) => {
    if (!i) return "";
    let l = "";
    for (; ; ) {
      let r = n(s), a = s;
      for (; a--; )
        if (r[a] < o && (l += e[r[a] % e.length], l.length >= i))
          return l;
    }
  };
}, ei = (e, t = 21) => $s(e, t | 0, xs), ti = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += Qs[n[e] & 63];
  return t;
};
const ni = () => ({ isGuest: !0, id: ei("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), oi = (e) => {
  const t = JSON.stringify(e);
  let n = 0;
  for (let o = 0, s = t.length; o < s; o++) {
    let i = t.charCodeAt(o);
    n = (n << 5) - n + i, n |= 0;
  }
  return `${n}`;
}, Mo = (e) => e ? typeof e == "object" ? { ...e } : e : void 0, si = (e, t) => (Array.isArray(e) ? e : [e]).map((n) => {
  const { id: o, type: s, purpose: i, value: l, created: r, modified: a, creator: f, ...d } = n;
  return {
    id: o || `temp-${oi(n)}`,
    annotation: t,
    type: s,
    purpose: i,
    value: l,
    creator: Mo(f),
    created: r ? new Date(r) : void 0,
    updated: a ? new Date(a) : void 0,
    ...d
  };
}), ii = (e) => e.map((t) => {
  var n;
  const { annotation: o, created: s, updated: i, ...l } = t, r = {
    ...l,
    created: s == null ? void 0 : s.toISOString(),
    modified: i == null ? void 0 : i.toISOString()
  };
  return (n = r.id) != null && n.startsWith("temp-") && delete r.id, r;
}), ri = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], cl = () => {
  const e = [...ri];
  return { assignRandomColor: () => {
    const t = Math.floor(Math.random() * e.length), n = e[t];
    return e.splice(t, 1), n;
  }, releaseColor: (t) => e.push(t) };
};
globalThis.ANNOTORIOUS_PRESENCE_KEY || (globalThis.ANNOTORIOUS_PRESENCE_KEY = ti());
const fl = (e, t = { strict: !0 }) => ({ parse: (s) => ai(s, t), serialize: (s) => ci(s, e, t) }), gn = (e) => (e == null ? void 0 : e.type) === "SvgSelector" || (e == null ? void 0 : e.type) === "FragmentSelector" || tn(e), li = (e) => {
  if (typeof e == "string")
    return tn(e);
  const t = Array.isArray(e.selector) ? e.selector.find(gn) : e.selector;
  return gn(t);
}, ai = (e, t = { strict: !0 }) => {
  const n = e.id || bo(), {
    creator: o,
    created: s,
    modified: i,
    body: l,
    ...r
  } = e, a = si(l || [], n), f = Array.isArray(e.target) ? e.target.find(li) : e.target;
  if (!f)
    return {
      error: Error(`Unsupported target(s): ${JSON.stringify(f)}`)
    };
  const d = typeof f == "string" ? f : Array.isArray(f.selector) ? f.selector[0] : f.selector, u = tn(d) ? os(d, t.invertY) : (d == null ? void 0 : d.type) === "SvgSelector" ? ys(d) : void 0, h = Array.isArray(r.target) ? r.target[0] : r.targret;
  return u || !t.strict ? {
    parsed: {
      ...r,
      id: n,
      bodies: a,
      target: {
        created: s ? new Date(s) : void 0,
        creator: Mo(o),
        updated: i ? new Date(i) : void 0,
        // Note the target can be a string and we don't want to spread the characters...
        ...typeof h == "string" ? {} : h,
        annotation: n,
        selector: u || d
      }
    }
  } : {
    error: Error(`Invalid selector: ${JSON.stringify(d)}`)
  };
}, ci = (e, t, n = { strict: !0 }) => {
  const {
    selector: o,
    creator: s,
    created: i,
    updated: l,
    updatedBy: r,
    // Excluded from serialization
    ...a
  } = e.target;
  let f;
  try {
    o.type === x.RECTANGLE && !o.geometry.rot ? f = ss(o.geometry) : f = Es(o);
  } catch (u) {
    if (n.strict)
      throw u;
    f = o;
  }
  const d = {
    ...e,
    "@context": "http://www.w3.org/ns/anno.jsonld",
    id: e.id,
    type: "Annotation",
    body: ii(e.bodies),
    created: i == null ? void 0 : i.toISOString(),
    creator: s,
    modified: l == null ? void 0 : l.toISOString(),
    target: {
      ...a,
      source: t,
      type: "SpecificResource",
      selector: f
    }
  };
  return delete d.bodies, typeof d.target != "string" && "annotation" in d.target && delete d.target.annotation, d;
}, ze = [];
function fi(e, t = $) {
  let n;
  const o = /* @__PURE__ */ new Set();
  function s(r) {
    if (ae(e, r) && (e = r, n)) {
      const a = !ze.length;
      for (const f of o)
        f[1](), ze.push(f, e);
      if (a) {
        for (let f = 0; f < ze.length; f += 2)
          ze[f][0](ze[f + 1]);
        ze.length = 0;
      }
    }
  }
  function i(r) {
    s(r(e));
  }
  function l(r, a = $) {
    const f = [r, a];
    return o.add(f), o.size === 1 && (n = t(s, i) || $), r(e), () => {
      o.delete(f), o.size === 0 && n && (n(), n = null);
    };
  }
  return { set: s, update: i, subscribe: l };
}
const ui = (e, t) => {
  const { naturalWidth: n, naturalHeight: o } = e;
  if (!n && !o) {
    const { width: s, height: i } = e;
    t.setAttribute("viewBox", `0 0 ${s} ${i}`), e.addEventListener("load", (l) => {
      const r = l.target;
      t.setAttribute("viewBox", `0 0 ${r.naturalWidth} ${r.naturalHeight}`);
    });
  } else
    t.setAttribute("viewBox", `0 0 ${n} ${o}`);
}, di = (e, t) => {
  ui(e, t);
  const { subscribe: n, set: o } = fi(1);
  let s;
  return window.ResizeObserver && (s = new ResizeObserver(() => {
    const l = t.getBoundingClientRect(), { width: r, height: a } = t.viewBox.baseVal, f = Math.max(
      l.width / r,
      l.height / a
    );
    o(f);
  }), s.observe(t.parentElement)), { destroy: () => {
    s && s.disconnect();
  }, subscribe: n };
}, je = (e, t, n) => {
  const o = typeof t == "function" ? t(e, n) : t;
  if (o) {
    const { fill: s, fillOpacity: i, stroke: l, strokeWidth: r, strokeOpacity: a } = o;
    let f = "";
    return s && (f += `fill:${s};`), i || i === 0 ? f += `fill-opacity:${i};` : s && (f += "fill-opacity:0.25;"), l && (f += `stroke:${l};`, f += `stroke-width:${r || "1"};`, f += `stroke-opacity:${a || "1"};`), f;
  }
}, St = (e, t = 0) => {
  const { minX: n, minY: o, maxX: s, maxY: i } = e;
  return {
    x: n - t,
    y: o - t,
    w: s - n + 2 * t,
    h: i - o + 2 * t
  };
}, Le = typeof window > "u" || typeof navigator > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-ignore
navigator.msMaxTouchPoints > 0, hi = (e) => ({}), mn = (e) => ({ grab: (
  /*onGrab*/
  e[0]
) });
function gi(e) {
  let t, n, o, s;
  const i = (
    /*#slots*/
    e[8].default
  ), l = Ro(
    i,
    e,
    /*$$scope*/
    e[7],
    mn
  );
  return {
    c() {
      t = C("g"), l && l.c(), c(t, "class", "a9s-annotation selected");
    },
    m(r, a) {
      Y(r, t, a), l && l.m(t, null), n = !0, o || (s = [
        Q(
          t,
          "pointerup",
          /*onRelease*/
          e[2]
        ),
        Q(
          t,
          "pointermove",
          /*onPointerMove*/
          e[1]
        )
      ], o = !0);
    },
    p(r, [a]) {
      l && l.p && (!n || a & /*$$scope*/
      128) && Yo(
        l,
        i,
        r,
        /*$$scope*/
        r[7],
        n ? Bo(
          i,
          /*$$scope*/
          r[7],
          a,
          hi
        ) : Uo(
          /*$$scope*/
          r[7]
        ),
        mn
      );
    },
    i(r) {
      n || (V(l, r), n = !0);
    },
    o(r) {
      j(l, r), n = !1;
    },
    d(r) {
      r && B(t), l && l.d(r), o = !1, Me(s);
    }
  };
}
function mi(e, t, n) {
  let { $$slots: o = {}, $$scope: s } = t;
  const i = Ue();
  let { shape: l } = t, { editor: r } = t, { transform: a } = t, { svgEl: f } = t, d, u, h;
  const g = (A) => (y) => {
    if (d = A, f) {
      const { left: p, top: k } = f.getBoundingClientRect(), T = y.clientX - p, P = y.clientY - k;
      u = a.elementToImage(T, P);
    } else {
      const { offsetX: p, offsetY: k } = y;
      u = a.elementToImage(p, k);
    }
    h = l, y.target.setPointerCapture(y.pointerId), i("grab", y);
  }, m = (A) => {
    if (d) {
      const [y, v] = a.elementToImage(A.offsetX, A.offsetY), p = [y - u[0], v - u[1]];
      n(3, l = r(h, d, p)), i("change", l);
    }
  }, w = (A) => {
    A.target.releasePointerCapture(A.pointerId), d = void 0, h = l, i("release", A);
  };
  return e.$$set = (A) => {
    "shape" in A && n(3, l = A.shape), "editor" in A && n(4, r = A.editor), "transform" in A && n(5, a = A.transform), "svgEl" in A && n(6, f = A.svgEl), "$$scope" in A && n(7, s = A.$$scope);
  }, [
    g,
    m,
    w,
    l,
    r,
    a,
    f,
    s,
    o
  ];
}
class on extends ye {
  constructor(t) {
    super(), _e(this, t, mi, gi, ae, {
      shape: 3,
      editor: 4,
      transform: 5,
      svgEl: 6
    });
  }
}
function pi(e) {
  let t, n, o, s, i, l, r, a, f = (
    /*selected*/
    e[3] && pn(e)
  );
  return {
    c() {
      t = C("g"), n = C("circle"), f && f.c(), s = C("circle"), c(n, "class", "a9s-handle-buffer svelte-qtyc7s"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = /*handleRadius*/
      e[5] + 6 / /*scale*/
      e[2]), c(n, "role", "button"), c(n, "tabindex", "0"), c(s, "class", i = Ze(`a9s-handle-dot${/*selected*/
      e[3] ? " selected" : ""}`) + " svelte-qtyc7s"), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(
        s,
        "r",
        /*handleRadius*/
        e[5]
      ), c(t, "class", l = `a9s-handle ${/*$$props*/
      e[8].class || ""}`.trim());
    },
    m(d, u) {
      Y(d, t, u), z(t, n), f && f.m(t, null), z(t, s), r || (a = [
        Q(
          n,
          "dblclick",
          /*dblclick_handler_1*/
          e[12]
        ),
        Q(
          n,
          "pointerenter",
          /*pointerenter_handler*/
          e[13]
        ),
        Q(
          n,
          "pointerleave",
          /*pointerleave_handler*/
          e[14]
        ),
        Q(
          n,
          "pointerdown",
          /*pointerdown_handler_1*/
          e[15]
        ),
        Q(
          n,
          "pointerdown",
          /*onPointerDown*/
          e[6]
        ),
        Q(
          n,
          "pointerup",
          /*pointerup_handler_1*/
          e[16]
        ),
        Q(
          n,
          "pointerup",
          /*onPointerUp*/
          e[7]
        )
      ], r = !0);
    },
    p(d, u) {
      u & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        d[0]
      ), u & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        d[1]
      ), u & /*handleRadius, scale*/
      36 && o !== (o = /*handleRadius*/
      d[5] + 6 / /*scale*/
      d[2]) && c(n, "r", o), /*selected*/
      d[3] ? f ? f.p(d, u) : (f = pn(d), f.c(), f.m(t, s)) : f && (f.d(1), f = null), u & /*selected*/
      8 && i !== (i = Ze(`a9s-handle-dot${/*selected*/
      d[3] ? " selected" : ""}`) + " svelte-qtyc7s") && c(s, "class", i), u & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        d[0]
      ), u & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        d[1]
      ), u & /*handleRadius*/
      32 && c(
        s,
        "r",
        /*handleRadius*/
        d[5]
      ), u & /*$$props*/
      256 && l !== (l = `a9s-handle ${/*$$props*/
      d[8].class || ""}`.trim()) && c(t, "class", l);
    },
    d(d) {
      d && B(t), f && f.d(), r = !1, Me(a);
    }
  };
}
function _i(e) {
  let t, n, o, s, i, l, r, a, f;
  return {
    c() {
      t = C("g"), n = C("circle"), s = C("circle"), l = C("circle"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = /*handleRadius*/
      e[5] * 10), c(n, "class", "a9s-touch-halo"), Pe(
        n,
        "touched",
        /*touched*/
        e[4]
      ), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(s, "r", i = /*handleRadius*/
      e[5] + 10 / /*scale*/
      e[2]), c(s, "class", "a9s-handle-buffer svelte-qtyc7s"), c(s, "role", "button"), c(s, "tabindex", "0"), c(l, "class", "a9s-handle-dot"), c(
        l,
        "cx",
        /*x*/
        e[0]
      ), c(
        l,
        "cy",
        /*y*/
        e[1]
      ), c(l, "r", r = /*handleRadius*/
      e[5] + 2 / /*scale*/
      e[2]), c(t, "class", "a9s-touch-handle");
    },
    m(d, u) {
      Y(d, t, u), z(t, n), z(t, s), z(t, l), a || (f = [
        Q(
          s,
          "dblclick",
          /*dblclick_handler*/
          e[9]
        ),
        Q(
          s,
          "pointerdown",
          /*pointerdown_handler*/
          e[10]
        ),
        Q(
          s,
          "pointerdown",
          /*onPointerDown*/
          e[6]
        ),
        Q(
          s,
          "pointerup",
          /*pointerup_handler*/
          e[11]
        ),
        Q(
          s,
          "pointerup",
          /*onPointerUp*/
          e[7]
        )
      ], a = !0);
    },
    p(d, u) {
      u & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        d[0]
      ), u & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        d[1]
      ), u & /*handleRadius*/
      32 && o !== (o = /*handleRadius*/
      d[5] * 10) && c(n, "r", o), u & /*touched*/
      16 && Pe(
        n,
        "touched",
        /*touched*/
        d[4]
      ), u & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        d[0]
      ), u & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        d[1]
      ), u & /*handleRadius, scale*/
      36 && i !== (i = /*handleRadius*/
      d[5] + 10 / /*scale*/
      d[2]) && c(s, "r", i), u & /*x*/
      1 && c(
        l,
        "cx",
        /*x*/
        d[0]
      ), u & /*y*/
      2 && c(
        l,
        "cy",
        /*y*/
        d[1]
      ), u & /*handleRadius, scale*/
      36 && r !== (r = /*handleRadius*/
      d[5] + 2 / /*scale*/
      d[2]) && c(l, "r", r);
    },
    d(d) {
      d && B(t), a = !1, Me(f);
    }
  };
}
function pn(e) {
  let t, n;
  return {
    c() {
      t = C("circle"), c(t, "class", "a9s-handle-selected"), c(
        t,
        "cx",
        /*x*/
        e[0]
      ), c(
        t,
        "cy",
        /*y*/
        e[1]
      ), c(t, "r", n = /*handleRadius*/
      e[5] + 8 / /*scale*/
      e[2]);
    },
    m(o, s) {
      Y(o, t, s);
    },
    p(o, s) {
      s & /*x*/
      1 && c(
        t,
        "cx",
        /*x*/
        o[0]
      ), s & /*y*/
      2 && c(
        t,
        "cy",
        /*y*/
        o[1]
      ), s & /*handleRadius, scale*/
      36 && n !== (n = /*handleRadius*/
      o[5] + 8 / /*scale*/
      o[2]) && c(t, "r", n);
    },
    d(o) {
      o && B(t);
    }
  };
}
function yi(e) {
  let t;
  function n(i, l) {
    return Le ? _i : pi;
  }
  let s = n()(e);
  return {
    c() {
      s.c(), t = Se();
    },
    m(i, l) {
      s.m(i, l), Y(i, t, l);
    },
    p(i, [l]) {
      s.p(i, l);
    },
    i: $,
    o: $,
    d(i) {
      i && B(t), s.d(i);
    }
  };
}
function wi(e, t, n) {
  let o, { x: s } = t, { y: i } = t, { scale: l } = t, { selected: r = void 0 } = t, a = !1;
  const f = (p) => {
    p.pointerType === "touch" && n(4, a = !0);
  }, d = () => n(4, a = !1);
  function u(p) {
    de.call(this, e, p);
  }
  function h(p) {
    de.call(this, e, p);
  }
  function g(p) {
    de.call(this, e, p);
  }
  function m(p) {
    de.call(this, e, p);
  }
  function w(p) {
    de.call(this, e, p);
  }
  function A(p) {
    de.call(this, e, p);
  }
  function y(p) {
    de.call(this, e, p);
  }
  function v(p) {
    de.call(this, e, p);
  }
  return e.$$set = (p) => {
    n(8, t = Kt(Kt({}, t), an(p))), "x" in p && n(0, s = p.x), "y" in p && n(1, i = p.y), "scale" in p && n(2, l = p.scale), "selected" in p && n(3, r = p.selected);
  }, e.$$.update = () => {
    e.$$.dirty & /*scale*/
    4 && n(5, o = 4 / l);
  }, t = an(t), [
    s,
    i,
    l,
    r,
    a,
    o,
    f,
    d,
    t,
    u,
    h,
    g,
    m,
    w,
    A,
    y,
    v
  ];
}
class Xe extends ye {
  constructor(t) {
    super(), _e(this, t, wi, yi, ae, { x: 0, y: 1, scale: 2, selected: 3 });
  }
}
function bi(e) {
  let t, n, o, s, i, l, r;
  return {
    c() {
      t = C("g"), n = C("circle"), s = C("circle"), i = C("circle"), c(n, "class", "a9s-polygon-midpoint-buffer svelte-12ykj76"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = 1.75 * /*handleRadius*/
      e[2]), c(s, "class", "a9s-polygon-midpoint-outer svelte-12ykj76"), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(
        s,
        "r",
        /*handleRadius*/
        e[2]
      ), c(i, "class", "a9s-polygon-midpoint-inner svelte-12ykj76"), c(
        i,
        "cx",
        /*x*/
        e[0]
      ), c(
        i,
        "cy",
        /*y*/
        e[1]
      ), c(
        i,
        "r",
        /*handleRadius*/
        e[2]
      ), c(t, "class", "a9s-polygon-midpoint svelte-12ykj76");
    },
    m(a, f) {
      Y(a, t, f), z(t, n), z(t, s), z(t, i), l || (r = [
        Q(
          n,
          "pointerdown",
          /*pointerdown_handler*/
          e[5]
        ),
        Q(
          n,
          "pointerdown",
          /*onPointerDown*/
          e[3]
        )
      ], l = !0);
    },
    p(a, f) {
      f & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        a[0]
      ), f & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        a[1]
      ), f & /*handleRadius*/
      4 && o !== (o = 1.75 * /*handleRadius*/
      a[2]) && c(n, "r", o), f & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        a[0]
      ), f & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        a[1]
      ), f & /*handleRadius*/
      4 && c(
        s,
        "r",
        /*handleRadius*/
        a[2]
      ), f & /*x*/
      1 && c(
        i,
        "cx",
        /*x*/
        a[0]
      ), f & /*y*/
      2 && c(
        i,
        "cy",
        /*y*/
        a[1]
      ), f & /*handleRadius*/
      4 && c(
        i,
        "r",
        /*handleRadius*/
        a[2]
      );
    },
    d(a) {
      a && B(t), l = !1, Me(r);
    }
  };
}
function Ei(e) {
  let t;
  return {
    c() {
      t = C("circle"), c(
        t,
        "cx",
        /*x*/
        e[0]
      ), c(
        t,
        "cy",
        /*y*/
        e[1]
      ), c(
        t,
        "r",
        /*handleRadius*/
        e[2]
      );
    },
    m(n, o) {
      Y(n, t, o);
    },
    p(n, o) {
      o & /*x*/
      1 && c(
        t,
        "cx",
        /*x*/
        n[0]
      ), o & /*y*/
      2 && c(
        t,
        "cy",
        /*y*/
        n[1]
      ), o & /*handleRadius*/
      4 && c(
        t,
        "r",
        /*handleRadius*/
        n[2]
      );
    },
    d(n) {
      n && B(t);
    }
  };
}
function vi(e) {
  let t;
  function n(i, l) {
    return Le ? Ei : bi;
  }
  let s = n()(e);
  return {
    c() {
      s.c(), t = Se();
    },
    m(i, l) {
      s.m(i, l), Y(i, t, l);
    },
    p(i, [l]) {
      s.p(i, l);
    },
    i: $,
    o: $,
    d(i) {
      i && B(t), s.d(i);
    }
  };
}
function Ai(e, t, n) {
  let o, { x: s } = t, { y: i } = t, { scale: l } = t;
  const r = (f) => {
    f.pointerType;
  };
  function a(f) {
    de.call(this, e, f);
  }
  return e.$$set = (f) => {
    "x" in f && n(0, s = f.x), "y" in f && n(1, i = f.y), "scale" in f && n(4, l = f.scale);
  }, e.$$.update = () => {
    e.$$.dirty & /*scale*/
    16 && n(2, o = 4 / l);
  }, [s, i, o, r, l, a];
}
class So extends ye {
  constructor(t) {
    super(), _e(this, t, Ai, vi, ae, { x: 0, y: 1, scale: 4 });
  }
}
function Yt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function _n(e, t, n) {
  const o = e.slice();
  return o[28] = t[n], o[30] = n, o;
}
function Ut(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function Vt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function yn(e) {
  let t, n, o, s;
  return {
    c() {
      t = C("circle"), c(t, "cx", n = /*point*/
      e[28][0]), c(t, "cy", o = /*point*/
      e[28][1]), c(t, "r", s = ot / /*viewportScale*/
      e[3]), c(t, "class", "svelte-1h2slbm");
    },
    m(i, l) {
      Y(i, t, l);
    },
    p(i, l) {
      l[0] & /*midpoints, visibleMidpoint*/
      1088 && n !== (n = /*point*/
      i[28][0]) && c(t, "cx", n), l[0] & /*midpoints, visibleMidpoint*/
      1088 && o !== (o = /*point*/
      i[28][1]) && c(t, "cy", o), l[0] & /*viewportScale*/
      8 && s !== (s = ot / /*viewportScale*/
      i[3]) && c(t, "r", s);
    },
    d(i) {
      i && B(t);
    }
  };
}
function wn(e) {
  let t, n, o, s, i, l, r, a, f, d;
  return {
    c() {
      t = C("mask"), n = C("rect"), r = C("circle"), c(n, "x", o = /*mask*/
      e[9].x), c(n, "y", s = /*mask*/
      e[9].y), c(n, "width", i = /*mask*/
      e[9].w), c(n, "height", l = /*mask*/
      e[9].h), c(n, "class", "svelte-1h2slbm"), c(r, "cx", a = /*point*/
      e[28][0]), c(r, "cy", f = /*point*/
      e[28][1]), c(r, "r", d = ot / /*viewportScale*/
      e[3]), c(r, "class", "svelte-1h2slbm"), c(t, "id", `${/*maskId*/
      e[19]}-inner`), c(t, "class", "a9s-polygon-editor-mask svelte-1h2slbm");
    },
    m(u, h) {
      Y(u, t, h), z(t, n), z(t, r);
    },
    p(u, h) {
      h[0] & /*mask*/
      512 && o !== (o = /*mask*/
      u[9].x) && c(n, "x", o), h[0] & /*mask*/
      512 && s !== (s = /*mask*/
      u[9].y) && c(n, "y", s), h[0] & /*mask*/
      512 && i !== (i = /*mask*/
      u[9].w) && c(n, "width", i), h[0] & /*mask*/
      512 && l !== (l = /*mask*/
      u[9].h) && c(n, "height", l), h[0] & /*midpoints, visibleMidpoint*/
      1088 && a !== (a = /*point*/
      u[28][0]) && c(r, "cx", a), h[0] & /*midpoints, visibleMidpoint*/
      1088 && f !== (f = /*point*/
      u[28][1]) && c(r, "cy", f), h[0] & /*viewportScale*/
      8 && d !== (d = ot / /*viewportScale*/
      u[3]) && c(r, "r", d);
    },
    d(u) {
      u && B(t);
    }
  };
}
function bn(e) {
  let t, n;
  return t = new Xe({
    props: {
      class: "a9s-corner-handle",
      x: (
        /*point*/
        e[28][0]
      ),
      y: (
        /*point*/
        e[28][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      ),
      selected: (
        /*selectedCorners*/
        e[8].includes(
          /*idx*/
          e[30]
        )
      )
    }
  }), t.$on(
    "pointerenter",
    /*onEnterHandle*/
    e[11]
  ), t.$on(
    "pointerleave",
    /*onLeaveHandle*/
    e[12]
  ), t.$on(
    "pointerdown",
    /*onHandlePointerDown*/
    e[15]
  ), t.$on("pointerdown", function() {
    se(
      /*grab*/
      e[27](`HANDLE-${/*idx*/
      e[30]}`)
    ) && e[27](`HANDLE-${/*idx*/
    e[30]}`).apply(this, arguments);
  }), t.$on(
    "pointerup",
    /*onHandlePointerUp*/
    e[16](
      /*idx*/
      e[30]
    )
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*geom*/
      32 && (i.x = /*point*/
      e[28][0]), s[0] & /*geom*/
      32 && (i.y = /*point*/
      e[28][1]), s[0] & /*viewportScale*/
      8 && (i.scale = /*viewportScale*/
      e[3]), s[0] & /*selectedCorners*/
      256 && (i.selected = /*selectedCorners*/
      e[8].includes(
        /*idx*/
        e[30]
      )), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function En(e) {
  let t, n;
  return t = new So({
    props: {
      x: (
        /*point*/
        e[28][0]
      ),
      y: (
        /*point*/
        e[28][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), t.$on("pointerdown", function() {
    se(
      /*onAddPoint*/
      e[18](
        /*visibleMidpoint*/
        e[6]
      )
    ) && e[18](
      /*visibleMidpoint*/
      e[6]
    ).apply(this, arguments);
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.x = /*point*/
      e[28][0]), s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.y = /*point*/
      e[28][1]), s[0] & /*viewportScale*/
      8 && (i.scale = /*viewportScale*/
      e[3]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Mi(e) {
  let t, n, o, s, i, l, r, a, f, d, u, h, g, m, w, A, y, v, p, k, T, P = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && yn(Vt(e))
  ), L = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && wn(Ut(e))
  ), N = ve(
    /*geom*/
    e[5].points
  ), I = [];
  for (let G = 0; G < N.length; G += 1)
    I[G] = bn(_n(e, N, G));
  const q = (G) => j(I[G], 1, 1, () => {
    I[G] = null;
  });
  let H = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && En(Yt(e))
  );
  return {
    c() {
      t = C("defs"), n = C("mask"), o = C("rect"), a = C("polygon"), P && P.c(), L && L.c(), d = we(), u = C("polygon"), g = we(), m = C("polygon"), A = we();
      for (let G = 0; G < I.length; G += 1)
        I[G].c();
      y = we(), H && H.c(), v = Se(), c(o, "x", s = /*mask*/
      e[9].x), c(o, "y", i = /*mask*/
      e[9].y), c(o, "width", l = /*mask*/
      e[9].w), c(o, "height", r = /*mask*/
      e[9].h), c(o, "class", "svelte-1h2slbm"), c(a, "points", f = /*geom*/
      e[5].points.map(vn).join(" ")), c(a, "class", "svelte-1h2slbm"), c(n, "id", `${/*maskId*/
      e[19]}-outer`), c(n, "class", "a9s-polygon-editor-mask svelte-1h2slbm"), c(u, "class", "a9s-outer"), c(u, "mask", `url(#${/*maskId*/
      e[19]}-outer)`), c(u, "points", h = /*geom*/
      e[5].points.map(An).join(" ")), c(m, "class", "a9s-inner a9s-shape-handle"), c(m, "mask", `url(#${/*maskId*/
      e[19]}-inner)`), c(
        m,
        "style",
        /*computedStyle*/
        e[1]
      ), c(m, "points", w = /*geom*/
      e[5].points.map(Mn).join(" "));
    },
    m(G, O) {
      Y(G, t, O), z(t, n), z(n, o), z(n, a), P && P.m(n, null), L && L.m(t, null), Y(G, d, O), Y(G, u, O), Y(G, g, O), Y(G, m, O), Y(G, A, O);
      for (let M = 0; M < I.length; M += 1)
        I[M] && I[M].m(G, O);
      Y(G, y, O), H && H.m(G, O), Y(G, v, O), p = !0, k || (T = [
        Q(
          u,
          "pointerup",
          /*onShapePointerUp*/
          e[14]
        ),
        Q(u, "pointerdown", function() {
          se(
            /*grab*/
            e[27]("SHAPE")
          ) && e[27]("SHAPE").apply(this, arguments);
        }),
        Q(
          m,
          "pointermove",
          /*onPointerMove*/
          e[13]
        ),
        Q(
          m,
          "pointerup",
          /*onShapePointerUp*/
          e[14]
        ),
        Q(m, "pointerdown", function() {
          se(
            /*grab*/
            e[27]("SHAPE")
          ) && e[27]("SHAPE").apply(this, arguments);
        })
      ], k = !0);
    },
    p(G, O) {
      if (e = G, (!p || O[0] & /*mask*/
      512 && s !== (s = /*mask*/
      e[9].x)) && c(o, "x", s), (!p || O[0] & /*mask*/
      512 && i !== (i = /*mask*/
      e[9].y)) && c(o, "y", i), (!p || O[0] & /*mask*/
      512 && l !== (l = /*mask*/
      e[9].w)) && c(o, "width", l), (!p || O[0] & /*mask*/
      512 && r !== (r = /*mask*/
      e[9].h)) && c(o, "height", r), (!p || O[0] & /*geom*/
      32 && f !== (f = /*geom*/
      e[5].points.map(vn).join(" "))) && c(a, "points", f), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? P ? P.p(Vt(e), O) : (P = yn(Vt(e)), P.c(), P.m(n, null)) : P && (P.d(1), P = null), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? L ? L.p(Ut(e), O) : (L = wn(Ut(e)), L.c(), L.m(t, null)) : L && (L.d(1), L = null), (!p || O[0] & /*geom*/
      32 && h !== (h = /*geom*/
      e[5].points.map(An).join(" "))) && c(u, "points", h), (!p || O[0] & /*computedStyle*/
      2) && c(
        m,
        "style",
        /*computedStyle*/
        e[1]
      ), (!p || O[0] & /*geom*/
      32 && w !== (w = /*geom*/
      e[5].points.map(Mn).join(" "))) && c(m, "points", w), O[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      134322472) {
        N = ve(
          /*geom*/
          e[5].points
        );
        let M;
        for (M = 0; M < N.length; M += 1) {
          const _ = _n(e, N, M);
          I[M] ? (I[M].p(_, O), V(I[M], 1)) : (I[M] = bn(_), I[M].c(), V(I[M], 1), I[M].m(y.parentNode, y));
        }
        for (be(), M = N.length; M < I.length; M += 1)
          q(M);
        Ee();
      }
      /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? H ? (H.p(Yt(e), O), O[0] & /*visibleMidpoint, isHandleHovered*/
      192 && V(H, 1)) : (H = En(Yt(e)), H.c(), V(H, 1), H.m(v.parentNode, v)) : H && (be(), j(H, 1, 1, () => {
        H = null;
      }), Ee());
    },
    i(G) {
      if (!p) {
        for (let O = 0; O < N.length; O += 1)
          V(I[O]);
        V(H), p = !0;
      }
    },
    o(G) {
      I = I.filter(Boolean);
      for (let O = 0; O < I.length; O += 1)
        j(I[O]);
      j(H), p = !1;
    },
    d(G) {
      G && (B(t), B(d), B(u), B(g), B(m), B(A), B(y), B(v)), P && P.d(), L && L.d(), Ge(I, G), H && H.d(G), k = !1, Me(T);
    }
  };
}
function Si(e) {
  let t, n;
  return t = new on({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[17]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          Mi,
          ({ grab: o }) => ({ 27: o }),
          ({ grab: o }) => [o ? 134217728 : 0]
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    e[20]
  ), t.$on(
    "grab",
    /*grab_handler*/
    e[21]
  ), t.$on(
    "release",
    /*release_handler*/
    e[22]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*shape*/
      1 && (i.shape = /*shape*/
      o[0]), s[0] & /*transform*/
      4 && (i.transform = /*transform*/
      o[2]), s[0] & /*svgEl*/
      16 && (i.svgEl = /*svgEl*/
      o[4]), s[0] & /*midpoints, visibleMidpoint, viewportScale, isHandleHovered, geom, selectedCorners, grab, computedStyle, mask*/
      134219754 | s[1] & /*$$scope*/
      1 && (i.$$scope = { dirty: s, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const ki = 250, Pi = 1e3, Ti = 12, ot = 4.5, vn = (e) => e.join(","), An = (e) => e.join(","), Mn = (e) => e.join(",");
function Li(e, t, n) {
  let o, s, i;
  const l = Ue();
  let { shape: r } = t, { computedStyle: a } = t, { transform: f } = t, { viewportScale: d = 1 } = t, { svgEl: u } = t, h, g = !1, m, w = [];
  const A = () => n(7, g = !0), y = () => n(7, g = !1), v = (M) => {
    if (w.length > 0 || !s.some((F) => F.visible)) {
      n(6, h = void 0);
      return;
    }
    const [_, b] = f.elementToImage(M.offsetX, M.offsetY), E = (F) => Math.pow(F[0] - _, 2) + Math.pow(F[1] - b, 2), S = o.points.reduce((F, Z) => E(Z) < E(F) ? Z : F), U = s.filter((F) => F.visible).reduce((F, Z) => E(Z.point) < E(F.point) ? Z : F), D = Math.pow(Pi / d, 2);
    E(S) < D || E(U.point) < D ? n(6, h = s.indexOf(U)) : n(6, h = void 0);
  }, p = () => {
    document.activeElement !== u && u.focus();
  }, k = () => {
    n(8, w = []), p();
  }, T = (M) => {
    n(7, g = !0), M.preventDefault(), M.stopPropagation(), m = performance.now();
  }, P = (M) => (_) => {
    if (!m || Le || performance.now() - m > ki) return;
    const b = w.includes(M);
    _.metaKey || _.ctrlKey || _.shiftKey ? b ? n(8, w = w.filter((E) => E !== M)) : n(8, w = [...w, M]) : b && w.length > 1 ? n(8, w = [M]) : b ? n(8, w = []) : n(8, w = [M]), p();
  }, L = (M, _, b) => {
    p();
    let E;
    const S = M.geometry;
    w.length > 1 ? E = S.points.map(([D, K], F) => w.includes(F) ? [D + b[0], K + b[1]] : [D, K]) : _ === "SHAPE" ? E = S.points.map(([D, K]) => [D + b[0], K + b[1]]) : E = S.points.map(([D, K], F) => _ === `HANDLE-${F}` ? [D + b[0], K + b[1]] : [D, K]);
    const U = ue(E);
    return { ...M, geometry: { points: E, bounds: U } };
  }, N = (M) => async (_) => {
    _.stopPropagation();
    const b = [
      ...o.points.slice(0, M + 1),
      s[M].point,
      ...o.points.slice(M + 1)
    ], E = ue(b);
    l("change", { ...r, geometry: { points: b, bounds: E } }), await co();
    const S = [...document.querySelectorAll(".a9s-handle")][M + 1];
    if (S != null && S.firstChild) {
      const U = new PointerEvent(
        "pointerdown",
        {
          bubbles: !0,
          cancelable: !0,
          clientX: _.clientX,
          clientY: _.clientY,
          pointerId: _.pointerId,
          pointerType: _.pointerType,
          isPrimary: _.isPrimary,
          buttons: _.buttons
        }
      );
      S.firstChild.dispatchEvent(U);
    }
  }, I = () => {
    if (o.points.length - w.length < 3) return;
    const M = o.points.filter((b, E) => !w.includes(E)), _ = ue(M);
    l("change", { ...r, geometry: { points: M, bounds: _ } }), n(8, w = []);
  };
  Ye(() => {
    if (Le) return;
    const M = (_) => {
      (_.key === "Delete" || _.key === "Backspace") && (_.preventDefault(), I());
    };
    return u.addEventListener("pointermove", v), u.addEventListener("keydown", M), () => {
      u.removeEventListener("pointermove", v), u.removeEventListener("keydown", M);
    };
  });
  const q = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`;
  function H(M) {
    de.call(this, e, M);
  }
  function G(M) {
    de.call(this, e, M);
  }
  function O(M) {
    de.call(this, e, M);
  }
  return e.$$set = (M) => {
    "shape" in M && n(0, r = M.shape), "computedStyle" in M && n(1, a = M.computedStyle), "transform" in M && n(2, f = M.transform), "viewportScale" in M && n(3, d = M.viewportScale), "svgEl" in M && n(4, u = M.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*shape*/
    1 && n(5, o = r.geometry), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(10, s = Le ? [] : o.points.map((M, _) => {
      const b = _ === o.points.length - 1 ? o.points[0] : o.points[_ + 1], E = (M[0] + b[0]) / 2, S = (M[1] + b[1]) / 2, D = Math.sqrt(Math.pow(b[0] - E, 2) + Math.pow(b[1] - S, 2)) > Ti / d;
      return { point: [E, S], visible: D };
    })), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(9, i = St(o.bounds, ot / d));
  }, [
    r,
    a,
    f,
    d,
    u,
    o,
    h,
    g,
    w,
    i,
    s,
    A,
    y,
    v,
    k,
    T,
    P,
    L,
    N,
    q,
    H,
    G,
    O
  ];
}
class Ci extends ye {
  constructor(t) {
    super(), _e(
      this,
      t,
      Li,
      Si,
      ae,
      {
        shape: 0,
        computedStyle: 1,
        transform: 2,
        viewportScale: 3,
        svgEl: 4
      },
      null,
      [-1, -1]
    );
  }
}
const ko = (e, t, n) => {
  const [o, s] = e, [i, l] = t, r = Math.cos(n), a = Math.sin(n), f = o - i, d = s - l;
  return [
    i + f * r - d * a,
    l + f * a + d * r
  ];
}, Ii = (e, t, n, o, s = 0) => {
  const i = [
    [e, t],
    [e + n, t],
    [e + n, t + o],
    [e, t + o]
  ], l = [e + n / 2, t + o / 2];
  return i.map((r) => ko(r, l, s));
}, Sn = (e, t) => {
  const { x: n, y: o, w: s, h: i, rot: l = 0 } = e, r = [n + s / 2, o + i / 2];
  let a = [n + s / 2, o - t];
  return ko(a, r, l);
}, Oi = (e, t, n) => {
  const o = Math.cos(n), s = Math.sin(n);
  return [
    e * o + t * s,
    -e * s + t * o
  ];
}, Di = (e, t, n) => {
  const o = e[0] - n[0], s = e[1] - n[1], i = Math.atan2(s, o), l = t[0] - n[0], r = t[1] - n[1];
  return Math.atan2(r, l) - i;
}, Ni = (e, t = 10) => {
  const n = t * Math.PI / 180;
  return Math.round(e / n) * n;
};
function Ri(e) {
  let t, n, o, s, i, l, r, a, f, d, u, h, g, m, w, A, y, v, p, k, T, P, L, N, I, q, H, G, O, M, _, b, E, S, U, D, K, F, Z, ee, he, oe, Ae, X, fe, te, ge, ie, Ve, rt, lt, at, kt, Ce, Pt, Ie, Tt, Oe, Lt, De, J, Ct, rn;
  return P = new Xe({
    props: {
      class: "a9s-rotation-handle",
      x: (
        /*rotationHandlePos*/
        e[7][0]
      ),
      y: (
        /*rotationHandlePos*/
        e[7][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), P.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("ROTATION")
    ) && e[16]("ROTATION").apply(this, arguments);
  }), Ce = new Xe({
    props: {
      class: "a9s-corner-handle-topleft",
      x: (
        /*rotatedCorners*/
        e[6][0][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][0][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Ce.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("TOP_LEFT")
    ) && e[16]("TOP_LEFT").apply(this, arguments);
  }), Ie = new Xe({
    props: {
      class: "a9s-corner-handle-topright",
      x: (
        /*rotatedCorners*/
        e[6][1][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][1][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Ie.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("TOP_RIGHT")
    ) && e[16]("TOP_RIGHT").apply(this, arguments);
  }), Oe = new Xe({
    props: {
      class: "a9s-corner-handle-bottomright",
      x: (
        /*rotatedCorners*/
        e[6][2][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][2][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Oe.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("BOTTOM_RIGHT")
    ) && e[16]("BOTTOM_RIGHT").apply(this, arguments);
  }), De = new Xe({
    props: {
      class: "a9s-corner-handle-bottomleft",
      x: (
        /*rotatedCorners*/
        e[6][3][0]
      ),
      y: (
        /*rotatedCorners*/
        e[6][3][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), De.$on("pointerdown", function() {
    se(
      /*grab*/
      e[16]("BOTTOM_LEFT")
    ) && e[16]("BOTTOM_LEFT").apply(this, arguments);
  }), {
    c() {
      t = C("defs"), n = C("mask"), o = C("rect"), a = C("polygon"), d = we(), u = C("g"), h = C("line"), y = C("line"), ce(P.$$.fragment), L = we(), N = C("g"), I = C("polygon"), H = C("polygon"), O = we(), M = C("line"), U = we(), D = C("line"), he = we(), oe = C("line"), ge = we(), ie = C("line"), kt = we(), ce(Ce.$$.fragment), Pt = we(), ce(Ie.$$.fragment), Tt = we(), ce(Oe.$$.fragment), Lt = we(), ce(De.$$.fragment), c(o, "class", "rect-mask-bg svelte-1bwhzbc"), c(o, "x", s = /*mask*/
      e[5].x), c(o, "y", i = /*mask*/
      e[5].y), c(o, "width", l = /*mask*/
      e[5].w), c(o, "height", r = /*mask*/
      e[5].h), c(a, "class", "rect-mask-fg svelte-1bwhzbc"), c(a, "points", f = /*rotatedCorners*/
      e[6].map(kn).join(" ")), c(
        n,
        "id",
        /*maskId*/
        e[9]
      ), c(n, "class", "a9s-rectangle-editor-mask svelte-1bwhzbc"), c(h, "class", "a9s-rotation-handle-line-bg"), c(h, "x1", g = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2), c(h, "y1", m = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2), c(h, "x2", w = /*rotationHandlePos*/
      e[7][0]), c(h, "y2", A = /*rotationHandlePos*/
      e[7][1]), c(h, "pointer-events", "none"), c(y, "class", "a9s-rotation-handle-line-fg"), c(y, "x1", v = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2), c(y, "y1", p = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2), c(y, "x2", k = /*rotationHandlePos*/
      e[7][0]), c(y, "y2", T = /*rotationHandlePos*/
      e[7][1]), c(y, "pointer-events", "none"), c(u, "class", "a9s-rotation-handle-group"), c(I, "class", "a9s-outer"), c(I, "mask", `url(#${/*maskId*/
      e[9]})`), c(I, "points", q = /*rotatedCorners*/
      e[6].map(Pn).join(" ")), c(H, "class", "a9s-inner a9s-shape-handle"), c(
        H,
        "style",
        /*computedStyle*/
        e[1]
      ), c(H, "points", G = /*rotatedCorners*/
      e[6].map(Tn).join(" ")), c(M, "class", "a9s-edge-handle a9s-edge-handle-top"), c(M, "x1", _ = /*rotatedCorners*/
      e[6][0][0]), c(M, "y1", b = /*rotatedCorners*/
      e[6][0][1]), c(M, "x2", E = /*rotatedCorners*/
      e[6][1][0]), c(M, "y2", S = /*rotatedCorners*/
      e[6][1][1]), c(D, "class", "a9s-edge-handle a9s-edge-handle-right"), c(D, "x1", K = /*rotatedCorners*/
      e[6][1][0]), c(D, "y1", F = /*rotatedCorners*/
      e[6][1][1]), c(D, "x2", Z = /*rotatedCorners*/
      e[6][2][0]), c(D, "y2", ee = /*rotatedCorners*/
      e[6][2][1]), c(oe, "class", "a9s-edge-handle a9s-edge-handle-bottom"), c(oe, "x1", Ae = /*rotatedCorners*/
      e[6][2][0]), c(oe, "y1", X = /*rotatedCorners*/
      e[6][2][1]), c(oe, "x2", fe = /*rotatedCorners*/
      e[6][3][0]), c(oe, "y2", te = /*rotatedCorners*/
      e[6][3][1]), c(ie, "class", "a9s-edge-handle a9s-edge-handle-left"), c(ie, "x1", Ve = /*rotatedCorners*/
      e[6][3][0]), c(ie, "y1", rt = /*rotatedCorners*/
      e[6][3][1]), c(ie, "x2", lt = /*rotatedCorners*/
      e[6][0][0]), c(ie, "y2", at = /*rotatedCorners*/
      e[6][0][1]);
    },
    m(W, R) {
      Y(W, t, R), z(t, n), z(n, o), z(n, a), Y(W, d, R), Y(W, u, R), z(u, h), z(u, y), re(P, u, null), Y(W, L, R), Y(W, N, R), z(N, I), z(N, H), Y(W, O, R), Y(W, M, R), Y(W, U, R), Y(W, D, R), Y(W, he, R), Y(W, oe, R), Y(W, ge, R), Y(W, ie, R), Y(W, kt, R), re(Ce, W, R), Y(W, Pt, R), re(Ie, W, R), Y(W, Tt, R), re(Oe, W, R), Y(W, Lt, R), re(De, W, R), J = !0, Ct || (rn = [
        Q(I, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("SHAPE")
          ) && e[16]("SHAPE").apply(this, arguments);
        }),
        Q(H, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("SHAPE")
          ) && e[16]("SHAPE").apply(this, arguments);
        }),
        Q(M, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("TOP")
          ) && e[16]("TOP").apply(this, arguments);
        }),
        Q(D, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("RIGHT")
          ) && e[16]("RIGHT").apply(this, arguments);
        }),
        Q(oe, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("BOTTOM")
          ) && e[16]("BOTTOM").apply(this, arguments);
        }),
        Q(ie, "pointerdown", function() {
          se(
            /*grab*/
            e[16]("LEFT")
          ) && e[16]("LEFT").apply(this, arguments);
        })
      ], Ct = !0);
    },
    p(W, R) {
      e = W, (!J || R & /*mask*/
      32 && s !== (s = /*mask*/
      e[5].x)) && c(o, "x", s), (!J || R & /*mask*/
      32 && i !== (i = /*mask*/
      e[5].y)) && c(o, "y", i), (!J || R & /*mask*/
      32 && l !== (l = /*mask*/
      e[5].w)) && c(o, "width", l), (!J || R & /*mask*/
      32 && r !== (r = /*mask*/
      e[5].h)) && c(o, "height", r), (!J || R & /*rotatedCorners*/
      64 && f !== (f = /*rotatedCorners*/
      e[6].map(kn).join(" "))) && c(a, "points", f), (!J || R & /*rotatedCorners*/
      64 && g !== (g = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2)) && c(h, "x1", g), (!J || R & /*rotatedCorners*/
      64 && m !== (m = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2)) && c(h, "y1", m), (!J || R & /*rotationHandlePos*/
      128 && w !== (w = /*rotationHandlePos*/
      e[7][0])) && c(h, "x2", w), (!J || R & /*rotationHandlePos*/
      128 && A !== (A = /*rotationHandlePos*/
      e[7][1])) && c(h, "y2", A), (!J || R & /*rotatedCorners*/
      64 && v !== (v = /*rotatedCorners*/
      e[6][0][0] + /*rotatedCorners*/
      (e[6][1][0] - /*rotatedCorners*/
      e[6][0][0]) / 2)) && c(y, "x1", v), (!J || R & /*rotatedCorners*/
      64 && p !== (p = /*rotatedCorners*/
      e[6][0][1] + /*rotatedCorners*/
      (e[6][1][1] - /*rotatedCorners*/
      e[6][0][1]) / 2)) && c(y, "y1", p), (!J || R & /*rotationHandlePos*/
      128 && k !== (k = /*rotationHandlePos*/
      e[7][0])) && c(y, "x2", k), (!J || R & /*rotationHandlePos*/
      128 && T !== (T = /*rotationHandlePos*/
      e[7][1])) && c(y, "y2", T);
      const ct = {};
      R & /*rotationHandlePos*/
      128 && (ct.x = /*rotationHandlePos*/
      e[7][0]), R & /*rotationHandlePos*/
      128 && (ct.y = /*rotationHandlePos*/
      e[7][1]), R & /*viewportScale*/
      8 && (ct.scale = /*viewportScale*/
      e[3]), P.$set(ct), (!J || R & /*rotatedCorners*/
      64 && q !== (q = /*rotatedCorners*/
      e[6].map(Pn).join(" "))) && c(I, "points", q), (!J || R & /*computedStyle*/
      2) && c(
        H,
        "style",
        /*computedStyle*/
        e[1]
      ), (!J || R & /*rotatedCorners*/
      64 && G !== (G = /*rotatedCorners*/
      e[6].map(Tn).join(" "))) && c(H, "points", G), (!J || R & /*rotatedCorners*/
      64 && _ !== (_ = /*rotatedCorners*/
      e[6][0][0])) && c(M, "x1", _), (!J || R & /*rotatedCorners*/
      64 && b !== (b = /*rotatedCorners*/
      e[6][0][1])) && c(M, "y1", b), (!J || R & /*rotatedCorners*/
      64 && E !== (E = /*rotatedCorners*/
      e[6][1][0])) && c(M, "x2", E), (!J || R & /*rotatedCorners*/
      64 && S !== (S = /*rotatedCorners*/
      e[6][1][1])) && c(M, "y2", S), (!J || R & /*rotatedCorners*/
      64 && K !== (K = /*rotatedCorners*/
      e[6][1][0])) && c(D, "x1", K), (!J || R & /*rotatedCorners*/
      64 && F !== (F = /*rotatedCorners*/
      e[6][1][1])) && c(D, "y1", F), (!J || R & /*rotatedCorners*/
      64 && Z !== (Z = /*rotatedCorners*/
      e[6][2][0])) && c(D, "x2", Z), (!J || R & /*rotatedCorners*/
      64 && ee !== (ee = /*rotatedCorners*/
      e[6][2][1])) && c(D, "y2", ee), (!J || R & /*rotatedCorners*/
      64 && Ae !== (Ae = /*rotatedCorners*/
      e[6][2][0])) && c(oe, "x1", Ae), (!J || R & /*rotatedCorners*/
      64 && X !== (X = /*rotatedCorners*/
      e[6][2][1])) && c(oe, "y1", X), (!J || R & /*rotatedCorners*/
      64 && fe !== (fe = /*rotatedCorners*/
      e[6][3][0])) && c(oe, "x2", fe), (!J || R & /*rotatedCorners*/
      64 && te !== (te = /*rotatedCorners*/
      e[6][3][1])) && c(oe, "y2", te), (!J || R & /*rotatedCorners*/
      64 && Ve !== (Ve = /*rotatedCorners*/
      e[6][3][0])) && c(ie, "x1", Ve), (!J || R & /*rotatedCorners*/
      64 && rt !== (rt = /*rotatedCorners*/
      e[6][3][1])) && c(ie, "y1", rt), (!J || R & /*rotatedCorners*/
      64 && lt !== (lt = /*rotatedCorners*/
      e[6][0][0])) && c(ie, "x2", lt), (!J || R & /*rotatedCorners*/
      64 && at !== (at = /*rotatedCorners*/
      e[6][0][1])) && c(ie, "y2", at);
      const ft = {};
      R & /*rotatedCorners*/
      64 && (ft.x = /*rotatedCorners*/
      e[6][0][0]), R & /*rotatedCorners*/
      64 && (ft.y = /*rotatedCorners*/
      e[6][0][1]), R & /*viewportScale*/
      8 && (ft.scale = /*viewportScale*/
      e[3]), Ce.$set(ft);
      const ut = {};
      R & /*rotatedCorners*/
      64 && (ut.x = /*rotatedCorners*/
      e[6][1][0]), R & /*rotatedCorners*/
      64 && (ut.y = /*rotatedCorners*/
      e[6][1][1]), R & /*viewportScale*/
      8 && (ut.scale = /*viewportScale*/
      e[3]), Ie.$set(ut);
      const dt = {};
      R & /*rotatedCorners*/
      64 && (dt.x = /*rotatedCorners*/
      e[6][2][0]), R & /*rotatedCorners*/
      64 && (dt.y = /*rotatedCorners*/
      e[6][2][1]), R & /*viewportScale*/
      8 && (dt.scale = /*viewportScale*/
      e[3]), Oe.$set(dt);
      const ht = {};
      R & /*rotatedCorners*/
      64 && (ht.x = /*rotatedCorners*/
      e[6][3][0]), R & /*rotatedCorners*/
      64 && (ht.y = /*rotatedCorners*/
      e[6][3][1]), R & /*viewportScale*/
      8 && (ht.scale = /*viewportScale*/
      e[3]), De.$set(ht);
    },
    i(W) {
      J || (V(P.$$.fragment, W), V(Ce.$$.fragment, W), V(Ie.$$.fragment, W), V(Oe.$$.fragment, W), V(De.$$.fragment, W), J = !0);
    },
    o(W) {
      j(P.$$.fragment, W), j(Ce.$$.fragment, W), j(Ie.$$.fragment, W), j(Oe.$$.fragment, W), j(De.$$.fragment, W), J = !1;
    },
    d(W) {
      W && (B(t), B(d), B(u), B(L), B(N), B(O), B(M), B(U), B(D), B(he), B(oe), B(ge), B(ie), B(kt), B(Pt), B(Tt), B(Lt)), le(P), le(Ce, W), le(Ie, W), le(Oe, W), le(De, W), Ct = !1, Me(rn);
    }
  };
}
function Bi(e) {
  let t, n;
  return t = new on({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[8]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          Ri,
          ({ grab: o }) => ({ 16: o }),
          ({ grab: o }) => o ? 65536 : 0
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "grab",
    /*grab_handler*/
    e[12]
  ), t.$on(
    "change",
    /*change_handler*/
    e[13]
  ), t.$on(
    "release",
    /*release_handler*/
    e[14]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, [s]) {
      const i = {};
      s & /*shape*/
      1 && (i.shape = /*shape*/
      o[0]), s & /*transform*/
      4 && (i.transform = /*transform*/
      o[2]), s & /*svgEl*/
      16 && (i.svgEl = /*svgEl*/
      o[4]), s & /*$$scope, rotatedCorners, viewportScale, grab, computedStyle, rotationHandlePos, mask*/
      196842 && (i.$$scope = { dirty: s, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const kn = (e) => `${e[0]},${e[1]}`, Pn = (e) => `${e[0]},${e[1]}`, Tn = (e) => `${e[0]},${e[1]}`;
function Yi(e, t, n) {
  let o, s, i, l, r, { shape: a } = t, { computedStyle: f } = t, { transform: d } = t, { viewportScale: u = 1 } = t, { svgEl: h } = t, g = !1;
  const m = (p, k, T) => {
    let { x: P, y: L, w: N, h: I, rot: q = 0 } = p.geometry;
    const [H, G] = T;
    if (k === "ROTATION") {
      const M = Sn(p.geometry, o), _ = M[0] + H, b = M[1] + G, E = [P + N / 2, L + I / 2];
      q += Di([M[0], M[1]], [_, b], E), g && (q = Ni(q));
      const S = 2 * Math.PI;
      q = (q % S + S) % S;
    } else if (k === "SHAPE")
      P += H, L += G;
    else {
      let M = 0, _ = 0, b = N, E = I;
      const [S, U] = q !== 0 ? Oi(H, G, q) : [H, G];
      switch (k) {
        case "TOP":
        case "TOP_LEFT":
        case "TOP_RIGHT":
          _ += U;
          break;
        case "BOTTOM":
        case "BOTTOM_LEFT":
        case "BOTTOM_RIGHT":
          E += U;
          break;
      }
      switch (k) {
        case "LEFT":
        case "TOP_LEFT":
        case "BOTTOM_LEFT":
          M += S;
          break;
        case "RIGHT":
        case "TOP_RIGHT":
        case "BOTTOM_RIGHT":
          b += S;
          break;
      }
      const D = (M + b) / 2, K = (_ + E) / 2;
      N = Math.abs(b - M), I = Math.abs(E - _);
      const F = [P + p.geometry.w / 2, L + p.geometry.h / 2], Z = [
        D - p.geometry.w / 2,
        K - p.geometry.h / 2
      ], ee = Math.cos(q), he = Math.sin(q), oe = F[0] + Z[0] * ee - Z[1] * he, Ae = F[1] + Z[0] * he + Z[1] * ee;
      P = oe - N / 2, L = Ae - I / 2;
    }
    const O = ue(i);
    return {
      ...p,
      geometry: { x: P, y: L, w: N, h: I, rot: q, bounds: O }
    };
  };
  Ye(() => {
    const p = (T) => {
      T.key === "Shift" && (g = !0);
    }, k = (T) => {
      T.key === "Shift" && (g = !1);
    };
    return window.addEventListener("keydown", p), window.addEventListener("keyup", k), () => {
      window.removeEventListener("keydown", p), window.removeEventListener("keyup", k);
    };
  });
  const w = `rect-mask-${Math.random().toString(36).substring(2, 12)}`;
  function A(p) {
    de.call(this, e, p);
  }
  function y(p) {
    de.call(this, e, p);
  }
  function v(p) {
    de.call(this, e, p);
  }
  return e.$$set = (p) => {
    "shape" in p && n(0, a = p.shape), "computedStyle" in p && n(1, f = p.computedStyle), "transform" in p && n(2, d = p.transform), "viewportScale" in p && n(3, u = p.viewportScale), "svgEl" in p && n(4, h = p.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    8 && n(11, o = 20 / u), e.$$.dirty & /*shape*/
    1 && n(10, s = a.geometry), e.$$.dirty & /*geom*/
    1024 && n(6, i = Ii(s.x, s.y, s.w, s.h, s.rot)), e.$$.dirty & /*geom, ROTATION_HANDLE_OFFSET*/
    3072 && n(7, l = Sn(s, o)), e.$$.dirty & /*geom, viewportScale*/
    1032 && n(5, r = St(s.bounds, 5 / u));
  }, [
    a,
    f,
    d,
    u,
    h,
    r,
    i,
    l,
    m,
    w,
    s,
    o,
    A,
    y,
    v
  ];
}
class Ui extends ye {
  constructor(t) {
    super(), _e(this, t, Yi, Bi, ae, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 3,
      svgEl: 4
    });
  }
}
var Ln = Object.prototype.hasOwnProperty;
function $t(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && $t(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (Ln.call(e, n) && ++o && !Ln.call(t, n) || !(n in t) || !$t(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
const Vi = 12, Xi = (e, t) => e.polygons.reduce((n, o, s) => {
  const i = o.rings.reduce((l, r, a) => {
    const f = r.points.map((d, u) => {
      const h = u === r.points.length - 1 ? r.points[0] : r.points[u + 1], g = (d[0] + h[0]) / 2, m = (d[1] + h[1]) / 2, A = Math.sqrt(
        Math.pow(h[0] - g, 2) + Math.pow(h[1] - m, 2)
      ) > Vi / t;
      return { point: [g, m], visible: A, elementIdx: s, ringIdx: a, pointIdx: u };
    });
    return [...l, ...f];
  }, []);
  return [...n, ...i];
}, []);
function Xt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function Cn(e, t, n) {
  const o = e.slice();
  return o[30] = t[n], o[32] = n, o;
}
function In(e, t, n) {
  const o = e.slice();
  return o[33] = t[n], o[35] = n, o;
}
function On(e, t, n) {
  const o = e.slice();
  return o[29] = t[n], o[37] = n, o;
}
function Ht(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function Gt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function Dn(e) {
  let t, n, o, s;
  return {
    c() {
      t = C("circle"), c(t, "cx", n = /*point*/
      e[29][0]), c(t, "cy", o = /*point*/
      e[29][1]), c(t, "r", s = st / /*viewportScale*/
      e[3]), c(t, "class", "svelte-1vxo6dc");
    },
    m(i, l) {
      Y(i, t, l);
    },
    p(i, l) {
      l[0] & /*midpoints, visibleMidpoint*/
      1088 && n !== (n = /*point*/
      i[29][0]) && c(t, "cx", n), l[0] & /*midpoints, visibleMidpoint*/
      1088 && o !== (o = /*point*/
      i[29][1]) && c(t, "cy", o), l[0] & /*viewportScale*/
      8 && s !== (s = st / /*viewportScale*/
      i[3]) && c(t, "r", s);
    },
    d(i) {
      i && B(t);
    }
  };
}
function Nn(e) {
  let t, n, o, s, i, l, r, a, f, d;
  return {
    c() {
      t = C("mask"), n = C("rect"), r = C("circle"), c(n, "x", o = /*mask*/
      e[9].x), c(n, "y", s = /*mask*/
      e[9].y), c(n, "width", i = /*mask*/
      e[9].w), c(n, "height", l = /*mask*/
      e[9].h), c(n, "class", "svelte-1vxo6dc"), c(r, "cx", a = /*point*/
      e[29][0]), c(r, "cy", f = /*point*/
      e[29][1]), c(r, "r", d = st / /*viewportScale*/
      e[3]), c(r, "class", "svelte-1vxo6dc"), c(t, "id", `${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-inner`), c(t, "class", "a9s-multipolygon-editor-mask svelte-1vxo6dc");
    },
    m(u, h) {
      Y(u, t, h), z(t, n), z(t, r);
    },
    p(u, h) {
      h[0] & /*mask*/
      512 && o !== (o = /*mask*/
      u[9].x) && c(n, "x", o), h[0] & /*mask*/
      512 && s !== (s = /*mask*/
      u[9].y) && c(n, "y", s), h[0] & /*mask*/
      512 && i !== (i = /*mask*/
      u[9].w) && c(n, "width", i), h[0] & /*mask*/
      512 && l !== (l = /*mask*/
      u[9].h) && c(n, "height", l), h[0] & /*midpoints, visibleMidpoint*/
      1088 && a !== (a = /*point*/
      u[29][0]) && c(r, "cx", a), h[0] & /*midpoints, visibleMidpoint*/
      1088 && f !== (f = /*point*/
      u[29][1]) && c(r, "cy", f), h[0] & /*viewportScale*/
      8 && d !== (d = st / /*viewportScale*/
      u[3]) && c(r, "r", d);
    },
    d(u) {
      u && B(t);
    }
  };
}
function Rn(e) {
  let t, n;
  function o(...s) {
    return (
      /*func*/
      e[19](
        /*elementIdx*/
        e[32],
        /*ringIdx*/
        e[35],
        /*pointIdx*/
        e[37],
        ...s
      )
    );
  }
  return t = new Xe({
    props: {
      class: "a9s-corner-handle",
      x: (
        /*point*/
        e[29][0]
      ),
      y: (
        /*point*/
        e[29][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      ),
      selected: (
        /*selectedCorners*/
        e[8].some(o)
      )
    }
  }), t.$on(
    "pointerenter",
    /*onEnterHandle*/
    e[11]
  ), t.$on(
    "pointerleave",
    /*onLeaveHandle*/
    e[12]
  ), t.$on(
    "pointerdown",
    /*onHandlePointerDown*/
    e[14]
  ), t.$on("pointerdown", function() {
    se(
      /*grab*/
      e[28](`HANDLE-${/*elementIdx*/
      e[32]}-${/*ringIdx*/
      e[35]}-${/*pointIdx*/
      e[37]}`)
    ) && e[28](`HANDLE-${/*elementIdx*/
    e[32]}-${/*ringIdx*/
    e[35]}-${/*pointIdx*/
    e[37]}`).apply(this, arguments);
  }), t.$on(
    "pointerup",
    /*onHandlePointerUp*/
    e[15](
      /*elementIdx*/
      e[32],
      /*ringIdx*/
      e[35],
      /*pointIdx*/
      e[37]
    )
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(s, i) {
      re(t, s, i), n = !0;
    },
    p(s, i) {
      e = s;
      const l = {};
      i[0] & /*geom*/
      32 && (l.x = /*point*/
      e[29][0]), i[0] & /*geom*/
      32 && (l.y = /*point*/
      e[29][1]), i[0] & /*viewportScale*/
      8 && (l.scale = /*viewportScale*/
      e[3]), i[0] & /*selectedCorners*/
      256 && (l.selected = /*selectedCorners*/
      e[8].some(o)), t.$set(l);
    },
    i(s) {
      n || (V(t.$$.fragment, s), n = !0);
    },
    o(s) {
      j(t.$$.fragment, s), n = !1;
    },
    d(s) {
      le(t, s);
    }
  };
}
function Bn(e) {
  let t, n, o = ve(
    /*ring*/
    e[33].points
  ), s = [];
  for (let l = 0; l < o.length; l += 1)
    s[l] = Rn(On(e, o, l));
  const i = (l) => j(s[l], 1, 1, () => {
    s[l] = null;
  });
  return {
    c() {
      for (let l = 0; l < s.length; l += 1)
        s[l].c();
      t = Se();
    },
    m(l, r) {
      for (let a = 0; a < s.length; a += 1)
        s[a] && s[a].m(l, r);
      Y(l, t, r), n = !0;
    },
    p(l, r) {
      if (r[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      268491048) {
        o = ve(
          /*ring*/
          l[33].points
        );
        let a;
        for (a = 0; a < o.length; a += 1) {
          const f = On(l, o, a);
          s[a] ? (s[a].p(f, r), V(s[a], 1)) : (s[a] = Rn(f), s[a].c(), V(s[a], 1), s[a].m(t.parentNode, t));
        }
        for (be(), a = o.length; a < s.length; a += 1)
          i(a);
        Ee();
      }
    },
    i(l) {
      if (!n) {
        for (let r = 0; r < o.length; r += 1)
          V(s[r]);
        n = !0;
      }
    },
    o(l) {
      s = s.filter(Boolean);
      for (let r = 0; r < s.length; r += 1)
        j(s[r]);
      n = !1;
    },
    d(l) {
      l && B(t), Ge(s, l);
    }
  };
}
function Yn(e) {
  let t, n, o, s, i, l, r, a, f, d, u, h, g, m, w, A, y, v = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && Dn(Gt(e))
  ), p = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && Nn(Ht(e))
  ), k = ve(
    /*element*/
    e[30].rings
  ), T = [];
  for (let L = 0; L < k.length; L += 1)
    T[L] = Bn(In(e, k, L));
  const P = (L) => j(T[L], 1, 1, () => {
    T[L] = null;
  });
  return {
    c() {
      t = C("g"), n = C("defs"), o = C("mask"), s = C("rect"), f = C("path"), v && v.c(), p && p.c(), u = C("path"), g = C("path");
      for (let L = 0; L < T.length; L += 1)
        T[L].c();
      c(s, "x", i = /*mask*/
      e[9].x), c(s, "y", l = /*mask*/
      e[9].y), c(s, "width", r = /*mask*/
      e[9].w), c(s, "height", a = /*mask*/
      e[9].h), c(s, "class", "svelte-1vxo6dc"), c(f, "d", d = Te(
        /*element*/
        e[30]
      )), c(f, "class", "svelte-1vxo6dc"), c(o, "id", `${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-outer`), c(o, "class", "a9s-multipolygon-editor-mask svelte-1vxo6dc"), c(u, "class", "a9s-outer"), c(u, "mask", `url(#${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-outer)`), c(u, "fill-rule", "evenodd"), c(u, "d", h = Te(
        /*element*/
        e[30]
      )), c(g, "class", "a9s-inner"), c(g, "mask", `url(#${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-inner)`), c(
        g,
        "style",
        /*computedStyle*/
        e[1]
      ), c(g, "fill-rule", "evenodd"), c(g, "d", m = Te(
        /*element*/
        e[30]
      ));
    },
    m(L, N) {
      Y(L, t, N), z(t, n), z(n, o), z(o, s), z(o, f), v && v.m(o, null), p && p.m(n, null), z(t, u), z(t, g);
      for (let I = 0; I < T.length; I += 1)
        T[I] && T[I].m(t, null);
      w = !0, A || (y = [
        Q(
          u,
          "pointerup",
          /*onShapePointerUp*/
          e[13]
        ),
        Q(u, "pointerdown", function() {
          se(
            /*grab*/
            e[28]("SHAPE")
          ) && e[28]("SHAPE").apply(this, arguments);
        }),
        Q(
          g,
          "pointerup",
          /*onShapePointerUp*/
          e[13]
        ),
        Q(g, "pointerdown", function() {
          se(
            /*grab*/
            e[28]("SHAPE")
          ) && e[28]("SHAPE").apply(this, arguments);
        })
      ], A = !0);
    },
    p(L, N) {
      if (e = L, (!w || N[0] & /*mask*/
      512 && i !== (i = /*mask*/
      e[9].x)) && c(s, "x", i), (!w || N[0] & /*mask*/
      512 && l !== (l = /*mask*/
      e[9].y)) && c(s, "y", l), (!w || N[0] & /*mask*/
      512 && r !== (r = /*mask*/
      e[9].w)) && c(s, "width", r), (!w || N[0] & /*mask*/
      512 && a !== (a = /*mask*/
      e[9].h)) && c(s, "height", a), (!w || N[0] & /*geom*/
      32 && d !== (d = Te(
        /*element*/
        e[30]
      ))) && c(f, "d", d), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? v ? v.p(Gt(e), N) : (v = Dn(Gt(e)), v.c(), v.m(o, null)) : v && (v.d(1), v = null), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? p ? p.p(Ht(e), N) : (p = Nn(Ht(e)), p.c(), p.m(n, null)) : p && (p.d(1), p = null), (!w || N[0] & /*geom*/
      32 && h !== (h = Te(
        /*element*/
        e[30]
      ))) && c(u, "d", h), (!w || N[0] & /*computedStyle*/
      2) && c(
        g,
        "style",
        /*computedStyle*/
        e[1]
      ), (!w || N[0] & /*geom*/
      32 && m !== (m = Te(
        /*element*/
        e[30]
      ))) && c(g, "d", m), N[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      268491048) {
        k = ve(
          /*element*/
          e[30].rings
        );
        let I;
        for (I = 0; I < k.length; I += 1) {
          const q = In(e, k, I);
          T[I] ? (T[I].p(q, N), V(T[I], 1)) : (T[I] = Bn(q), T[I].c(), V(T[I], 1), T[I].m(t, null));
        }
        for (be(), I = k.length; I < T.length; I += 1)
          P(I);
        Ee();
      }
    },
    i(L) {
      if (!w) {
        for (let N = 0; N < k.length; N += 1)
          V(T[N]);
        w = !0;
      }
    },
    o(L) {
      T = T.filter(Boolean);
      for (let N = 0; N < T.length; N += 1)
        j(T[N]);
      w = !1;
    },
    d(L) {
      L && B(t), v && v.d(), p && p.d(), Ge(T, L), A = !1, Me(y);
    }
  };
}
function Un(e) {
  let t, n;
  return t = new So({
    props: {
      x: (
        /*point*/
        e[29][0]
      ),
      y: (
        /*point*/
        e[29][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), t.$on("pointerdown", function() {
    se(
      /*onAddPoint*/
      e[17](
        /*visibleMidpoint*/
        e[6]
      )
    ) && e[17](
      /*visibleMidpoint*/
      e[6]
    ).apply(this, arguments);
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.x = /*point*/
      e[29][0]), s[0] & /*midpoints, visibleMidpoint*/
      1088 && (i.y = /*point*/
      e[29][1]), s[0] & /*viewportScale*/
      8 && (i.scale = /*viewportScale*/
      e[3]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Hi(e) {
  let t, n, o, s = ve(
    /*geom*/
    e[5].polygons
  ), i = [];
  for (let a = 0; a < s.length; a += 1)
    i[a] = Yn(Cn(e, s, a));
  const l = (a) => j(i[a], 1, 1, () => {
    i[a] = null;
  });
  let r = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && Un(Xt(e))
  );
  return {
    c() {
      for (let a = 0; a < i.length; a += 1)
        i[a].c();
      t = we(), r && r.c(), n = Se();
    },
    m(a, f) {
      for (let d = 0; d < i.length; d += 1)
        i[d] && i[d].m(a, f);
      Y(a, t, f), r && r.m(a, f), Y(a, n, f), o = !0;
    },
    p(a, f) {
      if (f[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp, maskId, computedStyle, onShapePointerUp, midpoints, visibleMidpoint, mask, isHandleHovered*/
      268763114) {
        s = ve(
          /*geom*/
          a[5].polygons
        );
        let d;
        for (d = 0; d < s.length; d += 1) {
          const u = Cn(a, s, d);
          i[d] ? (i[d].p(u, f), V(i[d], 1)) : (i[d] = Yn(u), i[d].c(), V(i[d], 1), i[d].m(t.parentNode, t));
        }
        for (be(), d = s.length; d < i.length; d += 1)
          l(d);
        Ee();
      }
      /*visibleMidpoint*/
      a[6] !== void 0 && !/*isHandleHovered*/
      a[7] ? r ? (r.p(Xt(a), f), f[0] & /*visibleMidpoint, isHandleHovered*/
      192 && V(r, 1)) : (r = Un(Xt(a)), r.c(), V(r, 1), r.m(n.parentNode, n)) : r && (be(), j(r, 1, 1, () => {
        r = null;
      }), Ee());
    },
    i(a) {
      if (!o) {
        for (let f = 0; f < s.length; f += 1)
          V(i[f]);
        V(r), o = !0;
      }
    },
    o(a) {
      i = i.filter(Boolean);
      for (let f = 0; f < i.length; f += 1)
        j(i[f]);
      j(r), o = !1;
    },
    d(a) {
      a && (B(t), B(n)), Ge(i, a), r && r.d(a);
    }
  };
}
function Gi(e) {
  let t, n;
  return t = new on({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[16]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          Hi,
          ({ grab: o }) => ({ 28: o }),
          ({ grab: o }) => [o ? 268435456 : 0]
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    e[20]
  ), t.$on(
    "grab",
    /*grab_handler*/
    e[21]
  ), t.$on(
    "release",
    /*release_handler*/
    e[22]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*shape*/
      1 && (i.shape = /*shape*/
      o[0]), s[0] & /*transform*/
      4 && (i.transform = /*transform*/
      o[2]), s[0] & /*svgEl*/
      16 && (i.svgEl = /*svgEl*/
      o[4]), s[0] & /*midpoints, visibleMidpoint, viewportScale, isHandleHovered, geom, selectedCorners, grab, computedStyle, mask*/
      268437482 | s[1] & /*$$scope*/
      128 && (i.$$scope = { dirty: s, ctx: o }), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const ji = 250, Fi = 1e3, st = 4.5;
function zi(e, t, n) {
  let o, s, i;
  const l = Ue();
  let { shape: r } = t, { computedStyle: a } = t, { transform: f } = t, { viewportScale: d = 1 } = t, { svgEl: u } = t, h, g = !1, m, w = [];
  const A = () => n(7, g = !0), y = () => n(7, g = !1), v = (_) => {
    if (w.length > 0 || !s.some((Z) => Z.visible)) {
      n(6, h = void 0);
      return;
    }
    const [b, E] = f.elementToImage(_.offsetX, _.offsetY), S = (Z) => Math.pow(Z[0] - b, 2) + Math.pow(Z[1] - E, 2), U = xo(o).reduce((Z, ee) => S(ee) < S(Z) ? ee : Z), D = s.filter((Z) => Z.visible).reduce((Z, ee) => S(ee.point) < S(Z.point) ? ee : Z), K = Math.pow(Fi / d, 2);
    S(U) < K || S(D.point) < K ? n(6, h = s.indexOf(D)) : n(6, h = void 0);
  }, p = () => {
    document.activeElement !== u && u.focus();
  }, k = () => {
    n(8, w = []), p();
  }, T = (_) => {
    n(7, g = !0), _.preventDefault(), _.stopPropagation(), m = performance.now();
  }, P = (_, b, E) => (S) => {
    if (!m || Le || performance.now() - m > ji) return;
    const U = (K) => K.polygon === _ && K.ring === b && K.point === E, D = w.some(U);
    S.metaKey || S.ctrlKey || S.shiftKey ? D ? n(8, w = w.filter((K) => !U(K))) : n(8, w = [...w, { polygon: _, ring: b, point: E }]) : D && w.length > 1 ? n(8, w = [{ polygon: _, ring: b, point: E }]) : D ? n(8, w = []) : n(8, w = [{ polygon: _, ring: b, point: E }]), p();
  }, L = (_, b, E) => {
    p();
    const S = _.geometry.polygons;
    let U;
    if (b === "SHAPE")
      U = S.map((D) => {
        const K = D.rings.map((Z, ee) => ({ points: Z.points.map((oe, Ae) => [oe[0] + E[0], oe[1] + E[1]]) })), F = ue(K[0].points);
        return { rings: K, bounds: F };
      });
    else {
      const [D, K, F, Z] = b.split("-").map((ee) => parseInt(ee));
      U = S.map((ee, he) => {
        if (he === K) {
          const oe = ee.rings.map((X, fe) => fe === F ? { points: X.points.map((ge, ie) => ie === Z ? [ge[0] + E[0], ge[1] + E[1]] : ge) } : X), Ae = ue(oe[0].points);
          return { rings: oe, bounds: Ae };
        } else
          return ee;
      });
    }
    return {
      ..._,
      geometry: {
        polygons: U,
        bounds: yt(U)
      }
    };
  }, N = (_) => async (b) => {
    b.stopPropagation();
    const E = s[_], S = o.polygons.map((D, K) => {
      if (K === E.elementIdx) {
        const F = D.rings.map((ee, he) => he === E.ringIdx ? { points: [
          ...ee.points.slice(0, E.pointIdx + 1),
          E.point,
          ...ee.points.slice(E.pointIdx + 1)
        ] } : ee), Z = ue(F[0].points);
        return { rings: F, bounds: Z };
      } else
        return D;
    });
    l("change", {
      ...r,
      geometry: {
        polygons: S,
        bounds: yt(S)
      }
    }), await co();
    const U = [...document.querySelectorAll(".a9s-handle")][_ + 1];
    if (U != null && U.firstChild) {
      const D = new PointerEvent(
        "pointerdown",
        {
          bubbles: !0,
          cancelable: !0,
          clientX: b.clientX,
          clientY: b.clientY,
          pointerId: b.pointerId,
          pointerType: b.pointerType,
          isPrimary: b.isPrimary,
          buttons: b.buttons
        }
      );
      U.firstChild.dispatchEvent(D);
    }
  }, I = () => {
    const _ = o.polygons.map((E, S) => {
      if (w.some((D) => D.polygon === S)) {
        const D = E.rings.map((F, Z) => {
          const ee = w.filter((he) => he.polygon === S && he.ring === Z);
          return ee.length && F.points.length - ee.length >= 3 ? { points: F.points.filter((oe, Ae) => !ee.some((X) => X.point === Ae)) } : F;
        }), K = ue(D[0].points);
        return { rings: D, bounds: K };
      } else
        return E;
    });
    !$t(o.polygons, _) && (l("change", {
      ...r,
      geometry: {
        polygons: _,
        bounds: yt(_)
      }
    }), n(8, w = []));
  };
  Ye(() => {
    if (Le) return;
    const _ = (b) => {
      (b.key === "Delete" || b.key === "Backspace") && (b.preventDefault(), I());
    };
    return u.addEventListener("pointermove", v), u.addEventListener("keydown", _), () => {
      u.removeEventListener("pointermove", v), u.removeEventListener("keydown", _);
    };
  });
  const q = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`, H = (_, b, E, { polygon: S, ring: U, point: D }) => S === _ && U === b && D === E;
  function G(_) {
    de.call(this, e, _);
  }
  function O(_) {
    de.call(this, e, _);
  }
  function M(_) {
    de.call(this, e, _);
  }
  return e.$$set = (_) => {
    "shape" in _ && n(0, r = _.shape), "computedStyle" in _ && n(1, a = _.computedStyle), "transform" in _ && n(2, f = _.transform), "viewportScale" in _ && n(3, d = _.viewportScale), "svgEl" in _ && n(4, u = _.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*shape*/
    1 && n(5, o = r.geometry), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(10, s = Le ? [] : Xi(o, d)), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(9, i = St(o.bounds, st / d));
  }, [
    r,
    a,
    f,
    d,
    u,
    o,
    h,
    g,
    w,
    i,
    s,
    A,
    y,
    k,
    T,
    P,
    L,
    N,
    q,
    H,
    G,
    O,
    M
  ];
}
class qi extends ye {
  constructor(t) {
    super(), _e(
      this,
      t,
      zi,
      Gi,
      ae,
      {
        shape: 0,
        computedStyle: 1,
        transform: 2,
        viewportScale: 3,
        svgEl: 4
      },
      null,
      [-1, -1]
    );
  }
}
const Po = /* @__PURE__ */ new Map([
  [x.RECTANGLE, Ui],
  [x.POLYGON, Ci],
  [x.MULTIPOLYGON, qi]
]), Ki = (e) => Po.get(e.type), Wi = (e, t) => Po.set(e, t);
function Zi(e, t, n) {
  let o;
  const s = Ue();
  let { annotation: i } = t, { editor: l } = t, { style: r } = t, { target: a } = t, { transform: f } = t, { viewportScale: d } = t, u;
  return Ye(() => (n(6, u = new l({
    target: a,
    props: {
      shape: i.target.selector,
      computedStyle: o,
      transform: f,
      viewportScale: d,
      svgEl: a.closest("svg")
    }
  })), u.$on("change", (h) => {
    u.$$set({ shape: h.detail }), s("change", h.detail);
  }), u.$on("grab", (h) => s("grab", h.detail)), u.$on("release", (h) => s("release", h.detail)), () => {
    u.$destroy();
  })), e.$$set = (h) => {
    "annotation" in h && n(0, i = h.annotation), "editor" in h && n(1, l = h.editor), "style" in h && n(2, r = h.style), "target" in h && n(3, a = h.target), "transform" in h && n(4, f = h.transform), "viewportScale" in h && n(5, d = h.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    5 && n(7, o = je(i, r, { selected: !0, hovered: !0 })), e.$$.dirty & /*annotation, editorComponent*/
    65 && i && (u == null || u.$set({ shape: i.target.selector })), e.$$.dirty & /*editorComponent, transform*/
    80 && u && u.$set({ transform: f }), e.$$.dirty & /*editorComponent, viewportScale*/
    96 && u && u.$set({ viewportScale: d }), e.$$.dirty & /*editorComponent, computedStyle*/
    192 && u && o && u.$set({ computedStyle: o });
  }, [
    i,
    l,
    r,
    a,
    f,
    d,
    u,
    o
  ];
}
class Ji extends ye {
  constructor(t) {
    super(), _e(this, t, Zi, null, ae, {
      annotation: 0,
      editor: 1,
      style: 2,
      target: 3,
      transform: 4,
      viewportScale: 5
    });
  }
}
function Qi(e, t, n) {
  const o = Ue();
  let { drawingMode: s } = t, { target: i } = t, { tool: l } = t, { transform: r } = t, { viewportScale: a } = t, f;
  return Ye(() => {
    const d = i.closest("svg"), u = [], h = (g, m, w) => {
      d == null || d.addEventListener(g, m, w), u.push(() => d == null ? void 0 : d.removeEventListener(g, m, w));
    };
    return n(5, f = new l({
      target: i,
      props: {
        addEventListener: h,
        drawingMode: s,
        transform: r,
        viewportScale: a
      }
    })), f.$on("create", (g) => o("create", g.detail)), () => {
      u.forEach((g) => g()), f.$destroy();
    };
  }), e.$$set = (d) => {
    "drawingMode" in d && n(0, s = d.drawingMode), "target" in d && n(1, i = d.target), "tool" in d && n(2, l = d.tool), "transform" in d && n(3, r = d.transform), "viewportScale" in d && n(4, a = d.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*toolComponent, transform*/
    40 && f && f.$set({ transform: r }), e.$$.dirty & /*toolComponent, viewportScale*/
    48 && f && f.$set({ viewportScale: a });
  }, [s, i, l, r, a, f];
}
class xi extends ye {
  constructor(t) {
    super(), _e(this, t, Qi, null, ae, {
      drawingMode: 0,
      target: 1,
      tool: 2,
      transform: 3,
      viewportScale: 4
    });
  }
}
function Vn(e) {
  let t, n, o, s, i, l, r, a, f, d;
  return {
    c() {
      t = C("defs"), n = C("mask"), o = C("rect"), a = C("rect"), f = C("rect"), d = C("rect"), c(o, "class", "rect-mask-bg svelte-1a76qe7"), c(o, "x", s = /*x*/
      e[1] - /*buffer*/
      e[5]), c(o, "y", i = /*y*/
      e[2] - /*buffer*/
      e[5]), c(o, "width", l = /*w*/
      e[3] + 2 * /*buffer*/
      e[5]), c(o, "height", r = /*h*/
      e[4] + 2 * /*buffer*/
      e[5]), c(a, "class", "rect-mask-fg svelte-1a76qe7"), c(
        a,
        "x",
        /*x*/
        e[1]
      ), c(
        a,
        "y",
        /*y*/
        e[2]
      ), c(
        a,
        "width",
        /*w*/
        e[3]
      ), c(
        a,
        "height",
        /*h*/
        e[4]
      ), c(
        n,
        "id",
        /*maskId*/
        e[6]
      ), c(n, "class", "a9s-rubberband-rectangle-mask svelte-1a76qe7"), c(f, "class", "a9s-outer"), c(f, "mask", `url(#${/*maskId*/
      e[6]})`), c(
        f,
        "x",
        /*x*/
        e[1]
      ), c(
        f,
        "y",
        /*y*/
        e[2]
      ), c(
        f,
        "width",
        /*w*/
        e[3]
      ), c(
        f,
        "height",
        /*h*/
        e[4]
      ), c(d, "class", "a9s-inner"), c(
        d,
        "x",
        /*x*/
        e[1]
      ), c(
        d,
        "y",
        /*y*/
        e[2]
      ), c(
        d,
        "width",
        /*w*/
        e[3]
      ), c(
        d,
        "height",
        /*h*/
        e[4]
      );
    },
    m(u, h) {
      Y(u, t, h), z(t, n), z(n, o), z(n, a), Y(u, f, h), Y(u, d, h);
    },
    p(u, h) {
      h & /*x, buffer*/
      34 && s !== (s = /*x*/
      u[1] - /*buffer*/
      u[5]) && c(o, "x", s), h & /*y, buffer*/
      36 && i !== (i = /*y*/
      u[2] - /*buffer*/
      u[5]) && c(o, "y", i), h & /*w, buffer*/
      40 && l !== (l = /*w*/
      u[3] + 2 * /*buffer*/
      u[5]) && c(o, "width", l), h & /*h, buffer*/
      48 && r !== (r = /*h*/
      u[4] + 2 * /*buffer*/
      u[5]) && c(o, "height", r), h & /*x*/
      2 && c(
        a,
        "x",
        /*x*/
        u[1]
      ), h & /*y*/
      4 && c(
        a,
        "y",
        /*y*/
        u[2]
      ), h & /*w*/
      8 && c(
        a,
        "width",
        /*w*/
        u[3]
      ), h & /*h*/
      16 && c(
        a,
        "height",
        /*h*/
        u[4]
      ), h & /*x*/
      2 && c(
        f,
        "x",
        /*x*/
        u[1]
      ), h & /*y*/
      4 && c(
        f,
        "y",
        /*y*/
        u[2]
      ), h & /*w*/
      8 && c(
        f,
        "width",
        /*w*/
        u[3]
      ), h & /*h*/
      16 && c(
        f,
        "height",
        /*h*/
        u[4]
      ), h & /*x*/
      2 && c(
        d,
        "x",
        /*x*/
        u[1]
      ), h & /*y*/
      4 && c(
        d,
        "y",
        /*y*/
        u[2]
      ), h & /*w*/
      8 && c(
        d,
        "width",
        /*w*/
        u[3]
      ), h & /*h*/
      16 && c(
        d,
        "height",
        /*h*/
        u[4]
      );
    },
    d(u) {
      u && (B(t), B(f), B(d));
    }
  };
}
function $i(e) {
  let t, n = (
    /*origin*/
    e[0] && Vn(e)
  );
  return {
    c() {
      t = C("g"), n && n.c(), c(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(o, s) {
      Y(o, t, s), n && n.m(t, null);
    },
    p(o, [s]) {
      /*origin*/
      o[0] ? n ? n.p(o, s) : (n = Vn(o), n.c(), n.m(t, null)) : n && (n.d(1), n = null);
    },
    i: $,
    o: $,
    d(o) {
      o && B(t), n && n.d();
    }
  };
}
function er(e, t, n) {
  let o;
  const s = Ue();
  let { addEventListener: i } = t, { drawingMode: l } = t, { transform: r } = t, { viewportScale: a = 1 } = t, f, d, u, h, g, m, w;
  const A = (T) => {
    const P = T;
    f = performance.now(), l === "drag" && (n(0, d = r.elementToImage(P.offsetX, P.offsetY)), u = d, n(1, h = d[0]), n(2, g = d[1]), n(3, m = 1), n(4, w = 1));
  }, y = (T) => {
    const P = T;
    d && (u = r.elementToImage(P.offsetX, P.offsetY), n(1, h = Math.min(u[0], d[0])), n(2, g = Math.min(u[1], d[1])), n(3, m = Math.abs(u[0] - d[0])), n(4, w = Math.abs(u[1] - d[1])));
  }, v = (T) => {
    const P = T, L = performance.now() - f;
    if (l === "click") {
      if (L > 300) return;
      d ? p() : (n(0, d = r.elementToImage(P.offsetX, P.offsetY)), u = d, n(1, h = d[0]), n(2, g = d[1]), n(3, m = 1), n(4, w = 1));
    } else d && (L > 300 || m * w > 100 ? (P.stopPropagation(), p()) : (n(0, d = void 0), u = void 0));
  }, p = () => {
    if (m * w > 15) {
      const T = {
        type: x.RECTANGLE,
        geometry: {
          bounds: {
            minX: h,
            minY: g,
            maxX: h + m,
            maxY: g + w
          },
          rot: 0,
          x: h,
          y: g,
          w: m,
          h: w
        }
      };
      s("create", T);
    }
    n(0, d = void 0), u = void 0;
  };
  Ye(() => {
    i("pointerdown", A), i("pointermove", y), i("pointerup", v, !0);
  });
  const k = `rect-mask-${Math.random().toString(36).substring(2, 12)}`;
  return e.$$set = (T) => {
    "addEventListener" in T && n(7, i = T.addEventListener), "drawingMode" in T && n(8, l = T.drawingMode), "transform" in T && n(9, r = T.transform), "viewportScale" in T && n(10, a = T.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    1024 && n(5, o = 2 / a);
  }, [
    d,
    h,
    g,
    m,
    w,
    o,
    k,
    i,
    l,
    r,
    a
  ];
}
class tr extends ye {
  constructor(t) {
    super(), _e(this, t, er, $i, ae, {
      addEventListener: 7,
      drawingMode: 8,
      transform: 9,
      viewportScale: 10
    });
  }
}
function jt(e) {
  const t = e.slice(), n = (
    /*coords*/
    t[2].map((o) => o.join(",")).join(" ")
  );
  return t[19] = n, t;
}
function Xn(e) {
  let t, n, o, s, i, l, r, a, f, d, u, h, g, m, w = (
    /*isClosable*/
    e[1] && Hn(e)
  );
  return {
    c() {
      t = C("defs"), n = C("mask"), o = C("rect"), a = C("polygon"), d = C("polygon"), h = C("polygon"), w && w.c(), m = Se(), c(o, "x", s = /*mask*/
      e[3].x), c(o, "y", i = /*mask*/
      e[3].y), c(o, "width", l = /*mask*/
      e[3].w), c(o, "height", r = /*mask*/
      e[3].h), c(o, "class", "svelte-18wrg3t"), c(a, "points", f = /*str*/
      e[19]), c(a, "class", "svelte-18wrg3t"), c(
        n,
        "id",
        /*maskId*/
        e[5]
      ), c(n, "class", "a9s-rubberband-polygon-mask svelte-18wrg3t"), c(d, "class", "a9s-outer"), c(d, "mask", `url(#${/*maskId*/
      e[5]})`), c(d, "points", u = /*str*/
      e[19]), c(h, "class", "a9s-inner"), c(h, "points", g = /*str*/
      e[19]);
    },
    m(A, y) {
      Y(A, t, y), z(t, n), z(n, o), z(n, a), Y(A, d, y), Y(A, h, y), w && w.m(A, y), Y(A, m, y);
    },
    p(A, y) {
      y & /*mask*/
      8 && s !== (s = /*mask*/
      A[3].x) && c(o, "x", s), y & /*mask*/
      8 && i !== (i = /*mask*/
      A[3].y) && c(o, "y", i), y & /*mask*/
      8 && l !== (l = /*mask*/
      A[3].w) && c(o, "width", l), y & /*mask*/
      8 && r !== (r = /*mask*/
      A[3].h) && c(o, "height", r), y & /*coords*/
      4 && f !== (f = /*str*/
      A[19]) && c(a, "points", f), y & /*coords*/
      4 && u !== (u = /*str*/
      A[19]) && c(d, "points", u), y & /*coords*/
      4 && g !== (g = /*str*/
      A[19]) && c(h, "points", g), /*isClosable*/
      A[1] ? w ? w.p(A, y) : (w = Hn(A), w.c(), w.m(m.parentNode, m)) : w && (w.d(1), w = null);
    },
    d(A) {
      A && (B(t), B(d), B(h), B(m)), w && w.d(A);
    }
  };
}
function Hn(e) {
  let t, n, o;
  return {
    c() {
      t = C("circle"), c(t, "class", "a9s-handle svelte-18wrg3t"), c(t, "cx", n = /*points*/
      e[0][0][0]), c(t, "cy", o = /*points*/
      e[0][0][1]), c(
        t,
        "r",
        /*handleRadius*/
        e[4]
      );
    },
    m(s, i) {
      Y(s, t, i);
    },
    p(s, i) {
      i & /*points*/
      1 && n !== (n = /*points*/
      s[0][0][0]) && c(t, "cx", n), i & /*points*/
      1 && o !== (o = /*points*/
      s[0][0][1]) && c(t, "cy", o), i & /*handleRadius*/
      16 && c(
        t,
        "r",
        /*handleRadius*/
        s[4]
      );
    },
    d(s) {
      s && B(t);
    }
  };
}
function nr(e) {
  let t, n = (
    /*mask*/
    e[3] && Xn(jt(e))
  );
  return {
    c() {
      t = C("g"), n && n.c(), c(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(o, s) {
      Y(o, t, s), n && n.m(t, null);
    },
    p(o, [s]) {
      /*mask*/
      o[3] ? n ? n.p(jt(o), s) : (n = Xn(jt(o)), n.c(), n.m(t, null)) : n && (n.d(1), n = null);
    },
    i: $,
    o: $,
    d(o) {
      o && B(t), n && n.d();
    }
  };
}
const or = 20, sr = 1500;
function ir(e, t, n) {
  let o, s, i;
  const l = Ue();
  let { addEventListener: r } = t, { drawingMode: a } = t, { transform: f } = t, { viewportScale: d = 1 } = t, u, h = [], g, m, w = !1;
  const A = (P) => {
    const L = P, { timeStamp: N, offsetX: I, offsetY: q } = L;
    if (u = { timeStamp: N, offsetX: I, offsetY: q }, a === "drag" && h.length === 0) {
      const H = f.elementToImage(L.offsetX, L.offsetY);
      h.push(H), n(10, g = H);
    }
  }, y = (P) => {
    const L = P;
    if (m && clearTimeout(m), h.length > 0) {
      if (n(10, g = f.elementToImage(L.offsetX, L.offsetY)), h.length > 2) {
        const N = _t(g, h[0]) * d;
        n(1, w = N < or);
      }
      L.pointerType === "touch" && (m = setTimeout(
        () => {
          p();
        },
        sr
      ));
    }
  }, v = (P) => {
    const L = P;
    if (m && clearTimeout(m), a === "click") {
      const N = L.timeStamp - u.timeStamp, I = _t([u.offsetX, u.offsetY], [L.offsetX, L.offsetY]);
      if (N > 300 || I > 15) return;
      if (w)
        k();
      else if (h.length === 0) {
        const q = f.elementToImage(L.offsetX, L.offsetY);
        h.push(q), n(10, g = q);
      } else
        g && h.push(g);
    } else {
      if (!g) return;
      if (h.length === 1 && _t(h[0], g) <= 4) {
        n(0, h = []), n(10, g = void 0);
        return;
      }
      L.stopImmediatePropagation(), w ? k() : h.push(g);
    }
  }, p = () => {
    if (!g) return;
    const P = h.slice(0, -1);
    if (P.length < 3) return;
    const L = {
      type: x.POLYGON,
      geometry: {
        bounds: ue(h),
        points: P
      }
    };
    Jt(L) > 4 && (n(0, h = []), n(10, g = void 0), l("create", L));
  }, k = () => {
    const P = {
      type: x.POLYGON,
      geometry: {
        bounds: ue(h),
        points: [...h]
      }
    };
    n(0, h = []), n(10, g = void 0), l("create", P);
  };
  Ye(() => {
    r("pointerdown", A, !0), r("pointermove", y), r("pointerup", v, !0), r("dblclick", p, !0);
  });
  const T = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`;
  return e.$$set = (P) => {
    "addEventListener" in P && n(6, r = P.addEventListener), "drawingMode" in P && n(7, a = P.drawingMode), "transform" in P && n(8, f = P.transform), "viewportScale" in P && n(9, d = P.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    512 && n(4, o = 4 / d), e.$$.dirty & /*cursor, isClosable, points*/
    1027 && n(2, s = g ? w ? h : [...h, g] : []), e.$$.dirty & /*coords, viewportScale*/
    516 && n(3, i = s.length > 0 ? St(ue(s), 2 / d) : void 0);
  }, [
    h,
    w,
    s,
    i,
    o,
    T,
    r,
    a,
    f,
    d,
    g
  ];
}
class rr extends ye {
  constructor(t) {
    super(), _e(this, t, ir, nr, ae, {
      addEventListener: 6,
      drawingMode: 7,
      transform: 8,
      viewportScale: 9
    });
  }
}
const sn = /* @__PURE__ */ new Map([
  ["rectangle", { tool: tr }],
  ["polygon", { tool: rr }]
]), To = () => [...sn.keys()], Lo = (e) => sn.get(e), lr = (e, t, n = {}) => sn.set(e, { tool: t, opts: n });
function ar(e) {
  let t, n, o, s, i;
  return {
    c() {
      t = C("g"), n = C("ellipse"), s = C("ellipse"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "cx",
        /*cx*/
        e[2]
      ), c(
        n,
        "cy",
        /*cy*/
        e[3]
      ), c(
        n,
        "rx",
        /*rx*/
        e[4]
      ), c(
        n,
        "ry",
        /*ry*/
        e[5]
      ), c(s, "class", "a9s-inner"), c(
        s,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        s,
        "cx",
        /*cx*/
        e[2]
      ), c(
        s,
        "cy",
        /*cy*/
        e[3]
      ), c(
        s,
        "rx",
        /*rx*/
        e[4]
      ), c(
        s,
        "ry",
        /*ry*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", i = /*annotation*/
      e[0].id);
    },
    m(l, r) {
      Y(l, t, r), z(t, n), z(t, s);
    },
    p(l, [r]) {
      r & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      l[1] ? "display:none;" : void 0) && c(n, "style", o), r & /*computedStyle*/
      2 && c(
        s,
        "style",
        /*computedStyle*/
        l[1]
      ), r & /*annotation*/
      1 && i !== (i = /*annotation*/
      l[0].id) && c(t, "data-id", i);
    },
    i: $,
    o: $,
    d(l) {
      l && B(t);
    }
  };
}
function cr(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { cx: r, cy: a, rx: f, ry: d } = i;
  return e.$$set = (u) => {
    "annotation" in u && n(0, s = u.annotation), "geom" in u && n(6, i = u.geom), "style" in u && n(7, l = u.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(1, o = je(s, l));
  }, [s, o, r, a, f, d, i, l];
}
class fr extends ye {
  constructor(t) {
    super(), _e(this, t, cr, ar, ae, { annotation: 0, geom: 6, style: 7 });
  }
}
function ur(e) {
  let t, n, o, s, i;
  return {
    c() {
      t = C("g"), n = C("line"), s = C("line"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "x1",
        /*x1*/
        e[2]
      ), c(
        n,
        "y1",
        /*y1*/
        e[3]
      ), c(
        n,
        "x2",
        /*x2*/
        e[4]
      ), c(
        n,
        "y2",
        /*y2*/
        e[5]
      ), c(s, "class", "a9s-inner"), c(
        s,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        s,
        "x1",
        /*x1*/
        e[2]
      ), c(
        s,
        "y1",
        /*y1*/
        e[3]
      ), c(
        s,
        "x2",
        /*x2*/
        e[4]
      ), c(
        s,
        "y2",
        /*y2*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", i = /*annotation*/
      e[0].id);
    },
    m(l, r) {
      Y(l, t, r), z(t, n), z(t, s);
    },
    p(l, [r]) {
      r & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      l[1] ? "display:none;" : void 0) && c(n, "style", o), r & /*computedStyle*/
      2 && c(
        s,
        "style",
        /*computedStyle*/
        l[1]
      ), r & /*annotation*/
      1 && i !== (i = /*annotation*/
      l[0].id) && c(t, "data-id", i);
    },
    i: $,
    o: $,
    d(l) {
      l && B(t);
    }
  };
}
function dr(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { points: r } = i, [[a, f], [d, u]] = r;
  return e.$$set = (h) => {
    "annotation" in h && n(0, s = h.annotation), "geom" in h && n(6, i = h.geom), "style" in h && n(7, l = h.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(1, o = je(s, l));
  }, [s, o, a, f, d, u, i, l];
}
class hr extends ye {
  constructor(t) {
    super(), _e(this, t, dr, ur, ae, { annotation: 0, geom: 6, style: 7 });
  }
}
function Gn(e, t, n) {
  const o = e.slice();
  return o[5] = t[n], o;
}
function jn(e) {
  let t, n, o;
  return {
    c() {
      t = C("path"), o = C("path"), c(t, "class", "a9s-outer"), c(t, "style", n = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(t, "fill-rule", "evenodd"), c(t, "d", Te(
        /*polygonElement*/
        e[5]
      )), c(o, "class", "a9s-inner"), c(
        o,
        "style",
        /*computedStyle*/
        e[1]
      ), c(o, "fill-rule", "evenodd"), c(o, "d", Te(
        /*polygonElement*/
        e[5]
      ));
    },
    m(s, i) {
      Y(s, t, i), Y(s, o, i);
    },
    p(s, i) {
      i & /*computedStyle*/
      2 && n !== (n = /*computedStyle*/
      s[1] ? "display:none;" : void 0) && c(t, "style", n), i & /*computedStyle*/
      2 && c(
        o,
        "style",
        /*computedStyle*/
        s[1]
      );
    },
    d(s) {
      s && (B(t), B(o));
    }
  };
}
function gr(e) {
  let t, n, o = ve(
    /*polygons*/
    e[2]
  ), s = [];
  for (let i = 0; i < o.length; i += 1)
    s[i] = jn(Gn(e, o, i));
  return {
    c() {
      t = C("g");
      for (let i = 0; i < s.length; i += 1)
        s[i].c();
      c(t, "class", "a9s-annotation"), c(t, "data-id", n = /*annotation*/
      e[0].id);
    },
    m(i, l) {
      Y(i, t, l);
      for (let r = 0; r < s.length; r += 1)
        s[r] && s[r].m(t, null);
    },
    p(i, [l]) {
      if (l & /*computedStyle, polygons, undefined*/
      6) {
        o = ve(
          /*polygons*/
          i[2]
        );
        let r;
        for (r = 0; r < o.length; r += 1) {
          const a = Gn(i, o, r);
          s[r] ? s[r].p(a, l) : (s[r] = jn(a), s[r].c(), s[r].m(t, null));
        }
        for (; r < s.length; r += 1)
          s[r].d(1);
        s.length = o.length;
      }
      l & /*annotation*/
      1 && n !== (n = /*annotation*/
      i[0].id) && c(t, "data-id", n);
    },
    i: $,
    o: $,
    d(i) {
      i && B(t), Ge(s, i);
    }
  };
}
function mr(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { polygons: r } = i;
  return e.$$set = (a) => {
    "annotation" in a && n(0, s = a.annotation), "geom" in a && n(3, i = a.geom), "style" in a && n(4, l = a.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    17 && n(1, o = je(s, l));
  }, [s, o, r, i, l];
}
class pr extends ye {
  constructor(t) {
    super(), _e(this, t, mr, gr, ae, { annotation: 0, geom: 3, style: 4 });
  }
}
function _r(e) {
  let t, n, o, s, i;
  return {
    c() {
      t = C("g"), n = C("polygon"), s = C("polygon"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "points",
        /*points*/
        e[2].map(yr).join(" ")
      ), c(s, "class", "a9s-inner"), c(
        s,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        s,
        "points",
        /*points*/
        e[2].map(wr).join(" ")
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", i = /*annotation*/
      e[0].id);
    },
    m(l, r) {
      Y(l, t, r), z(t, n), z(t, s);
    },
    p(l, [r]) {
      r & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      l[1] ? "display:none;" : void 0) && c(n, "style", o), r & /*computedStyle*/
      2 && c(
        s,
        "style",
        /*computedStyle*/
        l[1]
      ), r & /*annotation*/
      1 && i !== (i = /*annotation*/
      l[0].id) && c(t, "data-id", i);
    },
    i: $,
    o: $,
    d(l) {
      l && B(t);
    }
  };
}
const yr = (e) => e.join(","), wr = (e) => e.join(",");
function br(e, t, n) {
  let o, { annotation: s } = t, { geom: i } = t, { style: l } = t;
  const { points: r } = i;
  return e.$$set = (a) => {
    "annotation" in a && n(0, s = a.annotation), "geom" in a && n(3, i = a.geom), "style" in a && n(4, l = a.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    17 && n(1, o = je(s, l));
  }, [s, o, r, i, l];
}
class Er extends ye {
  constructor(t) {
    super(), _e(this, t, br, _r, ae, { annotation: 0, geom: 3, style: 4 });
  }
}
function vr(e) {
  let t, n, o, s, i, l, r;
  return {
    c() {
      t = C("g"), n = C("path"), i = C("path"), c(n, "class", o = Ze(`a9s-outer ${/*cssClass*/
      e[1]}`) + " svelte-1w0132l"), c(n, "style", s = /*computedStyle*/
      e[3] ? "display:none;" : void 0), c(
        n,
        "d",
        /*d*/
        e[2]
      ), c(i, "class", l = Ze(`a9s-inner ${/*cssClass*/
      e[1]}`) + " svelte-1w0132l"), c(
        i,
        "style",
        /*computedStyle*/
        e[3]
      ), c(
        i,
        "d",
        /*d*/
        e[2]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", r = /*annotation*/
      e[0].id);
    },
    m(a, f) {
      Y(a, t, f), z(t, n), z(t, i);
    },
    p(a, [f]) {
      f & /*cssClass*/
      2 && o !== (o = Ze(`a9s-outer ${/*cssClass*/
      a[1]}`) + " svelte-1w0132l") && c(n, "class", o), f & /*computedStyle*/
      8 && s !== (s = /*computedStyle*/
      a[3] ? "display:none;" : void 0) && c(n, "style", s), f & /*d*/
      4 && c(
        n,
        "d",
        /*d*/
        a[2]
      ), f & /*cssClass*/
      2 && l !== (l = Ze(`a9s-inner ${/*cssClass*/
      a[1]}`) + " svelte-1w0132l") && c(i, "class", l), f & /*computedStyle*/
      8 && c(
        i,
        "style",
        /*computedStyle*/
        a[3]
      ), f & /*d*/
      4 && c(
        i,
        "d",
        /*d*/
        a[2]
      ), f & /*annotation*/
      1 && r !== (r = /*annotation*/
      a[0].id) && c(t, "data-id", r);
    },
    i: $,
    o: $,
    d(a) {
      a && B(t);
    }
  };
}
function Ar(e, t, n) {
  let o, s, i, { annotation: l } = t, { geom: r } = t, { style: a } = t;
  return e.$$set = (f) => {
    "annotation" in f && n(0, l = f.annotation), "geom" in f && n(4, r = f.geom), "style" in f && n(5, a = f.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    33 && n(3, o = je(l, a)), e.$$.dirty & /*geom*/
    16 && n(2, s = po(r)), e.$$.dirty & /*geom*/
    16 && n(1, i = r.closed ? "closed" : "open");
  }, [l, i, s, o, r, a];
}
class Mr extends ye {
  constructor(t) {
    super(), _e(this, t, Ar, vr, ae, { annotation: 0, geom: 4, style: 5 });
  }
}
function Sr(e) {
  let t, n, o, s, i, l;
  return {
    c() {
      t = C("g"), n = C("g"), o = C("rect"), i = C("rect"), c(o, "class", "a9s-outer"), c(o, "style", s = /*computedStyle*/
      e[6] ? "display:none;" : void 0), c(
        o,
        "x",
        /*x*/
        e[4]
      ), c(
        o,
        "y",
        /*y*/
        e[2]
      ), c(
        o,
        "width",
        /*w*/
        e[3]
      ), c(
        o,
        "height",
        /*h*/
        e[1]
      ), c(i, "class", "a9s-inner"), c(
        i,
        "style",
        /*computedStyle*/
        e[6]
      ), c(
        i,
        "x",
        /*x*/
        e[4]
      ), c(
        i,
        "y",
        /*y*/
        e[2]
      ), c(
        i,
        "width",
        /*w*/
        e[3]
      ), c(
        i,
        "height",
        /*h*/
        e[1]
      ), c(
        n,
        "transform",
        /*rectTransform*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", l = /*annotation*/
      e[0].id);
    },
    m(r, a) {
      Y(r, t, a), z(t, n), z(n, o), z(n, i);
    },
    p(r, [a]) {
      a & /*computedStyle*/
      64 && s !== (s = /*computedStyle*/
      r[6] ? "display:none;" : void 0) && c(o, "style", s), a & /*x*/
      16 && c(
        o,
        "x",
        /*x*/
        r[4]
      ), a & /*y*/
      4 && c(
        o,
        "y",
        /*y*/
        r[2]
      ), a & /*w*/
      8 && c(
        o,
        "width",
        /*w*/
        r[3]
      ), a & /*h*/
      2 && c(
        o,
        "height",
        /*h*/
        r[1]
      ), a & /*computedStyle*/
      64 && c(
        i,
        "style",
        /*computedStyle*/
        r[6]
      ), a & /*x*/
      16 && c(
        i,
        "x",
        /*x*/
        r[4]
      ), a & /*y*/
      4 && c(
        i,
        "y",
        /*y*/
        r[2]
      ), a & /*w*/
      8 && c(
        i,
        "width",
        /*w*/
        r[3]
      ), a & /*h*/
      2 && c(
        i,
        "height",
        /*h*/
        r[1]
      ), a & /*rectTransform*/
      32 && c(
        n,
        "transform",
        /*rectTransform*/
        r[5]
      ), a & /*annotation*/
      1 && l !== (l = /*annotation*/
      r[0].id) && c(t, "data-id", l);
    },
    i: $,
    o: $,
    d(r) {
      r && B(t);
    }
  };
}
function kr(e, t, n) {
  let o, s, i, l, r, a, f, { annotation: d } = t, { geom: u } = t, { style: h } = t;
  return e.$$set = (g) => {
    "annotation" in g && n(0, d = g.annotation), "geom" in g && n(7, u = g.geom), "style" in g && n(8, h = g.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    257 && n(6, o = je(d, h)), e.$$.dirty & /*geom*/
    128 && n(4, { x: s, y: i, w: l, h: r, rot: a } = u, s, (n(2, i), n(7, u)), (n(3, l), n(7, u)), (n(1, r), n(7, u)), (n(9, a), n(7, u))), e.$$.dirty & /*rot, x, w, y, h*/
    542 && n(5, f = (a ?? 0) !== 0 ? `translate(${s + l / 2}, ${i + r / 2}) rotate(${(a ?? 0) * 180 / Math.PI}) translate(${-(s + l / 2)}, ${-(i + r / 2)})` : void 0);
  }, [d, r, i, l, s, f, o, u, h, a];
}
class Pr extends ye {
  constructor(t) {
    super(), _e(this, t, kr, Sr, ae, { annotation: 0, geom: 7, style: 8 });
  }
}
const ul = {
  elementToImage: (e, t) => [e, t]
}, Tr = (e) => ({
  elementToImage: (t, n) => {
    const o = e.getBoundingClientRect(), s = e.createSVGPoint();
    s.x = t + o.x, s.y = n + o.y;
    const { x: i, y: l } = s.matrixTransform(e.getScreenCTM().inverse());
    return [i, l];
  }
}), Lr = 250, Cr = (e, t) => {
  const n = Ue();
  let o;
  return { onPointerDown: () => o = performance.now(), onPointerUp: (l) => {
    if (performance.now() - o < Lr) {
      const { x: a, y: f } = Co(l, e), d = Le ? 10 : 2, u = t.getAt(a, f, void 0, d);
      u ? n("click", { originalEvent: l, annotation: u }) : n("click", { originalEvent: l });
    }
  } };
}, Co = (e, t) => {
  const n = t.createSVGPoint(), o = t.getBoundingClientRect(), s = e.clientX - o.x, i = e.clientY - o.y, { left: l, top: r } = t.getBoundingClientRect();
  return n.x = s + l, n.y = i + r, n.matrixTransform(t.getScreenCTM().inverse());
};
function Fn(e, t, n) {
  const o = e.slice();
  return o[39] = t[n], o;
}
function zn(e, t, n) {
  const o = e.slice();
  return o[42] = t[n], o;
}
function Ft(e) {
  const t = e.slice(), n = (
    /*annotation*/
    t[42].target.selector
  );
  return t[45] = n, t;
}
function qn(e) {
  let t = (
    /*annotation*/
    e[42]
  ), n, o, s = Kn(e);
  return {
    c() {
      s.c(), n = Se();
    },
    m(i, l) {
      s.m(i, l), Y(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*$store*/
      131072 && ae(t, t = /*annotation*/
      i[42]) ? (be(), j(s, 1, 1, $), Ee(), s = Kn(i), s.c(), V(s, 1), s.m(n.parentNode, n)) : s.p(i, l);
    },
    i(i) {
      o || (V(s), o = !0);
    },
    o(i) {
      j(s), o = !1;
    },
    d(i) {
      i && B(n), s.d(i);
    }
  };
}
function Ir(e) {
  let t, n;
  return t = new hr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Or(e) {
  let t, n;
  return t = new Mr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Dr(e) {
  let t, n;
  return t = new pr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Nr(e) {
  let t, n;
  return t = new Er({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Rr(e) {
  let t, n;
  return t = new Pr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*$store*/
      131072 && (i.annotation = /*annotation*/
      o[42]), s[0] & /*$store*/
      131072 && (i.geom = /*selector*/
      o[45].geometry), s[0] & /*style*/
      2 && (i.style = /*style*/
      o[1]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Br(e) {
  var o;
  let t, n;
  return t = new fr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        (o = e[45]) == null ? void 0 : o.geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(s, i) {
      re(t, s, i), n = !0;
    },
    p(s, i) {
      var r;
      const l = {};
      i[0] & /*$store*/
      131072 && (l.annotation = /*annotation*/
      s[42]), i[0] & /*$store*/
      131072 && (l.geom = /*selector*/
      (r = s[45]) == null ? void 0 : r.geometry), i[0] & /*style*/
      2 && (l.style = /*style*/
      s[1]), t.$set(l);
    },
    i(s) {
      n || (V(t.$$.fragment, s), n = !0);
    },
    o(s) {
      j(t.$$.fragment, s), n = !1;
    },
    d(s) {
      le(t, s);
    }
  };
}
function Kn(e) {
  let t, n, o, s;
  const i = [
    Br,
    Rr,
    Nr,
    Dr,
    Or,
    Ir
  ], l = [];
  function r(a, f) {
    var d, u, h, g, m, w;
    return (
      /*selector*/
      ((d = a[45]) == null ? void 0 : d.type) === x.ELLIPSE ? 0 : (
        /*selector*/
        ((u = a[45]) == null ? void 0 : u.type) === x.RECTANGLE ? 1 : (
          /*selector*/
          ((h = a[45]) == null ? void 0 : h.type) === x.POLYGON ? 2 : (
            /*selector*/
            ((g = a[45]) == null ? void 0 : g.type) === x.MULTIPOLYGON ? 3 : (
              /*selector*/
              ((m = a[45]) == null ? void 0 : m.type) === x.POLYLINE ? 4 : (
                /*selector*/
                ((w = a[45]) == null ? void 0 : w.type) === x.LINE ? 5 : -1
              )
            )
          )
        )
      )
    );
  }
  return ~(t = r(e)) && (n = l[t] = i[t](e)), {
    c() {
      n && n.c(), o = Se();
    },
    m(a, f) {
      ~t && l[t].m(a, f), Y(a, o, f), s = !0;
    },
    p(a, f) {
      let d = t;
      t = r(a), t === d ? ~t && l[t].p(a, f) : (n && (be(), j(l[d], 1, 1, () => {
        l[d] = null;
      }), Ee()), ~t ? (n = l[t], n ? n.p(a, f) : (n = l[t] = i[t](a), n.c()), V(n, 1), n.m(o.parentNode, o)) : n = null);
    },
    i(a) {
      s || (V(n), s = !0);
    },
    o(a) {
      j(n), s = !1;
    },
    d(a) {
      a && B(o), ~t && l[t].d(a);
    }
  };
}
function Wn(e) {
  let t = Mt(
    /*annotation*/
    e[42]
  ) && !/*isEditable*/
  e[10](
    /*annotation*/
    e[42]
  ), n, o, s = t && qn(Ft(e));
  return {
    c() {
      s && s.c(), n = Se();
    },
    m(i, l) {
      s && s.m(i, l), Y(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*$store, isEditable*/
      132096 && (t = Mt(
        /*annotation*/
        i[42]
      ) && !/*isEditable*/
      i[10](
        /*annotation*/
        i[42]
      )), t ? s ? (s.p(Ft(i), l), l[0] & /*$store, isEditable*/
      132096 && V(s, 1)) : (s = qn(Ft(i)), s.c(), V(s, 1), s.m(n.parentNode, n)) : s && (be(), j(s, 1, 1, () => {
        s = null;
      }), Ee());
    },
    i(i) {
      o || (V(s), o = !0);
    },
    o(i) {
      j(s), o = !1;
    },
    d(i) {
      i && B(n), s && s.d(i);
    }
  };
}
function Zn(e) {
  let t, n, o, s;
  const i = [Ur, Yr], l = [];
  function r(a, f) {
    return (
      /*editors*/
      a[6] ? 0 : (
        /*tool*/
        a[15] && /*drawingEnabled*/
        a[0] ? 1 : -1
      )
    );
  }
  return ~(t = r(e)) && (n = l[t] = i[t](e)), {
    c() {
      n && n.c(), o = Se();
    },
    m(a, f) {
      ~t && l[t].m(a, f), Y(a, o, f), s = !0;
    },
    p(a, f) {
      let d = t;
      t = r(a), t === d ? ~t && l[t].p(a, f) : (n && (be(), j(l[d], 1, 1, () => {
        l[d] = null;
      }), Ee()), ~t ? (n = l[t], n ? n.p(a, f) : (n = l[t] = i[t](a), n.c()), V(n, 1), n.m(o.parentNode, o)) : n = null);
    },
    i(a) {
      s || (V(n), s = !0);
    },
    o(a) {
      j(n), s = !1;
    },
    d(a) {
      a && B(o), ~t && l[t].d(a);
    }
  };
}
function Yr(e) {
  let t = `${/*toolName*/
  e[2]}-${/*toolMountKey*/
  e[7]}`, n, o, s = Jn(e);
  return {
    c() {
      s.c(), n = Se();
    },
    m(i, l) {
      s.m(i, l), Y(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*toolName, toolMountKey*/
      132 && ae(t, t = `${/*toolName*/
      i[2]}-${/*toolMountKey*/
      i[7]}`) ? (be(), j(s, 1, 1, $), Ee(), s = Jn(i), s.c(), V(s, 1), s.m(n.parentNode, n)) : s.p(i, l);
    },
    i(i) {
      o || (V(s), o = !0);
    },
    o(i) {
      j(s), o = !1;
    },
    d(i) {
      i && B(n), s.d(i);
    }
  };
}
function Ur(e) {
  let t, n, o = ve(
    /*editors*/
    e[6]
  ), s = [];
  for (let l = 0; l < o.length; l += 1)
    s[l] = xn(Fn(e, o, l));
  const i = (l) => j(s[l], 1, 1, () => {
    s[l] = null;
  });
  return {
    c() {
      for (let l = 0; l < s.length; l += 1)
        s[l].c();
      t = Se();
    },
    m(l, r) {
      for (let a = 0; a < s.length; a += 1)
        s[a] && s[a].m(l, r);
      Y(l, t, r), n = !0;
    },
    p(l, r) {
      if (r[0] & /*editors, drawingEl, style, transform, $scale, onChangeSelected*/
      8659266) {
        o = ve(
          /*editors*/
          l[6]
        );
        let a;
        for (a = 0; a < o.length; a += 1) {
          const f = Fn(l, o, a);
          s[a] ? (s[a].p(f, r), V(s[a], 1)) : (s[a] = xn(f), s[a].c(), V(s[a], 1), s[a].m(t.parentNode, t));
        }
        for (be(), a = o.length; a < s.length; a += 1)
          i(a);
        Ee();
      }
    },
    i(l) {
      if (!n) {
        for (let r = 0; r < o.length; r += 1)
          V(s[r]);
        n = !0;
      }
    },
    o(l) {
      s = s.filter(Boolean);
      for (let r = 0; r < s.length; r += 1)
        j(s[r]);
      n = !1;
    },
    d(l) {
      l && B(t), Ge(s, l);
    }
  };
}
function Jn(e) {
  let t, n;
  return t = new xi({
    props: {
      target: (
        /*drawingEl*/
        e[8]
      ),
      tool: (
        /*tool*/
        e[15]
      ),
      drawingMode: (
        /*drawingMode*/
        e[14]
      ),
      transform: (
        /*transform*/
        e[13]
      ),
      viewportScale: (
        /*$scale*/
        e[18]
      )
    }
  }), t.$on(
    "create",
    /*onSelectionCreated*/
    e[22]
  ), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      const i = {};
      s[0] & /*drawingEl*/
      256 && (i.target = /*drawingEl*/
      o[8]), s[0] & /*tool*/
      32768 && (i.tool = /*tool*/
      o[15]), s[0] & /*drawingMode*/
      16384 && (i.drawingMode = /*drawingMode*/
      o[14]), s[0] & /*transform*/
      8192 && (i.transform = /*transform*/
      o[13]), s[0] & /*$scale*/
      262144 && (i.viewportScale = /*$scale*/
      o[18]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Qn(e) {
  let t, n;
  return t = new Ji({
    props: {
      target: (
        /*drawingEl*/
        e[8]
      ),
      editor: (
        /*editable*/
        e[39].editor
      ),
      annotation: (
        /*editable*/
        e[39].annotation
      ),
      style: (
        /*style*/
        e[1]
      ),
      transform: (
        /*transform*/
        e[13]
      ),
      viewportScale: (
        /*$scale*/
        e[18]
      )
    }
  }), t.$on("change", function() {
    se(
      /*onChangeSelected*/
      e[23](
        /*editable*/
        e[39].annotation
      )
    ) && e[23](
      /*editable*/
      e[39].annotation
    ).apply(this, arguments);
  }), {
    c() {
      ce(t.$$.fragment);
    },
    m(o, s) {
      re(t, o, s), n = !0;
    },
    p(o, s) {
      e = o;
      const i = {};
      s[0] & /*drawingEl*/
      256 && (i.target = /*drawingEl*/
      e[8]), s[0] & /*editors*/
      64 && (i.editor = /*editable*/
      e[39].editor), s[0] & /*editors*/
      64 && (i.annotation = /*editable*/
      e[39].annotation), s[0] & /*style*/
      2 && (i.style = /*style*/
      e[1]), s[0] & /*transform*/
      8192 && (i.transform = /*transform*/
      e[13]), s[0] & /*$scale*/
      262144 && (i.viewportScale = /*$scale*/
      e[18]), t.$set(i);
    },
    i(o) {
      n || (V(t.$$.fragment, o), n = !0);
    },
    o(o) {
      j(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function xn(e) {
  let t = (
    /*editable*/
    e[39].annotation.id
  ), n, o, s = Qn(e);
  return {
    c() {
      s.c(), n = Se();
    },
    m(i, l) {
      s.m(i, l), Y(i, n, l), o = !0;
    },
    p(i, l) {
      l[0] & /*editors*/
      64 && ae(t, t = /*editable*/
      i[39].annotation.id) ? (be(), j(s, 1, 1, $), Ee(), s = Qn(i), s.c(), V(s, 1), s.m(n.parentNode, n)) : s.p(i, l);
    },
    i(i) {
      o || (V(s), o = !0);
    },
    o(i) {
      j(s), o = !1;
    },
    d(i) {
      i && B(n), s.d(i);
    }
  };
}
function Vr(e) {
  let t, n, o, s, i, l, r = ve(
    /*$store*/
    e[17].filter(
      /*func*/
      e[34]
    )
  ), a = [];
  for (let u = 0; u < r.length; u += 1)
    a[u] = Wn(zn(e, r, u));
  const f = (u) => j(a[u], 1, 1, () => {
    a[u] = null;
  });
  let d = (
    /*drawingEl*/
    e[8] && Zn(e)
  );
  return {
    c() {
      t = C("svg"), n = C("g");
      for (let u = 0; u < a.length; u += 1)
        a[u].c();
      o = C("g"), d && d.c(), c(o, "class", "drawing"), c(t, "role", "application"), c(t, "tabindex", 0), c(t, "class", "a9s-annotationlayer"), Pe(
        t,
        "drawing",
        /*tool*/
        e[15]
      ), Pe(
        t,
        "editing",
        /*editableAnnotations*/
        e[5]
      ), Pe(t, "hidden", !/*visible*/
      e[3]), Pe(
        t,
        "hover",
        /*$hover*/
        e[16]
      );
    },
    m(u, h) {
      Y(u, t, h), z(t, n);
      for (let g = 0; g < a.length; g += 1)
        a[g] && a[g].m(n, null);
      z(t, o), d && d.m(o, null), e[35](o), e[36](t), s = !0, i || (l = [
        Q(t, "pointerup", function() {
          se(
            /*onPointerUp*/
            e[11]
          ) && e[11].apply(this, arguments);
        }),
        Q(t, "pointerdown", function() {
          se(
            /*onPointerDown*/
            e[12]
          ) && e[12].apply(this, arguments);
        }),
        Q(
          t,
          "pointermove",
          /*onPointerMove*/
          e[24]
        )
      ], i = !0);
    },
    p(u, h) {
      if (e = u, h[0] & /*$store, style, isEditable*/
      132098) {
        r = ve(
          /*$store*/
          e[17].filter(
            /*func*/
            e[34]
          )
        );
        let g;
        for (g = 0; g < r.length; g += 1) {
          const m = zn(e, r, g);
          a[g] ? (a[g].p(m, h), V(a[g], 1)) : (a[g] = Wn(m), a[g].c(), V(a[g], 1), a[g].m(n, null));
        }
        for (be(), g = r.length; g < a.length; g += 1)
          f(g);
        Ee();
      }
      /*drawingEl*/
      e[8] ? d ? (d.p(e, h), h[0] & /*drawingEl*/
      256 && V(d, 1)) : (d = Zn(e), d.c(), V(d, 1), d.m(o, null)) : d && (be(), j(d, 1, 1, () => {
        d = null;
      }), Ee()), (!s || h[0] & /*tool*/
      32768) && Pe(
        t,
        "drawing",
        /*tool*/
        e[15]
      ), (!s || h[0] & /*editableAnnotations*/
      32) && Pe(
        t,
        "editing",
        /*editableAnnotations*/
        e[5]
      ), (!s || h[0] & /*visible*/
      8) && Pe(t, "hidden", !/*visible*/
      e[3]), (!s || h[0] & /*$hover*/
      65536) && Pe(
        t,
        "hover",
        /*$hover*/
        e[16]
      );
    },
    i(u) {
      if (!s) {
        for (let h = 0; h < r.length; h += 1)
          V(a[h]);
        V(d), s = !0;
      }
    },
    o(u) {
      a = a.filter(Boolean);
      for (let h = 0; h < a.length; h += 1)
        j(a[h]);
      j(d), s = !1;
    },
    d(u) {
      u && B(t), Ge(a, u), d && d.d(), e[35](null), e[36](null), i = !1, Me(l);
    }
  };
}
function Xr(e, t, n) {
  let o, s, i, l, r, a, f, d, u, h, g, m, w = $, A = () => (w(), w = oo(_, (X) => n(18, m = X)), _);
  e.$$.on_destroy.push(() => w());
  let { drawingEnabled: y } = t, { image: v } = t, { preferredDrawingMode: p } = t, { state: k } = t, { style: T = void 0 } = t, { toolName: P = To()[0] } = t, { user: L } = t, { visible: N = !0 } = t, I = 0;
  const q = () => n(7, I += 1), H = () => P, G = () => y;
  let O, M, _;
  Ye(() => A(n(9, _ = di(v, M))));
  const { hover: b, selection: E, store: S } = k;
  Ot(e, b, (X) => n(16, u = X)), Ot(e, E, (X) => n(33, h = X)), Ot(e, S, (X) => n(17, g = X));
  let U, D;
  const K = (X) => {
    U && S.unobserve(U);
    const fe = X.filter(({ editable: te }) => te).map(({ id: te }) => te);
    fe.length > 0 ? (n(5, D = fe.map((te) => S.getAnnotation(te)).filter((te) => te && Mt(te))), U = (te) => {
      const { updated: ge } = te.changes;
      n(5, D = ge == null ? void 0 : ge.map((ie) => ie.newValue));
    }, S.observe(U, { annotations: fe })) : n(5, D = void 0);
  }, F = (X) => {
    const fe = bo(), te = {
      id: fe,
      bodies: [],
      target: {
        annotation: fe,
        selector: X.detail,
        creator: L,
        created: /* @__PURE__ */ new Date()
      }
    };
    S.addAnnotation(te), E.setSelected(te.id);
  }, Z = (X) => (fe) => {
    var Ve;
    const { target: te } = X, ge = 10 * 60 * 1e3, ie = ((Ve = te.creator) == null ? void 0 : Ve.id) !== L.id || !te.created || (/* @__PURE__ */ new Date()).getTime() - te.created.getTime() > ge;
    S.updateTarget({
      ...te,
      selector: fe.detail,
      created: ie ? te.created : /* @__PURE__ */ new Date(),
      updated: ie ? /* @__PURE__ */ new Date() : void 0,
      updatedBy: ie ? L : void 0
    });
  }, ee = (X) => {
    const { x: fe, y: te } = Co(X, M), ge = S.getAt(fe, te, void 0, 2);
    ge ? u !== ge.id && b.set(ge.id) : b.set(void 0);
  }, he = (X) => Mt(X);
  function oe(X) {
    Et[X ? "unshift" : "push"](() => {
      O = X, n(8, O);
    });
  }
  function Ae(X) {
    Et[X ? "unshift" : "push"](() => {
      M = X, n(4, M);
    });
  }
  return e.$$set = (X) => {
    "drawingEnabled" in X && n(0, y = X.drawingEnabled), "image" in X && n(25, v = X.image), "preferredDrawingMode" in X && n(26, p = X.preferredDrawingMode), "state" in X && n(27, k = X.state), "style" in X && n(1, T = X.style), "toolName" in X && n(2, P = X.toolName), "user" in X && n(28, L = X.user), "visible" in X && n(3, N = X.visible);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*toolName*/
    4 && n(15, { tool: o, opts: s } = Lo(P) || { tool: void 0, opts: void 0 }, o, (n(32, s), n(2, P))), e.$$.dirty[0] & /*preferredDrawingMode*/
    67108864 | e.$$.dirty[1] & /*opts*/
    2 && n(14, i = (s == null ? void 0 : s.drawingMode) || p), e.$$.dirty[0] & /*svgEl*/
    16 && n(13, l = Tr(M)), e.$$.dirty[0] & /*svgEl*/
    16 && n(12, { onPointerDown: r, onPointerUp: a } = Cr(M, S), r, (n(11, a), n(4, M))), e.$$.dirty[1] & /*$selection*/
    4 && K(h.selected), e.$$.dirty[0] & /*editableAnnotations*/
    32 && n(6, f = D ? D.map((X) => ({
      annotation: X,
      editor: Ki(X.target.selector)
    })).filter((X) => X.editor) : void 0), e.$$.dirty[0] & /*editors*/
    64 && n(10, d = (X) => f && f.some((fe) => fe.annotation.id === X.id));
  }, [
    y,
    T,
    P,
    N,
    M,
    D,
    f,
    I,
    O,
    _,
    d,
    a,
    r,
    l,
    i,
    o,
    u,
    g,
    m,
    b,
    E,
    S,
    F,
    Z,
    ee,
    v,
    p,
    k,
    L,
    q,
    H,
    G,
    s,
    h,
    he,
    oe,
    Ae
  ];
}
class Hr extends ye {
  constructor(t) {
    super(), _e(
      this,
      t,
      Xr,
      Vr,
      ae,
      {
        drawingEnabled: 0,
        image: 25,
        preferredDrawingMode: 26,
        state: 27,
        style: 1,
        toolName: 2,
        user: 28,
        visible: 3,
        cancelDrawing: 29,
        getDrawingTool: 30,
        isDrawingEnabled: 31
      },
      null,
      [-1, -1]
    );
  }
  get cancelDrawing() {
    return this.$$.ctx[29];
  }
  get getDrawingTool() {
    return this.$$.ctx[30];
  }
  get isDrawingEnabled() {
    return this.$$.ctx[31];
  }
}
function Io(e, t, n = 0, o = e.length - 1, s = Gr) {
  for (; o > n; ) {
    if (o - n > 600) {
      const a = o - n + 1, f = t - n + 1, d = Math.log(a), u = 0.5 * Math.exp(2 * d / 3), h = 0.5 * Math.sqrt(d * u * (a - u) / a) * (f - a / 2 < 0 ? -1 : 1), g = Math.max(n, Math.floor(t - f * u / a + h)), m = Math.min(o, Math.floor(t + (a - f) * u / a + h));
      Io(e, t, g, m, s);
    }
    const i = e[t];
    let l = n, r = o;
    for (xe(e, n, t), s(e[o], i) > 0 && xe(e, n, o); l < r; ) {
      for (xe(e, l, r), l++, r--; s(e[l], i) < 0; ) l++;
      for (; s(e[r], i) > 0; ) r--;
    }
    s(e[n], i) === 0 ? xe(e, n, r) : (r++, xe(e, r, o)), r <= t && (n = r + 1), t <= r && (o = r - 1);
  }
}
function xe(e, t, n) {
  const o = e[t];
  e[t] = e[n], e[n] = o;
}
function Gr(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
class jr {
  constructor(t = 9) {
    this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(t) {
    let n = this.data;
    const o = [];
    if (!mt(t, n)) return o;
    const s = this.toBBox, i = [];
    for (; n; ) {
      for (let l = 0; l < n.children.length; l++) {
        const r = n.children[l], a = n.leaf ? s(r) : r;
        mt(t, a) && (n.leaf ? o.push(r) : qt(t, a) ? this._all(r, o) : i.push(r));
      }
      n = i.pop();
    }
    return o;
  }
  collides(t) {
    let n = this.data;
    if (!mt(t, n)) return !1;
    const o = [];
    for (; n; ) {
      for (let s = 0; s < n.children.length; s++) {
        const i = n.children[s], l = n.leaf ? this.toBBox(i) : i;
        if (mt(t, l)) {
          if (n.leaf || qt(t, l)) return !0;
          o.push(i);
        }
      }
      n = o.pop();
    }
    return !1;
  }
  load(t) {
    if (!(t && t.length)) return this;
    if (t.length < this._minEntries) {
      for (let o = 0; o < t.length; o++)
        this.insert(t[o]);
      return this;
    }
    let n = this._build(t.slice(), 0, t.length - 1, 0);
    if (!this.data.children.length)
      this.data = n;
    else if (this.data.height === n.height)
      this._splitRoot(this.data, n);
    else {
      if (this.data.height < n.height) {
        const o = this.data;
        this.data = n, n = o;
      }
      this._insert(n, this.data.height - n.height - 1, !0);
    }
    return this;
  }
  insert(t) {
    return t && this._insert(t, this.data.height - 1), this;
  }
  clear() {
    return this.data = We([]), this;
  }
  remove(t, n) {
    if (!t) return this;
    let o = this.data;
    const s = this.toBBox(t), i = [], l = [];
    let r, a, f;
    for (; o || i.length; ) {
      if (o || (o = i.pop(), a = i[i.length - 1], r = l.pop(), f = !0), o.leaf) {
        const d = Fr(t, o.children, n);
        if (d !== -1)
          return o.children.splice(d, 1), i.push(o), this._condense(i), this;
      }
      !f && !o.leaf && qt(o, s) ? (i.push(o), l.push(r), r = 0, a = o, o = o.children[0]) : a ? (r++, o = a.children[r], f = !1) : o = null;
    }
    return this;
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, n) {
    return t.minX - n.minX;
  }
  compareMinY(t, n) {
    return t.minY - n.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(t) {
    return this.data = t, this;
  }
  _all(t, n) {
    const o = [];
    for (; t; )
      t.leaf ? n.push(...t.children) : o.push(...t.children), t = o.pop();
    return n;
  }
  _build(t, n, o, s) {
    const i = o - n + 1;
    let l = this._maxEntries, r;
    if (i <= l)
      return r = We(t.slice(n, o + 1)), qe(r, this.toBBox), r;
    s || (s = Math.ceil(Math.log(i) / Math.log(l)), l = Math.ceil(i / Math.pow(l, s - 1))), r = We([]), r.leaf = !1, r.height = s;
    const a = Math.ceil(i / l), f = a * Math.ceil(Math.sqrt(l));
    $n(t, n, o, f, this.compareMinX);
    for (let d = n; d <= o; d += f) {
      const u = Math.min(d + f - 1, o);
      $n(t, d, u, a, this.compareMinY);
      for (let h = d; h <= u; h += a) {
        const g = Math.min(h + a - 1, u);
        r.children.push(this._build(t, h, g, s - 1));
      }
    }
    return qe(r, this.toBBox), r;
  }
  _chooseSubtree(t, n, o, s) {
    for (; s.push(n), !(n.leaf || s.length - 1 === o); ) {
      let i = 1 / 0, l = 1 / 0, r;
      for (let a = 0; a < n.children.length; a++) {
        const f = n.children[a], d = zt(f), u = Kr(t, f) - d;
        u < l ? (l = u, i = d < i ? d : i, r = f) : u === l && d < i && (i = d, r = f);
      }
      n = r || n.children[0];
    }
    return n;
  }
  _insert(t, n, o) {
    const s = o ? t : this.toBBox(t), i = [], l = this._chooseSubtree(s, this.data, n, i);
    for (l.children.push(t), et(l, s); n >= 0 && i[n].children.length > this._maxEntries; )
      this._split(i, n), n--;
    this._adjustParentBBoxes(s, i, n);
  }
  // split overflowed node into two
  _split(t, n) {
    const o = t[n], s = o.children.length, i = this._minEntries;
    this._chooseSplitAxis(o, i, s);
    const l = this._chooseSplitIndex(o, i, s), r = We(o.children.splice(l, o.children.length - l));
    r.height = o.height, r.leaf = o.leaf, qe(o, this.toBBox), qe(r, this.toBBox), n ? t[n - 1].children.push(r) : this._splitRoot(o, r);
  }
  _splitRoot(t, n) {
    this.data = We([t, n]), this.data.height = t.height + 1, this.data.leaf = !1, qe(this.data, this.toBBox);
  }
  _chooseSplitIndex(t, n, o) {
    let s, i = 1 / 0, l = 1 / 0;
    for (let r = n; r <= o - n; r++) {
      const a = $e(t, 0, r, this.toBBox), f = $e(t, r, o, this.toBBox), d = Wr(a, f), u = zt(a) + zt(f);
      d < i ? (i = d, s = r, l = u < l ? u : l) : d === i && u < l && (l = u, s = r);
    }
    return s || o - n;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(t, n, o) {
    const s = t.leaf ? this.compareMinX : zr, i = t.leaf ? this.compareMinY : qr, l = this._allDistMargin(t, n, o, s), r = this._allDistMargin(t, n, o, i);
    l < r && t.children.sort(s);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(t, n, o, s) {
    t.children.sort(s);
    const i = this.toBBox, l = $e(t, 0, n, i), r = $e(t, o - n, o, i);
    let a = gt(l) + gt(r);
    for (let f = n; f < o - n; f++) {
      const d = t.children[f];
      et(l, t.leaf ? i(d) : d), a += gt(l);
    }
    for (let f = o - n - 1; f >= n; f--) {
      const d = t.children[f];
      et(r, t.leaf ? i(d) : d), a += gt(r);
    }
    return a;
  }
  _adjustParentBBoxes(t, n, o) {
    for (let s = o; s >= 0; s--)
      et(n[s], t);
  }
  _condense(t) {
    for (let n = t.length - 1, o; n >= 0; n--)
      t[n].children.length === 0 ? n > 0 ? (o = t[n - 1].children, o.splice(o.indexOf(t[n]), 1)) : this.clear() : qe(t[n], this.toBBox);
  }
}
function Fr(e, t, n) {
  if (!n) return t.indexOf(e);
  for (let o = 0; o < t.length; o++)
    if (n(e, t[o])) return o;
  return -1;
}
function qe(e, t) {
  $e(e, 0, e.children.length, t, e);
}
function $e(e, t, n, o, s) {
  s || (s = We(null)), s.minX = 1 / 0, s.minY = 1 / 0, s.maxX = -1 / 0, s.maxY = -1 / 0;
  for (let i = t; i < n; i++) {
    const l = e.children[i];
    et(s, e.leaf ? o(l) : l);
  }
  return s;
}
function et(e, t) {
  return e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), e;
}
function zr(e, t) {
  return e.minX - t.minX;
}
function qr(e, t) {
  return e.minY - t.minY;
}
function zt(e) {
  return (e.maxX - e.minX) * (e.maxY - e.minY);
}
function gt(e) {
  return e.maxX - e.minX + (e.maxY - e.minY);
}
function Kr(e, t) {
  return (Math.max(t.maxX, e.maxX) - Math.min(t.minX, e.minX)) * (Math.max(t.maxY, e.maxY) - Math.min(t.minY, e.minY));
}
function Wr(e, t) {
  const n = Math.max(e.minX, t.minX), o = Math.max(e.minY, t.minY), s = Math.min(e.maxX, t.maxX), i = Math.min(e.maxY, t.maxY);
  return Math.max(0, s - n) * Math.max(0, i - o);
}
function qt(e, t) {
  return e.minX <= t.minX && e.minY <= t.minY && t.maxX <= e.maxX && t.maxY <= e.maxY;
}
function mt(e, t) {
  return t.minX <= e.maxX && t.minY <= e.maxY && t.maxX >= e.minX && t.maxY >= e.minY;
}
function We(e) {
  return {
    children: e,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function $n(e, t, n, o, s) {
  const i = [t, n];
  for (; i.length; ) {
    if (n = i.pop(), t = i.pop(), n - t <= o) continue;
    const l = t + Math.ceil((n - t) / o / 2) * o;
    Io(e, l, t, n, s), i.push(t, l, l, n);
  }
}
const Zr = () => {
  const e = new jr(), t = /* @__PURE__ */ new Map(), n = () => [...t.values()], o = () => {
    e.clear(), t.clear();
  }, s = (u) => {
    if (!wt(u)) return;
    const { minX: h, minY: g, maxX: m, maxY: w } = u.selector.geometry.bounds, A = { minX: h, minY: g, maxX: m, maxY: w, target: u };
    e.insert(A), t.set(u.annotation, A);
  }, i = (u) => {
    if (!wt(u)) return;
    const h = t.get(u.annotation);
    h && e.remove(h), t.delete(u.annotation);
  };
  return {
    all: n,
    clear: o,
    getAt: (u, h, g = 0) => {
      const w = e.search({
        minX: u - g,
        minY: h - g,
        maxX: u + g,
        maxY: h + g
      }).map((A) => A.target).filter(({ selector: A }) => Wo(A, u, h, g));
      return w.length > 0 ? (w.sort((A, y) => Jt(A.selector) - Jt(y.selector)), w) : [];
    },
    getIntersecting: (u, h, g, m) => e.search({
      minX: u,
      minY: h,
      maxX: u + g,
      maxY: h + m
    }).map((w) => w.target),
    insert: s,
    remove: i,
    set: (u, h = !0) => {
      h && o();
      const g = u.reduce((m, w) => {
        if (wt(w)) {
          const { minX: A, minY: y, maxX: v, maxY: p } = w.selector.geometry.bounds;
          return [...m, { minX: A, minY: y, maxX: v, maxY: p, target: w }];
        } else
          return m;
      }, []);
      g.forEach((m) => t.set(m.target.annotation, m)), e.load(g);
    },
    size: () => e.all().length,
    update: (u, h) => {
      i(u), s(h);
    }
  };
}, Jr = (e) => ({
  ...e,
  subscribe: (n) => {
    const o = (s) => n(s.state);
    return e.observe(o), n(e.all()), () => e.unobserve(o);
  }
}), Qr = (e) => {
  const t = js(), n = Zr(), o = Cs(t, e.userSelectAction, e.adapter), s = Ls(t), i = Ks();
  return t.observe(({ changes: a }) => {
    n.set((a.created || []).map((f) => f.target), !1), (a.deleted || []).forEach((f) => n.remove(f.target)), (a.updated || []).forEach(({ oldValue: f, newValue: d }) => n.update(f.target, d.target));
  }), {
    store: {
      ...t,
      getAt: (a, f, d, u) => {
        const h = n.getAt(a, f, u);
        if (d)
          return h.map((m) => t.getAnnotation(m.annotation)).filter(Boolean).filter(d)[0];
        {
          const g = h[0];
          return g ? t.getAnnotation(g.annotation) : void 0;
        }
      },
      getIntersecting: (a, f, d, u) => n.getIntersecting(a, f, d, u).map((h) => t.getAnnotation(h.annotation)).filter(Boolean)
    },
    selection: o,
    hover: s,
    viewport: i
  };
}, xr = (e) => {
  const t = Qr(e);
  return {
    ...t,
    store: Jr(t.store)
  };
}, $r = (e) => {
  let t, n;
  if (e.nodeName === "CANVAS")
    t = e, n = t.getContext("2d", { willReadFrequently: !0 });
  else {
    const s = e;
    t = document.createElement("canvas"), t.width = s.width, t.height = s.height, n = t.getContext("2d", { willReadFrequently: !0 }), n.drawImage(s, 0, 0, s.width, s.height);
  }
  let o = 0;
  for (let s = 1; s < 10; s++)
    for (let i = 1; i < 10; i++) {
      const l = Math.round(i * t.width / 10), r = Math.round(s * t.height / 10), a = n.getImageData(l, r, 1, 1).data, f = (0.299 * a[0] + 0.587 * a[1] + 0.114 * a[2]) / 255;
      o += f;
    }
  return o / 81;
}, el = (e) => {
  const t = $r(e), n = t > 0.6 ? "dark" : "light";
  return console.log(`[Annotorious] Image brightness: ${t.toFixed(1)}. Setting ${n} theme.`), n;
}, eo = (e, t, n) => t.setAttribute("data-theme", n === "auto" ? el(e) : n), tl = (e, t) => ({
  ...e,
  drawingEnabled: e.drawingEnabled === void 0 ? t.drawingEnabled : e.drawingEnabled,
  drawingMode: e.drawingMode || t.drawingMode,
  userSelectAction: e.userSelectAction || t.userSelectAction,
  theme: e.theme || t.theme
}), to = typeof navigator > "u" ? !1 : navigator.userAgent.indexOf("Mac OS X") !== -1, nl = (e, t) => {
  const n = t || document, o = (l) => {
    const r = l;
    r.key === "z" && r.ctrlKey ? e.undo() : r.key === "y" && r.ctrlKey && e.redo();
  }, s = (l) => {
    const r = l;
    r.key === "z" && r.metaKey && (r.shiftKey ? e.redo() : e.undo());
  }, i = () => {
    to ? n.removeEventListener("keydown", s) : n.removeEventListener("keydown", o);
  };
  return to ? n.addEventListener("keydown", s) : n.addEventListener("keydown", o), {
    destroy: i
  };
}, dl = (e, t = {}) => {
  if (!e)
    throw "Missing argument: image";
  const n = typeof e == "string" ? document.getElementById(e) : e, o = tl(t, {
    drawingEnabled: !0,
    drawingMode: "drag",
    userSelectAction: Eo.EDIT,
    theme: "light"
  }), s = xr(o), { selection: i, store: l } = s, r = qs(l, o.initialHistory), a = Ws(
    s,
    r,
    o.adapter,
    o.autoSave
  ), f = document.createElement("DIV");
  f.style.position = "relative", f.style.display = "inline-block", n.style.display = "block", n.parentNode.insertBefore(f, n), f.appendChild(n);
  const d = nl(r);
  let u = ni();
  eo(n, f, o.theme);
  const h = new Hr({
    target: f,
    props: {
      drawingEnabled: !!o.drawingEnabled,
      image: n,
      preferredDrawingMode: o.drawingMode,
      state: s,
      style: o.style,
      user: u
    }
  });
  h.$on("click", (O) => {
    const { originalEvent: M, annotation: _ } = O.detail;
    _ ? i.userSelect(_.id, M) : i.isEmpty() || i.clear();
  });
  const g = Js(s, r, o.adapter), m = () => h.cancelDrawing(), w = () => {
    h.$destroy(), f.parentNode.insertBefore(n, f), f.parentNode.removeChild(f), d.destroy(), r.destroy();
  }, A = () => h.getDrawingTool(), y = () => u, v = () => h.isDrawingEnabled(), p = (O, M, _) => lr(O, M, _), k = (O, M) => Wi(O, M), T = (O) => {
    if (!Lo(O))
      throw `No drawing tool named ${O}`;
    h.$set({ toolName: O });
  }, P = (O) => h.$set({ drawingEnabled: O }), L = (O) => h.$set({ preferredDrawingMode: O }), N = (O) => {
    console.warn("Filter not implemented yet");
  }, I = (O) => h.$set({ style: O }), q = (O) => eo(n, f, O), H = (O) => {
    u = O, h.$set({ user: O });
  }, G = (O) => (
    // @ts-ignore
    h.$set({ visible: O })
  );
  return {
    ...g,
    cancelDrawing: m,
    destroy: w,
    getDrawingTool: A,
    getUser: y,
    isDrawingEnabled: v,
    listDrawingTools: To,
    on: a.on,
    off: a.off,
    registerDrawingTool: p,
    registerShapeEditor: k,
    setDrawingEnabled: P,
    setDrawingMode: L,
    setDrawingTool: T,
    setFilter: N,
    setStyle: I,
    setTheme: q,
    setUser: H,
    setVisible: G,
    element: f,
    state: s
  };
};
export {
  on as Editor,
  Ji as EditorMount,
  Xe as Handle,
  ul as IdentityTransform,
  So as MidpointHandle,
  Ci as PolygonEditor,
  Ui as RectangleEditor,
  ns as RectangleUtil,
  tr as RubberbandRectangle,
  Hr as SVGAnnotationLayer,
  x as ShapeType,
  xi as ToolMount,
  Eo as UserSelectAction,
  fl as W3CImageFormat,
  Cr as addEventListeners,
  Qt as approximateAsPolygon,
  yt as boundsFromMultiPolygonElements,
  ue as boundsFromPoints,
  al as chainStyles,
  Jt as computeArea,
  vt as computePolygonArea,
  po as computeSVGPath,
  ll as computeStyle,
  rl as createBody,
  dl as createImageAnnotator,
  Qr as createImageAnnotatorState,
  Tr as createSVGTransform,
  xr as createSvelteImageAnnotatorState,
  cl as defaultColorProvider,
  el as detectTheme,
  _t as distance,
  di as enableResponsive,
  tl as fillDefaults,
  xo as getAllCorners,
  Ki as getEditor,
  St as getMaskDimensions,
  Co as getSVGPoint,
  Lo as getTool,
  nl as initKeyboardCommands,
  Wo as intersects,
  tn as isFragmentSelector,
  Mt as isImageAnnotation,
  wt as isImageAnnotationTarget,
  to as isMac,
  At as isPointInPolygon,
  Le as isTouch,
  To as listDrawingTools,
  Te as multipolygonElementToPath,
  os as parseFragmentSelector,
  ys as parseSVGSelector,
  ai as parseW3CImageAnnotation,
  ho as pointsToPath,
  Wi as registerEditor,
  Qe as registerShapeUtil,
  lr as registerTool,
  $r as sampleBrightness,
  ss as serializeFragmentSelector,
  Es as serializeSVGSelector,
  ci as serializeW3CImageAnnotation,
  eo as setTheme,
  sl as simplifyMultiPolygon,
  go as simplifyPoints,
  il as simplifyPolygon,
  Jr as toSvelteStore
};
//# sourceMappingURL=annotorious.es.js.map
